// 6 - april - 2021
// function start(){
if(!window.is_hulk_load_js) {
    window.is_hulk_load_js = true
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
        window.hulkapps_shopify_rate = window.Shopify.currency.rate;
    } else {
        window.hulkapps_shopify_rate = 1; // Fallback to default rate
    }
    window.userModifiedGroups = {};
    var checkout_selectors = "input[name='checkout']:not(.hulkapps-ignore), input[value='Checkout']:not(.hulkapps-ignore), button[name='checkout']:not(.hulkapps-ignore), [href$='checkout']:not(.hulkapps-ignore), button[value='Checkout']:not(.hulkapps-ignore), input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'],.hulkapps_checkout"
    if (window.hulkapps.page_type == "product") {
        var hulk_variants = window.hulkapps.product.variants;
        window.hulkapps.product.selected_variant = null;
        var product_price = ''
        var compare_product_price = ''

        var currency_symbol = ''
        var display_price_setting = ''
        window.product_page_btn_condition = function () {
            var options = [];
            var selector_var = document.querySelectorAll(".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio:checked, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio']:checked, variant-picker select");
            selector_var.forEach(function (selector) {
                options.push(selector.value)
            });
            var grep = function (items, callback) {
                var filtered = [],
                    len = items.length,
                    i = 0;
                for (i; i < len; i++) {
                    var item = items[i];
                    var cond = callback(item);
                    if (cond) {
                        filtered.push(item);
                    }
                }
                return filtered;
            };
            options = grep(options, function (n) {
                return (n);
            });
            if (options.length == 1) {
                var selected_variant_title = options;
            } else {
                var selected_variant_title = options.join(' / ');
            }
            var flag = 0;

            // Fluid Theme for getting Variant ID Start
            if (document.querySelector('.selected_variant span') != null) {
                var variantId = document.querySelector('.selected_variant span').textContent;
            } else {
                // Fluid Theme for getting Variant ID End
                Object.keys(hulk_variants).forEach(function (key) {
                    var val = hulk_variants[key];
                    selected_variant_title = selected_variant_title.toString().toLowerCase();
                    var variantTitle = val.title.toString().toLowerCase();
                    if (variantTitle.trim() == selected_variant_title.trim()) {
                        // if(selected_variant_title.includes(variantTitle)){
                        var variantId = val.id;
                        window.hulkapps.product.selected_variant = val.id
                        product_price = val.price
                        compare_product_price = val.compare_at_price
                        window.hulkapps.product.selected_variant_price = product_price
                        window.hulkapps.product.selected_variant_compare_price = compare_product_price
                    }
                    if(document.querySelector('script[type="application/json"][data-variant]')){
                        updateSelectedVariant();
                    }
                });

            }
            if (window.hulkapps.product.selected_variant == null) {
                window.hulkapps.product.selected_variant = hulk_variants[0].id
                product_price = window.hulkapps.product.variants[0].price
                compare_product_price = window.hulkapps.product.variants[0].compare_at_price
                window.hulkapps.product.selected_variant_price = product_price
                window.hulkapps.product.selected_variant_compare_price = compare_product_price
            }
        }

        function updateSelectedVariant(){
            var scriptElement = document.querySelector('script[type="application/json"][data-variant]');
            var parsedData = scriptElement.textContent && JSON.parse(scriptElement.textContent);
            window.hulkapps.product.selected_variant = parsedData["id"]
            product_price = parsedData["price"]
            compare_product_price = parsedData["compare_at_price"]
            window.hulkapps.product.selected_variant_price = parsedData["price"]
            window.hulkapps.product.selected_variant_compare_price = compare_product_price
            hulkapps_jQuery('#hulkapps_options_' + window.hulkapps.product_id).closest("form").find(':submit').addClass('hulkapps_submit_cart');
            if(window.$first_add_to_cart_el){
                window.$first_add_to_cart_el.removeClass('hulkapps_submit_cart').addClass('hulkapps_submit_cart');
            }
        }
    }
    window.hulkLoadScript = function (url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    window.hulkLoadStyle = function (url) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        document.head.appendChild(link);
    };


    window.checkAppInstalled = function (version) {
        window.hulkapps.is_product_option = true
        hulkLoadScript('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.5/js/intlTelInput.min.js', function () {
            commonJS(version);
            cartPageJS(version);
            productPageJS(version);
        });
    };

    window.commonJS = function ($) {
        window.getCartInfo();
        window.fetch = new Proxy(window.fetch, {
            apply(fetch, that, args) {
                // Forward function call to the original fetch
                const hulkapps_fetch_result = fetch.apply(that, args);
                hulkapps_fetch_result.then((response) => {
                    var endpoint = window.hulkappsParseURL(args[0]);
                    var isMatched = false;
                    var cart_endpoints = ["/cart/change", "/cart/clear", "/cart/update", "/cart/add"]
                    cart_endpoints.forEach(async function (endpoint) {
                        if (args[0] && args[0].includes(endpoint)) {
                            isMatched = true;
                            window.is_on_click = false;
                            var cart = await response.clone().json();
                            if (args[0].includes("/cart/add")) {
                                cart = undefined
                            }
                            window.getCartInfo(0, cart);
                        }
                    });
                    if (!isMatched && endpoint && endpoint.query) {
                        if (endpoint.query.get('section_id') && endpoint.query.get('section_id').includes('cart')) {
                            isMatched = true;
                            window.getCartInfo();
                        }else if (endpoint.query.get('ref') && endpoint.path.includes('/cart') ) {
                            return;
                        } else if ( endpoint.query.get('view') && endpoint.query.get('view').includes('hulkapps_cart_collections')) {
                            return;
                        } else if (endpoint.query.get('view') && endpoint.path.includes('/cart') && !endpoint.path.includes('/cart.js')) {
                            isMatched = true;
                            window.getCartInfo();
                        }
                    }

                    if (!isMatched) {
                        if (endpoint && endpoint.path === '/cart') {
                            window.getCartInfo();
                        }
                    }
                }).catch((error) => {
                });
                return hulkapps_fetch_result;

            }
        });

        function hulkappsXMLRequestCallback(callback) {
            var oldSend, i;
            if (XMLHttpRequest.callbacks) {
                XMLHttpRequest.callbacks.push(callback);
            } else {
                XMLHttpRequest.callbacks = [callback];
                oldSend = XMLHttpRequest.prototype.send;
                XMLHttpRequest.prototype.send = function () {
                    if (XMLHttpRequest.callbacks) {
                        for (i = 0; i < XMLHttpRequest.callbacks.length; i++) {
                            XMLHttpRequest.callbacks[i](this);
                        }
                    }
                    oldSend.apply(this, arguments);
                }
            }
        }

        hulkappsXMLRequestCallback(function (xhr) {
            var isMatched = false;
            var endpoint = window.hulkappsParseURL(xhr._url);

            let cart_endpoints = ["/cart/change", "/cart/clear", "/cart/update", "/cart/add"]
            var isStaged = false;
            const xhrReadyStageHandler = function () {
                // In local files, status is 0 upon success in Mozilla Firefox
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    isStaged = true;
                    cart_endpoints.forEach(function (endpoint) {
                        if (xhr._url && xhr._url.includes(endpoint)) {
                            isMatched = true;
                            var status = xhr.status;
                            if (status === 0 || (status >= 200 && status < 400)) {
                                window.is_on_click = false;
                                var cart = JSON.parse(xhr.response)
                                if (xhr._url.includes("/cart/add")) {

                                    cart = undefined
                                }
                                // The request has been completed successfully
                                window.getCartInfo(0, cart);
                            } else {
                                // Oh no! There has been an error with the request!
                            }
                        }
                    });
                    if (!isMatched && endpoint && endpoint.query) {
                        if (endpoint.query.get('section_id') && endpoint.query.get('section_id').includes('cart')) {
                            isMatched = true;
                            window.getCartInfo();
                        }else if (endpoint.query.get('ref') && endpoint.path.includes('/cart') ) {
                            return;
                        } else if (endpoint.query.get('view') && endpoint.query.get('view').includes('hulkapps_cart_collections')) {
                            return;
                        } else if (endpoint.query.get('view') && endpoint.path.includes('/cart') && !endpoint.path.includes('/cart.js')) {
                            isMatched = true;
                            window.getCartInfo();
                        }
                    }
                    if (!isMatched) {
                        if (endpoint && endpoint.path === '/cart') {
                            window.getCartInfo();
                        }
                    }
                }
            };

            const interval = setInterval(function () {
                if (!isStaged) {
                    xhrReadyStageHandler();
                    isStaged = true;
                }
                if (isStaged) {
                    clearInterval(interval);
                }
            }, 1000);

        });
        (function ($) {
            (function () {
                'use strict';

                // save the original methods before overwriting them
                Document.prototype._hulkappsAddEventListener = Document.prototype.addEventListener;
                Document.prototype._hulkappsRemoveEventListener = Document.prototype.removeEventListener;

                /**
                 * [addEventListener description]
                 * @param {[type]}  type       [description]
                 * @param {[type]}  listener   [description]
                 * @param {Boolean} useCapture [description]
                 */

                Document.prototype._hulkappsAddEventListener = function (type, listener, useCapture = false) {

                    // declare listener
                    this._hulkappsAddEventListener(type, listener, useCapture);
                    if (!this.hulkappsEventListenerList) this.hulkappsEventListenerList = {};
                    if (!this.hulkappsEventListenerList[type]) this.hulkappsEventListenerList[type] = [];
                    // add listener to  event tracking list
                    this.hulkappsEventListenerList[type].push({type, listener, useCapture});
                };
                Document.prototype._hulkappsRemoveEventListener = function (type, listener, useCapture = false) {
                    // remove listener
                    this._hulkappsRemoveEventListener(type, listener, useCapture);

                    if (!this.hulkappsEventListenerList) this.hulkappsEventListenerList = {};
                    if (!this.hulkappsEventListenerList[type]) this.hulkappsEventListenerList[type] = [];
                    for (let i = 0; i < this.hulkappsEventListenerList[type].length; i++) {

                        if (this.hulkappsEventListenerList[type][i].listener === listener && this.hulkappsEventListenerList[type][i].useCapture === useCapture) {
                            this.hulkappsEventListenerList[type].splice(i, 1);
                            break;
                        }
                    }
                    // if no more events of the removed event type are left,remove the group
                    if (this.hulkappsEventListenerList[type].length == 0) delete this.hulkappsEventListenerList[type];
                };

                Document.prototype.hulkappsGetEventListeners = function (type) {
                    if (!this.hulkappsEventListenerList) this.hulkappsEventListenerList = {};
                    // return reqested listeners type or all them
                    if (type === undefined) return this.hulkappsEventListenerList;
                    return this.hulkappsEventListenerList[type];
                };
            })();



        function triggerEditCartEvents($wrapper, value) {
            if (!$wrapper.length) return;
        
            const $input = $wrapper.first();
            const type = $input.attr('type');
            const tag = $wrapper.prop('tagName').toLowerCase();

            if (tag === 'div' || tag === 'label') {
                $input.prop('checked', true).trigger('change', { isProgrammatic: true });
            } else if (type === 'radio') {
                $input.prop('checked', true).trigger('change', { isProgrammatic: true });
            }else if (type === 'checkbox') {
                $input.prop('checked', true).trigger('change', { isProgrammatic: true });
            } else if (tag === 'select' || $input.is('option')) {
                if($input.closest('select').hasClass("hulk_po_dropdown_multiple")){
                    // for multi dropdown
                    if (!$input.is(':disabled')) {
                        const $select = $input.closest('select');
                        const chkMulti = $select.find('option:selected:not([disabled])').map(function () {
                            return $(this).val();
                        }).get();
                        chkMulti.push(value)

                        $input.closest('select').val(chkMulti).trigger('change', { isProgrammatic: true });
                    }
                }else{
                    if (!$input.is(':disabled')) {
                        $input.closest('select').val(value).trigger('change', { isProgrammatic: true });
                    }
                }
                
            }else if (tag === 'li') {
                $input.first().trigger('click', { isProgrammatic: true });
            }else if (type == 'number' && $input.hasClass('multi-qty-option')){
                $input.val(value).trigger('click', { isProgrammatic: true });
            }else if (type === 'text' || type == 'email' || type == 'number' || tag == 'textarea' || type == 'time' || type == 'date' || type == 'color') {
                $input.val(value).trigger('change', { isProgrammatic: true });
                const el = $input[0];

                // If this input is managed by flatpickr, sync it properly
                if (el && el._flatpickr) {
                el._flatpickr.setDate(value, false); // false = don't re-trigger change
                }
            } else {
                $input.trigger('change', { isProgrammatic: true });
            }
            
            
        }

        function getOptionChild(propertyName, propertyValue) {
            var hiddenInput = $('#edit_cart_popup input[name="properties[' + propertyName + ']"]');
            if (hiddenInput.length === 0) return []; // nothing found

            var wrapper = hiddenInput.closest('.hulkapps_option_value');
            if (!wrapper.length) return [{ input: hiddenInput, value: propertyValue }];

            var optionClass = hiddenInput.parents(".hulkapps_option")[0].classList[1];
            var result = [];

            switch(optionClass) {
                case 'swatch_render':
                    var cleanValue = propertyValue.split(' [')[0].trim();
                    wrapper.find('.hulkapps_option_child').filter(function() {
                        return String($(this).attr('value')) === String(cleanValue);
                    }).each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'mq_render': // multi quantity selector
                    var entries = propertyValue.split(',');
                    entries.forEach(function(entry) {
                        var parts = entry.split(' | ');
                        if (parts.length < 2) return;
                        var namePart = parts[0].trim();
                        var qtyPart = parts[1].trim();

                        wrapper.find('.muti-qty-div .hulk_quantity_amount').filter(function() {
                            return String($(this).data('value')).trim() === namePart;
                        }).each(function() {
                            result.push({ input: $(this), value: qtyPart });
                        });
                    });
                    break;

                case 'stg_render': // short text group
                    var cleanValue = propertyValue.split(' [')[0].trim();
                    var entries = cleanValue.split('|');
                    entries.forEach(function(entry) {
                        var parts = entry.split(':');
                        if (parts.length < 2) return;
                        var fieldName = parts[0].trim();
                        var fieldValue = parts[1].trim();

                        wrapper.find('input[type="text"]').filter(function() {
                            return String($(this).data("key-name")) === fieldName;
                        }).each(function() {
                            result.push({ input: $(this), value: fieldValue });
                        });
                    });
                    break;

                case 'tb_render': // short text
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('input[type="text"]').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'ta_render': // textarea
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('textarea').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'ci_render':
                    wrapper.find('.hulkapps_option_child li[value="' + propertyValue + '"]').each(function() {
                        result.push({ input: $(this), value: propertyValue });
                    });
                    break;

                case 'pn_render':
                    wrapper.find('.hulkapps_option_child li[value="' + propertyValue + '"]').each(function() {
                        result.push({ input: $(this), value: propertyValue });
                    });
                    break;

                case 'button_render':
                    wrapper.find('.hulkapps_option_child .button_radio').filter(function() {
                        return String($(this).val()) === propertyValue;
                    }).each(function() {
                        result.push({ input: $(this), value: propertyValue });
                    });
                    break;

                case 'et_render':
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('input[type="email"]').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'dp_render':
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('input[type="date"], .date-range').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'dt_render':
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('input[type="time"]').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'cp_render':
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('input[type="color"]').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'nf_render':
                    var cleanValue = propertyValue.split(' [')[0].trim();

                    wrapper.find('input[type="number"]').each(function() {
                        result.push({ input: $(this), value: cleanValue });
                    });
                    break;

                case 'multiswatch_render':
                    var entries = propertyValue.split(',');
                    entries.forEach(function(entry) {
                        wrapper.find('.hulkapps_option_child .hulk_po_swatch_multiple_checkbox').filter(function() {
                            return String($(this).val().trim()) === entry.trim();
                        }).each(function() {
                            result.push({ input: $(this), value: entry.trim() });
                        });
                    });
                    break;


                case 'cb_render': // checkboxes
                    var entries = propertyValue.split(',');
                    entries.forEach(function(entry) {
                        wrapper.find('input[type="checkbox"]').filter(function() {
                            return String($(this).val().trim()) === entry.trim();
                        }).each(function() {
                            result.push({ input: $(this), value: entry.trim() });
                        });
                    });
                    break;

                case 'dd_multi_render': // multi dropdown
                    var entries = propertyValue.split(',');
                    entries.forEach(function(entry) {
                        wrapper.find('select option').filter(function() {
                            return String($(this).val().trim()) === entry.trim();
                        }).each(function() {
                            result.push({ input: $(this), value: entry.trim() });
                        });
                    });
                    break;

                case 'dd_render':
                    wrapper.find('.hulkapps_option_child option').filter(function() {
                        return String($(this).attr('value')) === String(propertyValue);
                    }).each(function() {
                        result.push({ input: $(this), value: propertyValue });
                    });
                    break;

                case 'fm_render':
                    var cleanValue = propertyValue.split('|');
                    cleanValue.forEach(function(value) {
                        if (value.includes(':')){
                            var parts = value.split(':');
                            var fieldName = parts[0].trim();
                            var fieldValue = parts[1].trim();

                            wrapper.find('.po_changed_formula').filter(function() {
                                return String($(this).data("name")) === fieldName;
                            }).each(function() {
                                var $input = $(this);
                                var existingValue = $input.val();
    
                                if (existingValue === "" || existingValue === null || typeof existingValue === "undefined") {
                                    result.push({ input: $input, value: fieldValue });
                                }
                            });
                        }
                    });

                    break;

                case 'fu_render':
                    wrapper.find('.file-select-name').html(`<a class="hulk_file_upload img_url" href="${propertyValue}" target="_blank">Uploaded File</a>`).removeClass('noFile');
                    return [];

                case 'gf_render':
                    propertyValue = propertyValue.split(" [ ")[0];
                    wrapper.find('.hulkapps_option_child').val(propertyValue).trigger('change');
                    wrapper.find('.font-select a span').text(propertyValue);
                    return [];

                default:
                    wrapper.find('.hulkapps_option_child').filter(function() {
                        return String($(this).attr('value')) === String(propertyValue);
                    }).each(function() {
                        result.push({ input: $(this), value: propertyValue });
                    });
            }

            function defaultValues(){
                var result = []
                wrapper.find('.hulkapps_option_child').filter(function() {
                    return String($(this).attr('value')) === String(propertyValue);
                }).each(function() {
                    result.push({ input: $(this), value: propertyValue });
                });
                return result;
            }

            return result.length ? result : defaultValues();
        }

        function createHiddenPropertyInput(propertyName, propertyValue) {
            // Ensure the container exists
            var $container = $('#edit_cart_popup .hidden-properties-container');
            if (!$container.length) {
                $container = $('<div>', { class: 'hidden-properties-container' });
                $('#edit_cart_popup').append($container);
            }

            // Create the new hidden input
            var $input = $('<input>', {
                type: 'hidden',
                name: 'properties[' + propertyName + ']',
                value: propertyValue
            });

            // Append to container
            $container.append($input);
        }

        window.preSelectCartOptions = function(editCartButton) {
            if (!editCartButton.length) return;

            var itemKey = editCartButton.data("key");
            var cart = window.hulkapps.cart;
            var cartItem = (cart && cart.items) ? cart.items.find(i => i.key === itemKey) : null;
            if (!cartItem || !cartItem.properties) return;
            Object.keys(cartItem.properties).forEach(function(propertyName) {
                var propertyValue = cartItem.properties[propertyName];
                var inputs = getOptionChild(propertyName, propertyValue);
                if(inputs.length != 0 ){
                    inputs.forEach(function(obj) {
                        triggerEditCartEvents(obj.input, obj.value);
                    });
                }else{
                    createHiddenPropertyInput(propertyName, propertyValue);
                }
            });
        };


            $('body').on('click', '.edit_cart_option', function (e) {
                e.preventDefault();
                var itemKey = $(this).data("key");
                var cart = window.hulkapps.cart;
                var cartItem = (cart && cart.items) ? cart.items.find(i => i.key === itemKey) : null;
                if (!cartItem || !cartItem.properties) return;

                // Scope the cart line's variant in its own global so variant-based
                // conditional rules inside the edit-in-cart popup can read it without
                // overwriting window.hulkapps.product.selected_variant, which belongs
                // to the underlying product page. The condition evaluator picks the
                // right source by checking hulkapps_parents (see conditional_rules).
                window.hulkEditCartSelectedVariant = cartItem.variant_id;

                var store_id = window.hulkapps.store_id;
                var pid = $(this).data("product_id");
                var variant_id = $(this).data("variant_id");
                $("[name^='properties']").each(function () {
                    if ($(this).val() == '') {
                        $(this).attr('disabled', true);
                    }
                });
                var $this = $(this);
                var format = window.hulkapps.money_format;
                window.currentEditOptionSelector = $this;
                $.getJSON(`/products/${cartItem.handle}.js`, function(product) {
                    // Optional store_id check
                    if (window.hulkapps.store_id) {
                        window.hulkapps.product = {};

                        window.hulkapps.product_id = cartItem.product_id;
                        window.hulkapps.product_variant = cartItem.variant_id;
                        window.hulkapps.product_title = cartItem.title;
                        window.hulkapps.product_quantity = cartItem.quantity;

                        window.cproduct_price = cartItem.price;

                        window.hulkapps.product.vendor = product.vendor;
                        window.hulkapps.product.type = product.type;
                        window.hulkapps.product.tags = product.tags;
                        var arr = window.hulkapps.cart_collections && window.hulkapps.cart_collections[window.hulkapps.product_variant];
                        window.hulkapps.product_collections = (arr && arr.join) ? arr.join(',') : '';

                        window.hulkapps.product.properties = cartItem.properties || {};
                    }
                    productPageAjax($,"is_edit_cart", $this);
                });
            });

        }(hulkapps_jQuery));
        (function($){

            $.fn.fontselect = function(fonts,options) {
                var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

                var settings = {
                    style: 'font-select',
                    placeholder: 'Select a font',
                    lookahead: 2,
                    api: 'https://fonts.googleapis.com/css?family='
                };

                if(fonts.google_font){
                    var google_fonts = Object.keys(fonts.google_font)

                    var chunkSize = Math.ceil(google_fonts.length / 3);

                    for (var i = 0; i < google_fonts.length; i += chunkSize) {
                      var chunk = google_fonts.slice(i, i + chunkSize);
                      var fontNames = chunk.join('|');
                      var link = settings.api + fontNames;
                      if ($("link[href*='" + fontNames + "']").length === 0){
                          $('head').append('<link href="' + link + '" rel="stylesheet" type="text/css">');
                      }
                    }
                }
                if(fonts.custom_font){
                    var custom_fonts = fonts.custom_font
                }

                var Fontselect = (function(){

                    function Fontselect(original, o){
                        this.$original = $(original);
                        this.options = o;
                        this.active = false;
                        this.setupHtml();
                        this.getVisibleFonts();
                        this.bindEvents();

                        var font = this.$original.val();
                        if (font) {
                            this.updateSelected();
                        }
                    }

                    Fontselect.prototype.bindEvents = function(){
                        var self = this;
                        // Close dropdown automatically on clicks outside dropdown
                        $(document).click(function(event){
                            if(self.active && !$(event.target).parents('#fontSelect-'+ self.$original[0].id).length){
                                self.toggleDrop();
                            }
                        });

                        $('li', this.$results)
                            .click(__bind(this.selectFont, this))
                            .mouseenter(__bind(this.activateFont, this))
                            .mouseleave(__bind(this.deactivateFont, this));

                        $('span', this.$select).click(__bind(this.toggleDrop, this));
                        this.$arrow.click(__bind(this.toggleDrop, this));
                    };

                    Fontselect.prototype.toggleDrop = function(ev){

                        if(this.active){
                            this.$element.removeClass('font-select-active');
                            this.$drop.hide();
                            clearInterval(this.visibleInterval);
                        } else {
                            this.$element.addClass('font-select-active');
                            this.$drop.show();
                            this.moveToSelected();
                            this.visibleInterval = setInterval(__bind(this.getVisibleFonts, this), 500);
                        }

                        this.active = !this.active;
                    };

                    Fontselect.prototype.selectFont = function(){

                        var font = $('li.active', this.$results).data('value');
                        this.$original.val(font).change();
                        this.updateSelected();
                        this.toggleDrop();
                    };

                    Fontselect.prototype.moveToSelected = function(){

                        var $li, font = this.$original.val();

                        if (font){
                            $li = $("li[data-value='"+ font +"']", this.$results);
                        } else {
                            $li = $("li", this.$results).first();
                        }

                        this.$results.scrollTop($li.addClass('active')[0].offsetTop);
                    };

                    Fontselect.prototype.activateFont = function(ev){
                        $('li.active', this.$results).removeClass('active');
                        $(ev.currentTarget).addClass('active');
                    };

                    Fontselect.prototype.deactivateFont = function(ev){

                        $(ev.currentTarget).removeClass('active');
                    };

                    Fontselect.prototype.updateSelected = function(){

                        var font = this.$original.val();
                        $('span', this.$element).text(this.toReadable(font)).css(this.toStyle(font));
                    };

                    Fontselect.prototype.setupHtml = function(){

                        this.$original.empty().hide();
                        this.$element = $('<div>', {'id': 'fontSelect-'+this.$original[0].id, 'class': this.options.style});
                        this.$arrow = $('<div><b></b></div>');
                        this.$select = $('<a><span tabindex="0">'+ this.options.placeholder +'</span></a>');
                        this.$drop = $('<div>', {'class': 'fs-drop'});
                        this.$results = $('<ul>', {'class': 'fs-results'});
                        this.$original.after(this.$element.append(this.$select.append(this.$arrow)).append(this.$drop));
                        this.$drop.append(this.$results.append(this.fontsAsHtml())).hide();
                    };
                    
                    Fontselect.prototype.fontsAsHtml = function() {
                        h = '';
                        var fontFaceCSS = '';
                        if(fonts.google_font){
                            var l = google_fonts.length;
                            var r, s;
                        
                            for (var i = 0; i < l; i++) {
                                r = this.toReadable(google_fonts[i]);
                                s = this.toStyle(google_fonts[i]);
                                h += '<li tabindex="0" aria-label="' + google_fonts[i] + '" data-is-custom="false" data-value="' + google_fonts[i] + '" style="font-family: ' + s['font-family'] + '; font-weight: ' + s['font-weight'] + '">' + r + '</li>';
                            }
                        }

                        if(fonts.custom_font){
                            var k = Object.keys(custom_fonts).length;
                        
                            for (var i = 0; i < k; i++) {
                                var fontName = Object.keys(custom_fonts)[i];
                                r = this.toReadable(fontName);
                                s = this.toStyle(fontName);
                                var src = custom_fonts[fontName];
                                fontFaceCSS += '@font-face {font-family: "' + fontName + '";src: url(' + src + ');} ';
                                h += '<li tabindex="0" aria-label="' + fontName + '"  data-is-custom="true"  data-value="' + fontName + '" style="font-family: ' + fontName + '">' + r + '</li>';
                            }
    
                            $('head').append('<style>' + fontFaceCSS + '</style>');
                        }
                    
                        return h;
                    };

                    Fontselect.prototype.toReadable = function(font){
                        return font.replace(/[\+|:]/g, ' ');
                    };

                    Fontselect.prototype.toStyle = function(font){
                        var t = font.split(':');
                        return {'font-family': this.toReadable(t[0]), 'font-weight': (t[1] || 400)};
                    };

                    Fontselect.prototype.getVisibleFonts = function(){

                        if(this.$results.is(':hidden')) return;

                        var fs = this;
                        var top = this.$results.scrollTop();
                        var bottom = top + this.$results.height();

                        if(this.options.lookahead){
                            var li = $('li', this.$results).first().height();
                            bottom += li*this.options.lookahead;
                        }

                    };

                    return Fontselect;
                })();

                return this.each(function() {
                    // If options exist, lets merge them
                    if (options) $.extend( settings, options );

                    return new Fontselect(this, settings);
                });

            };
        })(hulkapps_jQuery);

        window.hulkDraftOrder = function () {
            return window.is_draft_order
        }
        window.hulkappsDoActions = function (data) {
            if (data.discounts.discount_show_integration) {
                window.is_discount_code = true
            }else{
                window.is_discount_code = false
            }
            if (data.discounts.discount_show) {

                $(".discount_code_box").css("display", "block");
            }else{
                $(".discount_code_box").css("display", "none");
            }

            if (typeof data.discounts == "object" && typeof data.discounts.cart == "object" && typeof data.discounts.cart.items == "object") {
                hulkappsShowCartDiscounts(data.discounts)
            }


        }

        $(document).on('click', checkout_selectors, function (e) {
            e.preventDefault();
            if (window.hulk_inventory_arr && window.hulk_inventory_arr.length > 0) {
                var error_html = "<div class=\"hulkapps_summary inventory_validation_hulkapps\">"
                window.hulk_inventory_arr.forEach(function (error_msg) {
                    error_html += error_msg

                })
                error_html += "</div>"
                $(".inventory_validation_hulkapps").remove()
                $(this).parent().after(error_html)
                return false;
            }else{
                $(".inventory_validation_hulkapps").remove();
            }
            if (window.is_draft_order && window.hulk_inventory_arr &&  window.hulk_inventory_arr.length <= 0) {
                if (typeof hulkappsCheckout != "function") {
                    window.location = "/checkout";
                }
                // Order Delivery Date App Code for validation issue. IntegrationCheckoutClick() function is at frontend side in theme
                if (typeof IntegrationCheckoutClick === 'undefined') {
                    hulkappsCheckout(null);
                } else {
                    var result = IntegrationCheckoutClick();
                    if (result.required == true) {
                        hulkappsCheckout(result);
                    } else if (result.required != false) {
                        hulkappsCheckout(result);
                    }
                }
            }else{
                if (typeof IntegrationCheckoutClick === 'undefined') {
                    window.location = "/checkout?locale="+Shopify.locale;
                }else{
                    var result = IntegrationCheckoutClick();
                    if (result.required == true) {
                    window.location = "/checkout?locale="+Shopify.locale;
                    } else if (result.required != false) {
                    window.location = "/checkout?locale="+Shopify.locale;
                    }else if  (result.required == false) {
                    return false
                    }

                }
                
                
            }

        });
        quickQuoteIntegration = function(items){
            const lineItems = document.querySelectorAll(`.cart-item-row`);
            items.forEach((item, index) => {
                const priceEl = lineItems[index] ? lineItems[index].querySelector('.price .ng-binding') : null;

                if (priceEl) {
                    priceEl.innerHTML = item.original_line_price_format;
                }
            });
        }

        window.hulkappsShowCartDiscounts = function (discounts) {
            if($('.cart-item-row').length > 0){
                quickQuoteIntegration(discounts.cart.items)
            }
            window.hulkapps.discounts = discounts;
            var cart_item_price_selectors = discounts['cart_item_price_selectors'].split(',')

            var cart_item_line_price_selectors = discounts['cart_item_line_price_selectors'].split(',')
            var cart_item_line_price_before_discount = discounts['cart_item_line_price_before_discount'].split(',')

            var cart_total_price_selectors = discounts['cart_total_price_selectors']
            discounts.cart.items.forEach(function (item) {
                $.each(cart_item_price_selectors, function( index, selector ) {
                    $(""+selector+"[data-key='" + item.key + "']").html(item.original_price_format);
                });

                $.each(cart_item_line_price_selectors, function( index, selector ) {
                    $(""+selector+"[data-key='" + item.key + "']").html(item.original_line_price_format);
                });

                $.each(cart_item_line_price_before_discount, function( index, selector ) {
                    $(""+selector+"[data-key='" + item.key + "']").html(item.cart_item_line_price_before_discount);
                });

            });
            var discounted_price = parseFloat(discounts.discount_cut_price);
            cart_total_price_selectors = cart_total_price_selectors.split(',')
            $.each(cart_total_price_selectors, function( index, selector ) {

                if (discounts.discount_code && discounts.discount_error == 1) {
                    $(selector).html(discounts.original_price_total);
                    hulkapps_jQuery(".hulkapps_summary").remove();
                    $(".hulkapps_discount_hide").after("<span class='hulkapps_summary'>Discount code does not match</span>");
                    localStorage.removeItem('discount_code');
                    $(selector).html(discounts.original_price_total);
                    $(selector).css("text-decoration", "none");
                    $(".hulkapps-summary-line-discount-code").html("");
                    $(".after_discount_price").html("");
                } else if (discounts.is_free_shipping) {
                    $(".hulkapps_summary").remove();
                    $(selector).html(discounts.original_price_total);
                    $(selector).css("text-decoration", "none");
                    $(".hulkapps-summary-line-discount-code").html("");
                    $(".after_discount_price").html("");
                    $(".hulkapps_discount_hide").after("<span class='hulkapps-summary-line-discount-code'><span class='discount-tag'>" + discounts.discount_code + "<span class='close-tag'></span></span>Free Shipping");

                } else if (discounts.discount_code && discounted_price <= 0 && $('.discount_code_box').is(":visible")) {
                    $(selector).html(discounts.original_price_total);
                    $(".hulkapps_discount_hide").after("<span class='hulkapps_summary'>" + discounts.discount_code + " discount code isn’t valid for the items in your cart</span>");
                    $(".hulkapps_discount_code").val("")
                    $(selector).html(discounts.original_price_total);
                    $(selector).css("text-decoration", "none");
                    $(".hulkapps-summary-line-discount-code").html("");
                    $(".after_discount_price").html("");
                    localStorage.removeItem('discount_code');
                } else if (discounts.discount_code && $('.discount_code_box').is(":visible")) {
                    $(".discount_code_box").find(".hulkapps_summary").html("");
                    $(".hulkapps-summary-line-discount-code,.after_discount_price").remove();
                    $(".hulkapps_discount_hide").after("<span class='hulkapps-summary-line-discount-code'><span class='discount-tag'>" + discounts.discount_code + "<span class='close-tag'></span></span><span class='hulkapps_with_discount'>" + " -" + discounts.with_discount + "</span></span><span class='after_discount_price'><span class='final-total'>Total</span>" + discounts.final_with_discounted_price + "</span>");
                    $(selector).html(discounts.original_price_total);
                    if (discounts.original_price_total != discounts.final_with_discounted_price) {
                        $(selector).css("text-decoration", "line-through");
                    }
                    $(".hulkapps-cart-total").remove();
                } else {
                    $(selector).html(discounts.original_price_total);
                    $(selector).css("text-decoration", "none");
                    $(".hulkapps-summary-line-discount-code").html("");
                    $(".after_discount_price").html("");
                    $(".discount_code_box").find(".hulkapps_summary").html("");

                }
                //$(selector).html(discounts.original_price_total);
            });
        }
        window.hulkappsCheckout = function (result) {

            // Trigger custom event before checkout
            try {
                document.dispatchEvent(new CustomEvent("hpo_before_checkout"));
            } catch (e) {
                console.warn("hpo_before_checkout event failed:", e);
            }

            if(window.hulk_inventory_arr && window.hulk_inventory_arr.length > 0){
                return false
            }
            // Prevent duplicate draft orders
            if (window.hulkapps_checkout_in_progress) {
                return false
            }
            window.hulkapps_checkout_in_progress = true
            $(checkout_selectors).attr('disabled', true)
            var releaseCheckoutLock = function () {
                window.hulkapps_checkout_in_progress = false
                $(checkout_selectors).attr('disabled', false)
            }
            var order_app = {}
            if (result != null) {
                if (result.shipping_status == 1) {
                    order_app = {"price": result.shipping_price, "title": result.shipping_method}
                }
            }
            var storage_code = localStorage.getItem('discount_code');
            $.getJSON('/cart.js', {_: new Date().getTime()}, function (cart) {
                if(cart && cart.item_count > 0) {
                    window.hulkapps.cart = cart;
                    new Promise((resolve, reject) => {
                        $.ajax({
                            url: "/cart?view=hulkapps_cart_collections.json", success: function (result) {
                                try {
                                    if (result) {
                                        var obj = JSON.parse(result)
                                        if (obj) {
                                            var items = obj.items
                                            $.each(items, function (index, pcollections) {
                                                window.hulkapps.cart_collections[pcollections['variant_id']] = pcollections['product_collections']
                                            });
                                        }
                                    }
                                    resolve(window.hulkapps.cart_collections)
                                } catch (err) {
                                    resolve(window.hulkapps.cart_collections)
                                }
                            },
                            error: function (error) {
                                resolve(window.hulkapps.cart_collections)
                            }
                        })
                    }).then(function (cart_collections) {
                        window.hulkapps.cart_collections = cart_collections
                        var draft_order_language = Shopify.locale
                        const draft_order_data = {
                            cart_json: window.hulkapps,
                            store_id: window.hulkapps.store_id,
                            discount_code: storage_code,
                            cart_collections: JSON.stringify(window.hulkapps.cart_collections),
                            order_app: order_app,
                            customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',
                            draft_order_language: draft_order_language != undefined ? draft_order_language : "",
                            default_address: window.hulkapps.customer != null && window.hulkapps.customer.default_address != null  ? window.hulkapps.customer.default_address : '',
                            currency_rate: window.Shopify.currency.rate

                        }
                        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
                            draft_order_data.currency_code = window.Shopify.currency.active;
                        }
                        if (window.Shopify && window.Shopify.country) {
                            draft_order_data.buyer_country_code = window.Shopify.country;
                        }
                        
                        $.ajax({
                            type: "POST",
                            url: window.hulkapps.po_url + "/store/create_draft_order",
                            data: draft_order_data,
                            crossDomain: true,
                            success: function (res) {
                                if (typeof res == "string") {
                                    // START https://apps.shopify.com/upsell-cross-sell-kit-1 app integration
                                    try {
                                        var upsell_discount_code = localStorage.getItem("lb-upsell-offer-discount");
                                        if(upsell_discount_code) {
                                            upsell_discount_code = JSON.parse(upsell_discount_code)
                                            if (upsell_discount_code && upsell_discount_code.code){
                                                if (res.includes('?')) {
                                                    res = res + `&discount=${upsell_discount_code.code}`
                                                } else {
                                                    res = res + `?discount=${upsell_discount_code.code}`
                                                }
                                            }
                                        }
                                    }catch(err){

                                    }

                                    // END https://apps.shopify.com/upsell-cross-sell-kit-1 app integration
                                    window.location.href = res
                                } else {
                                    window.location.href = "/checkout"
                                }
                                localStorage.removeItem('discount_code');
                            },
                            error: function () {
                                releaseCheckoutLock();
                            }
                        });
                    }).catch(function (error) {
                        releaseCheckoutLock();
                        console.error(error);
                    })
                } else {
                    releaseCheckoutLock();
                }
            }).fail(function () {
                releaseCheckoutLock();
            });

        }
        var selected_option_list = []
        var selector_var = document.querySelectorAll(".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio'], variant-picker select")
        selector_var.forEach(function (selector) { 
            selector.addEventListener('change', (event) => {
                selected_option_list = []
                selector_var.forEach(function (selector) {
                    var dropdown_selector = selector.options ? selector.options[selector.options.selectedIndex].selected : false
                    if (selector.checked || dropdown_selector) {
                        selected_option_list.push(selector.value)
                    }
                });
                selected_option_list = selected_option_list.join(' / ')
                Object.keys(hulk_variants).forEach(function (key) {
                    var val = hulk_variants[key];
                    if (val.options.length < 2) {
                        selected_variant_title = event.target.value.toString().toLowerCase();
                        var variantTitle = val.title.toString().toLowerCase();
                        if (variantTitle.trim() == selected_variant_title.trim()) {
                            // if(selected_variant_title.includes(variantTitle)){
                            var variantId = val.id;
                            window.hulkapps.product.selected_variant = val.id
                            product_price = val.price
                            compare_product_price = val.compare_at_price
                            window.hulkapps.product.selected_variant_price = product_price
                            window.hulkapps.product.selected_variant_compare_price = compare_product_price
                        }
                    } else {
                        selected_variant_title = selected_option_list.toString().toLowerCase();
                        var variantTitle = val.title.toString().toLowerCase();
                        // if (variantTitle.trim() == selected_variant_title.trim()) {
                        if (selected_variant_title.includes(variantTitle)) {
                            var variantId = val.id;
                            window.hulkapps.product.selected_variant = val.id
                            product_price = val.price
                            compare_product_price = val.compare_at_price
                            window.hulkapps.product.selected_variant_price = product_price
                            window.hulkapps.product.selected_variant_compare_price = compare_product_price
                        }
                    }
                    if(document.querySelector('script[type="application/json"][data-variant]')){
                        updateSelectedVariant();
                    }
                });
                if(window.need_varaint_change && window.need_varaint_change == true){
                    window.productPageAjax($)   
                }                       
             });
        });

        window.initDatePickers = function (hpage_type) {
            hulkapps_jQuery('.date-range').each(function () {
                if (this._flatpickr) return;

                flatpickr(this, {
                    mode: 'range',
                    dateFormat: 'Y-m-d',
                    minDate: this.min || null,
                    maxDate: this.max || null
                });
            });
            if(hpage_type == "is_edit_cart"){
                hulkapps_jQuery('.flatpickr-calendar').css('z-index', 2147483647);
            }
        }

        window.productPageAjax = function ($,page='product', editCartButton=''){
            if(window.cproduct_price){
                product_price = window.cproduct_price
            }
            var hpage_type = page;
            var parentClass = (hpage_type == "is_edit_cart") ? "hulkapps_edit_product_options" : "hulkapps_product_options";
            $.ajax({
                type: "POST",
                url: window.hulkapps.po_url + "/api/v2/store/get_all_relationships",
                data: {hpage_type: hpage_type, pid: window.hulkapps.product_id, store_id: window.hulkapps.store_id,tags: window.hulkapps.product.tags,vendor: window.hulkapps.product.vendor,ptype: window.hulkapps.product.type,customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',product_collections: window.hulkapps.product_collections,shopify_currency_rate: window.hulkapps_shopify_rate},
                sync: false,
                crossDomain: true,
                success: function (data) {
                    if(window.$first_add_to_cart_el){
                        window.$first_add_to_cart_el.removeAttr("disabled")
                    }

                    if (typeof data === "string") {
                        try {
                            data = JSON.parse(data);
                        } catch (e) {
                            console.warn("Non-JSON response received");

                            if (hpage_type === 'is_collection_page') {

                                if (!window.hulk_options_not_available_text) {
                                    window.hulk_options_not_available_text = 'Options not available';
                                }

                                $(`.hulkapps-po-main_form_${window.hulkapps.product_id}`)
                                    .append(`<div class='hulk_options_not_available'>
                                                    <p>${window.hulk_options_not_available_text}</p>
                                                </div>`);
                            }

                            return; // stop execution
                        }
                    }
                    // setTimeout(function(){
                        var conditional_html = ''
                        let a = {};
                        window.store_created_date = data['created_at_date']
                        window.hulk_po_plan_id = data['plan_id']
                        window.hulk_po_plans_features = data['plans_features']
                        window.hulk_po_is_on_trial_period = data['is_on_trial_period']
                        if (checkPlan('conditional_logic', 'boolean' ) || (checkPlan('conditional_logic', 'boolean' ) == false && oldStore() == true) ) {
                            if (data['condition'] != undefined) {
                                conditional_html += "<div id='conditional_rules' style='display:none'>"
                                var comConClass = ''
                                $.each(data['condition'], function (index, con) {
                                    var condition_id = con['id']
                                    var conditions = hulkapps_jQuery.parseJSON(con['conditions'])
                                    if (conditions['apply_rule'] == 'OR') {
                                        var apply_rule = "0"
                                    } else {
                                        var apply_rule = "1"
                                    }
                                    conditional_html = conditional_html + "<div id='conditional_logic_" + condition_id + "' name='conditional_logic_" + condition_id + "' data-verify-all='" + apply_rule + "' style='display:none'>"
                                    $.each(conditions['rules'], function (index, rule) {
                                        var isVariantRule = rule['option'] === 'shopify_product_variant';
                                        var option_id = parseInt(rule['option']);
                                        if (isVariantRule || data['option_id_array'].indexOf(option_id) >= 0) {
                                            if (parseInt(rule['rule_type']) == 1) {
                                                var rule_type = "=="
                                            } else {
                                                var rule_type = "!="
                                            }
                                            if (isVariantRule) {
                                                window.need_varaint_change = true
                                                conditional_html += `<div name='conditional_logic_${condition_id}' data-variant-rule='true' data-verify-all='${apply_rule}' class='step_1' data-conchildren-value='**value11**${rule_type}${rule['option_val']}'>**value11**${rule_type}${rule['option_val']}</div>`
                                            } else {
                                                conditional_html += `<div name='conditional_logic_${condition_id}' data-field-num='${option_id}' data-verify-all='${apply_rule}' class='step_1' data-conchildren-value='**value11**${rule_type}${rule['option_val']}'>**value11**${rule_type}${rule['option_val']}</div>`
                                            }
                                        }
                                    });
                                    conditional_html = conditional_html + "</div>"
                                    let b = [];
                                    $.each(conditions['actions'], function (index, action) {
                                        var option_id = parseInt(action['option']);
                                        b.push(option_id);
                                        if (data['option_id_array'].indexOf(option_id) >= 0) {
                                            if (parseInt(action['action_type']) == 1) {
                                                var action_type = "show"
                                            } else {
                                                var action_type = "hide"
                                            }
                                            comConClass += " conditional_logic_" + condition_id + "_" + action_type
                                            var conclass = "condition_" + action_type + " conditional"
                                            data['hide_show_array'][option_id] = conclass;
                                        }
                                    });
                                    a[condition_id] = b;
                                });
                                conditional_html = conditional_html + "</div>"
                            }
                        }
                        var cart_selectors = data['cart_selectors']
                        
                        
                        var title_text = data['options_title']['title_text'].length != 0 ? data['options_title']['title_text'] : 'Choose Your Product Options:';

                        var ho_title = ".hulkapps_option_title{"
                        ho_title = ho_title + ((data['options_title']['title_padding'].length != 0) ? "padding: " + data['options_title']['title_padding'] + "px;" : 'padding: 15px;')
                        ho_title = ho_title + ((data['options_title']['title_font_size'].length != 0) ? "font-size: " + data['options_title']['title_font_size'] + "px;" : 'font-size: 16px;')
                        ho_title = ho_title + ((data['options_title']['title_text_align'].length != 0) ? "text-align: " + data['options_title']['title_text_align'] + ";" : 'text-align: left;')
                        ho_title = ho_title + ((data['options_title']['title_background'].length != 0) ? "background-color: " + data['options_title']['title_background'] + ";" : 'background-color: #ffffff;')
                        ho_title = ho_title + ((data['options_title']['title_border'].length != 0) ? "border: 1px solid " + data['options_title']['title_border'] + ";" : 'border: 1px solid #000000;')
                        ho_title = ho_title + ((data['options_title']['title_font_color'].length != 0) ? "color: " + data['options_title']['title_font_color'] + ";" : 'color:#000000;')
                        ho_title = ho_title + ((parseInt(data['options_title']['title_bold']) == 1) ? "font-weight:bold;" : 'font-weight:normal;')
                        ho_title = ho_title + ((parseInt(data['options_title']['title_display']) == 1) ? "" : 'display:none;')
                        ho_title = ho_title + "border-bottom: none;"
                        ho_title = ho_title + "}"

                        var enable_tooltip = data['options_container_style']['enable_tooltip']
                        var enable_helptext = data['options_container_style']['enable_helptext']
                        var oc_style = "#hulkapps_option_list_" + data['pid'] + "{"
                        oc_style = oc_style + ((data['options_container_style']['background_color'].length != 0) ? "background-color: " + data['options_container_style']['background_color'] + ";" : 'background-color: #fff;')
                        oc_style = oc_style + ((data['options_container_style']['border_color'].length != 0) ? "border: 1px solid " + data['options_container_style']['border_color'] + ";" : 'border: 0 none;')
                        oc_style = oc_style + ((data['options_container_style']['padding'].length != 0) ? "padding: " + data['options_container_style']['padding'] + "px;" : 'padding: 10px;')
                        oc_style = oc_style + "}.hulkapps_option {width: 100%;display: block;transition: 0.3s all;"
                        oc_style = oc_style + ((data['options_container_style']['spacing_between_options'].length != 0) ? "padding-bottom: 0px; margin-bottom: " + data['options_container_style']['spacing_between_options'] + "px;" : 'padding-bottom: 0; margin-bottom: 6px;')
                        oc_style = oc_style + ((data['options_container_style']['line_between_options'].length != 0) ? "border-bottom: 1px solid " + data['options_container_style']['line_between_options'] + ";" : '')
                        oc_style = oc_style + "}"

                        var option_name_inline = data['options_name_style']['option_name_inline']
                        var formula_option_name_inline = data['display_settings']['formula_option_name_inline']
                        window.change_button_text = (data && data['display_settings'] && data['display_settings']['change_button_text'] !== undefined && data['display_settings']['change_button_text'].trim() !== '') ? data['display_settings']['change_button_text'] : 'Change';
                        window.select_button_text = (data && data['display_settings'] && data['display_settings']['select_button_text'] !== undefined && data['display_settings']['select_button_text'].trim() !== '') ? data['display_settings']['select_button_text'] : 'Select';
                        var is_current_behaviour_radiobutton = data['display_settings']['is_current_behaviour_radiobutton'] || false;

                        window.min_max_validation_message = escapeHtml(data['display_settings']['min_max_validation_message']) || 'Choose from {min} to {max} values';
                        window.min_only_validation_message = escapeHtml(data['display_settings']['min_only_validation_message']) || 'Choose at least {min} values';
                        window.max_only_validation_message = escapeHtml(data['display_settings']['max_only_validation_message']) || 'Choose upto {max} values';

                        window.min_max_formula_validation_message = escapeHtml(data['display_settings']['min_max_formula_validation_message']) || 'Choose values from {min} - {max}';
                        window.min_only_formula_validation_message = escapeHtml(data['display_settings']['min_only_formula_validation_message']) || 'Choose values higher than {min}';
                        window.max_only_formula_validation_message = escapeHtml(data['display_settings']['max_only_formula_validation_message']) || 'Choose values up to {max}';

                        window.invalid_date_validation_message = escapeHtml(data['display_settings']['invalid_date_validation_message']) || 'Enter valid date format mm/dd/yyyy';
                        window.invalid_email_validation_message = escapeHtml(data['display_settings']['invalid_email_validation_message']) || 'Invalid email format';
                        window.invalid_phone_validation_message = escapeHtml(data['display_settings']['invalid_phone_validation_message']) || 'Invalid number';

                        var on_style = ".hulkapps_option_name {"
                        on_style = on_style + ((data['options_name_style']['option_name_width'].length != 0) ? "width: " + data['options_name_style']['option_name_width'] + "px;" : 'width: 180px;')
                        on_style = on_style + ((data['options_name_style']['option_name_font_size'].length != 0) ? "font-size: " + data['options_name_style']['option_name_font_size'] + "px;" : 'font-size: 14px;')
                        on_style = on_style + ((data['options_name_style']['option_name_text_align'].length != 0) ? "text-align: " + data['options_name_style']['option_name_text_align'] + ";" : 'text-align: left;')
                        on_style = on_style + ((data['options_name_style']['font_color'].length != 0) ? "color: " + data['options_name_style']['font_color'] + ";" : 'color: #424242;')
                        on_style = on_style + ((parseInt(data['options_name_style']['on_title_bold']) == 1) ? "font-weight: bold;" : 'font-weight: normal;')
                        on_style = on_style + "min-width: " + data['options_name_style']['option_name_width'] + "px;padding-right: 15px;box-sizing: border-box;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;-ms-box-sizing: border-box;vertical-align: top;}"

                        var ov_padding = data['option_values_style']['ov_padding']
                        var ov_width = data['option_values_style']['ov_width']
                        var spacing_left_of_values = data['option_values_style']['spacing_left_of_values']
                        var single_line = data['option_values_style']['single_line']
                        var ov_style = ".hulkapps_option_value {"
                        ov_style = ov_style + "width:100%;min-width: 100%;text-align: left;vertical-align: top;}"
                        ov_style = ov_style + ".hulkapps_option .hulkapps_option_value, .pn_render .hulkapps_option_child, .et_render .hulkapps_option_child, .tb_render .hulkapps_option_child, .ta_render .hulkapps_option_child, .fu_render .hulkapps_option_child, .dd_render .hulkapps_option_child, .dd_multi_render .hulkapps_option_child, .nf_render .hulkapps_option_child, .dp_render .hulkapps_option_child, .dt_render .hulkapps_option_child{"
                        ov_style = ov_style + ((data['option_values_style']['ov_font_size'].length != 0) ? "font-size: " + data['option_values_style']['ov_font_size'] + "px !important;" : '')
                        ov_style = ov_style + ((data['option_values_style']['ov_font_color'].length != 0) ? "color: " + data['option_values_style']['ov_font_color'] + " !important;" : '')
                        ov_style = ov_style + ((data['option_values_style']['ov_font_weight'] != undefined && parseInt(data['option_values_style']['ov_font_weight']) == 1) ? "font-weight:bold;" : 'font-weight:normal;')
                        ov_style = ov_style + ((data['option_values_style']['ov_text_align'] != undefined) ? "text-align: " + data['option_values_style']['ov_text_align'] + " !important;" : '')
                        ov_style = ov_style + "}"

                        var ov_radiobutton_color = data['option_values_style']['selected_radio_button_color'] || "#0090FA"
                        var ov_checkbox_color = data['option_values_style']['selected_checkbox_color'] || "#ffffff"
                        var recommended_btn = ".recommended_btn, recommended_btn a{"
                        recommended_btn = recommended_btn +  ((data['recomodation_setting'] != undefined && data['recomodation_setting']['recomodation_font_size'] != undefined) ? "font-size: " + data['recomodation_setting']['recomodation_font_size'] + "px !important;" : '')
                        recommended_btn = recommended_btn + ((data['recomodation_setting'] != undefined && data['recomodation_setting']['recomodation_font_color'] != undefined) ? "color: " + data['recomodation_setting']['recomodation_font_color'] + " !important;" : '')
                        recommended_btn = recommended_btn + "}"

                        var oh_style = ".hulkapps_helptext,.hulkapps_helptext a{"
                        oh_style = oh_style + ((data['option_help_text_style'] != undefined && data['option_help_text_style']['option_help_text_font_size'] != undefined) ? "font-size: " + data['option_help_text_style']['option_help_text_font_size'] + "px !important;" : '')
                        oh_style = oh_style + ((data['option_help_text_style'] != undefined && data['option_help_text_style']['option_help_text_font_color'] != undefined) ? "color: " + data['option_help_text_style']['option_help_text_font_color'] + "!important;" : '')
                        oh_style = oh_style + ((data['option_help_text_style'] != undefined  && parseInt(data['option_help_text_style']['on_help_text_bold']) == 1) ? "font-weight: bold;" : 'font-weight: normal;')
                        oh_style = oh_style + "}"

                        var ot_style = ".hulkapps-tooltip .hulkapps-tooltip-inner,.hulkapps-tooltip .hulkapps-tooltip-inner a{"
                        ot_style = ot_style + ((data['option_tooltip_style'] != undefined && data['option_tooltip_style']['option_tooltip_font_size'] != undefined) ? "font-size: " + data['option_tooltip_style']['option_tooltip_font_size'] + "px !important;" : '')
                        ot_style = ot_style + ((data['option_tooltip_style'] != undefined && data['option_tooltip_style']['option_tooltip_font_color'] != undefined) ? "color: " + data['option_tooltip_style']['option_tooltip_font_color'] + "!important;" : '')
                        ot_style = ot_style + ((data['option_tooltip_style'] != undefined && data['option_tooltip_style']['option_tooltip_background_color'] != undefined) ? "background-color: " + data['option_tooltip_style']['option_tooltip_background_color'] + "!important;" : '')
                        ot_style = ot_style + "}"
                        ot_style = ot_style + ".hulkapps-tooltip .hulkapps-tooltip-inner:after{"
                        ot_style = ot_style + ((data['option_tooltip_style'] != undefined && data['option_tooltip_style']['option_tooltip_background_color'] != undefined) ? "border-color: " + data['option_tooltip_style']['option_tooltip_background_color'] + " transparent transparent transparent !important;" : '')
                        ot_style = ot_style + "}"

                        ot_style = ot_style + ".hulkapps-tooltip .hulkapps-tooltip-inner.swatch-tooltip p,.hulkapps-tooltip .hulkapps-tooltip-inner.multiswatch-tooltip p{"
                        ot_style = ot_style + ((data['option_tooltip_style'] != undefined && data['option_tooltip_style']['option_tooltip_font_color'] != undefined) ? "color: " + data['option_tooltip_style']['option_tooltip_font_color'] + "!important;" : '')

                        ot_style = ot_style + "}"
                        var floating_label_size = (data['option_values_style']['ov_font_size'].length != 0) ? parseInt(data['option_values_style']['ov_font_size']) - 2  : 14

                        var float_lable_setting = ".has-float-label .floating_label{"
                        float_lable_setting = float_lable_setting +  ((data['option_values_style']['ov_font_size'].length != 0) ? "font-size: " + data['option_values_style']['ov_font_size'] + "px;" : 'font-size: 14px;')
                        float_lable_setting = float_lable_setting + ((data['option_values_style']['ov_font_color'].length != 0) ? "color: " + data['option_values_style']['ov_font_color'] + ";" : 'color: #424242;')
                        float_lable_setting = float_lable_setting + ((parseInt(data['option_values_style']['ov_font_weight'] ) != undefined && parseInt(data['option_values_style']['ov_font_weight']) == 1) ? "font-weight: bold;" : 'font-weight: normal;')
                        float_lable_setting =  float_lable_setting + "}"
                        float_lable_setting = float_lable_setting + ".has-float-label .hulkapps_option_value input:focus-visible ~ .floating_label, .has-float-label .hulkapps_option_value textarea:focus ~ .floating_label, .has-float-label .hulkapps_option_value textarea:focus-visible ~ .floating_label, .has-float-label .hulkapps_option_value input:focus ~ .floating_label, .has-float-label .hulkapps_option_value textarea:focus-within ~ .floating_label, .has-float-label .hulkapps_option_value input:focus-within ~ .floating_label,  .has-float-label .hulkapps_option_value textarea:active ~ .floating_label, .has-float-label .hulkapps_option_value input:active ~ .floating_label,.has-float-label .hulkapps_option_value input.textbox_selected ~ .floating_label, .has-float-label .hulkapps_option_value input.numberfield_selected ~ .floating_label,.has-float-label .hulkapps_option_value input.emailbox_selected ~ .floating_label,.has-float-label .hulkapps_option_value textarea.textbox_selected ~ .floating_label, .has-float-label .hulkapps_option_value textarea.textarea_selected ~ .floating_label, .has-float-label,.hulkapps_option_value select ~ label.floating_label{"
                        float_lable_setting = float_lable_setting +  ((data['option_values_style']['ov_font_size'].length != 0) ? "font-size: " + floating_label_size  + "px !important;" : 'font-size: 14px;')

                        float_lable_setting =  float_lable_setting + "}"


                        var custom_js = data['advanced_users']['custom_js']
                        var custom_css = data['advanced_users']['custom_css']

                        var swatch_width = parseInt(data['swatch_settings']['swatch_width'])
                        var swatch_height = parseInt(data['swatch_settings']['swatch_height'])
                        var tooltip_position = data['swatch_settings']['tooltip_position']
                        var tooltip_contains = data['swatch_settings']['tooltip_contains']
                        var tooltip_display = parseInt(data['swatch_settings']['tooltip_display'])
                        var round_corners = parseInt(data['swatch_settings']['round_corners'])
                        var enable_swatch_images = parseInt(data['swatch_settings']['enable_swatch_images'])
                        var enable_swatch_with_text = parseInt(data['swatch_settings']['enable_swatch_with_text'])
                        var swatch_width = (swatch_width == '' || swatch_width < 0) ? "width:35px;" : "width:" + swatch_width + "px;"
                        var swatch_height = (swatch_height == '' || swatch_height < 0) ? "height:35px;" : "height:" + swatch_height + "px;"
                        var tooltip_position = (tooltip_position == 'top') ? 'top' : 'bottom'
                        var round_corners = (round_corners == 1) ? '-webkit-border-radius: 50%;-moz-border-radius: 50%;border-radius: 50%;' : ''
                        var swatch_selected_border = data['swatch_settings']['swatch_selected_border']
                        
                        var swach_selected_border_color = swatch_selected_border != undefined ? "border-color: "+swatch_selected_border +" !important" : " #000000 !important"

                        var button_option_background = ((data['button_option_settings']['button_option_background'].length != 0) ? 'background-color: ' + data['button_option_settings']['button_option_background'] + ';' : '#ffffff')
                        var button_option_font_color = ((data['button_option_settings']['button_option_font_color'].length != 0) ? 'color: ' + data['button_option_settings']['button_option_font_color'] + ';' : '#777777')
                        var button_option_border_color = ((data['button_option_settings']['button_option_border_color'].length != 0) ? 'border-color: ' + data['button_option_settings']['button_option_border_color'] + ';' : '#777777')

                        var label_setting = (data['label_setting'] != undefined && data['label_setting']['lable_display'] == 'blocklable') ? '' : (data['label_setting'] == undefined ? '' :  data['label_setting']['lable_display'])
                        if(label_setting == 'floatingLabels'){
                            var has_float_label = 'has-float-label'
                        }
                        if(label_setting == "inlineLabels"){
                            var has_float_label = 'has-inline-label'
                        }
                        var update_total_text = data['premium_option_settings']['update_total_text']
                        var amount_note_display = (data['premium_option_settings']['amount_note_display'] == undefined) ? 1 : data['premium_option_settings']['amount_note_display']
                        var price_setting = data['premium_option_settings']['price_setting']
                        if(price_setting != undefined){
                            var amount_note_display = (data['premium_option_settings']['price_setting'] == 'price_addtional_charge' || data['premium_option_settings']['price_setting'] == 'price_total_charge') ? "1" : "0"
                        }
                        var disabled_option_price = (data['premium_option_settings']['disabled_option_price'] == undefined) ? 0 : data['premium_option_settings']['disabled_option_price']
                        var store_currency  = data['currency_symbol']
                        if (data['is_enabled_shopify_default_currency'] ){
                            var p_with_currency = currency_conversion(0)
                            var temp = document.createElement('div');
                            temp.innerHTML = p_with_currency;
                            data['currency_symbol'] = temp.textContent.replace(/[0-9,.\s]/g, '').trim();
                        }
                        window.is_enabled_shopify_default_currency = data['is_enabled_shopify_default_currency']
                       window.rounding_price =  data['is_price_rounding']
                        currency_symbol = data['currency_symbol']
                        window.hulk_po_currency_symbol = data['currency_symbol']
                        display_price_setting = data['premium_option_settings']
                        var post_total_text = data['premium_option_settings']['post_total_text']
                        var total_container_background_color = data['premium_option_settings']['total_container_background_color']
                        var total_container_border_color = data['premium_option_settings']['total_container_border_color']
                        var total_container_font_color = data['premium_option_settings']['total_container_font_color']
                        var total_container_price_color = data['premium_option_settings']['total_container_price_color']
                        var po_settings = "#option_total {"
                        po_settings = po_settings + (total_container_background_color !== '' ? "background: none repeat scroll 0 0 " + total_container_background_color + ";" : "background: none repeat scroll 0 0 #fff;")
                        po_settings = po_settings + (total_container_border_color !== '' ? "border:1px solid " + total_container_border_color + ";" : 'border:1px solid #000000;')
                        po_settings = po_settings + (total_container_font_color !== '' ? "color: " + total_container_font_color + ";" : "color: #000;")
                        po_settings = po_settings + "}#formatted_option_total {"
                        po_settings = po_settings + (total_container_price_color !== '' ? "color: " + total_container_price_color + ";" : "color: #000;")
                        po_settings = po_settings + "}"
                        var single_inline_css = parseInt(single_line) == 0 ? '0px' : '10px'
                        var popup_button_settings  = data['popup_button_settings']
                        var button_option_continue = ".hulkSaveBtn { background-color: "+popup_button_settings['button1_background_color']+"; color: "+popup_button_settings['button1_font_color']+";border: "+popup_button_settings['button1_border_width']+"px solid "+popup_button_settings['button1_border_color']+"}"
                        var button_option_cancel = ".hulkCancelBtn { background-color: "+popup_button_settings['button2_background_color']+"; color: "+popup_button_settings['button2_font_color']+";border: "+popup_button_settings['button2_border_width']+"px solid "+popup_button_settings['button2_border_color']+"} .hulkresetBtn { background-color: "+popup_button_settings['button2_background_color']+"; color: "+popup_button_settings['button2_font_color']+";border: "+popup_button_settings['button2_border_width']+"px solid "+popup_button_settings['button2_border_color']+"} "
                        $('.hulkSaveBtn').text(popup_button_settings['button1_text']);
                        $('.hulkCancelBtn').text(popup_button_settings['button2_text']);
                        var image_parent_list = data['image_thumbnail_parents_selector'] != undefined ? data['image_thumbnail_parents_selector'] : ""
                        var image_parent = ""
                        if(image_parent_list != undefined && image_parent_list != ''){
                            image_parent_selector = image_parent_list.split(",")
                            image_parent_selector.forEach(function (selector,idx,image_parent_selector) {
                                if (idx === image_parent_selector.length - 1){
                                    image_parent += selector + '  img'
                                }else{
                                    image_parent += selector + '  img,'
                                }
                            });
                        }
                        window.image_parent = image_parent
                        var button_option_selected_background = data['button_option_settings']['button_option_selected_background']
                        var button_option_selected_border_color = data['button_option_settings']['button_option_selected_border_color']
                        var button_option_selected_font_color = data['button_option_settings']['button_option_selected_font_color']


                        var other_css = "#hulkapps_custom_options_" + data['pid'] + "{clear: both}#hulkapps_options_" + data['pid'] + "{margin:15px 0;}#hulkapps_option_list_" + data['pid'] + " select{width:100%;padding-top: 12px;padding-bottom: 12px}.popup_detail{position: fixed;background-color: #F7F7F7;padding: 15px;top: 50%;left: 50%;transform: translate(-50%, -50%);justify-content: space-between;z-index: 3;min-width: 300px;max-width: fit-content;overflow-y: auto;max-height: 300px;}.popup_detail a{cursor: pointer;}.popup_detail img{width: 15px;height: 15px;margin: 5px;}.popup_detail p{margin:0;}.overlay-popup{position: fixed;display: none;width: 100%;height: 100%;top: 0;left: 0;bottom: 0;background-color: rgba(0,0,0,0.5);z-index: 2;}.popup_render{margin-bottom:0!important;display:flex;align-items:center!important}.popup_render .hulkapps_option_value{min-width:auto!important}.popup_render a{margin-left: 4px;text-decoration:underline!important;transition:all .3s!important;font-weight: normal !important;}.popup_render a:hover{color:#6e6e6e}.cut-popup-icon{display:inline-flex;align-items:center}.cut-popup-icon-span{display:inline-flex}.des-detail{font-weight: normal;}#hulkapps_option_list_" + data['pid'] + " input[type='text']{width:100%;border-radius:0}.no-radio-style {accent-color: "+ ov_radiobutton_color +";}#hulkapps_option_list_" + data['pid'] + " input:not(.no-radio-style),#hulkapps_option_list_" + data['pid'] + " textarea,#hulkapps_option_list_" + data['pid'] + " select{border:1px solid #DADADA;box-shadow: none;-webkit-appearance: none;padding:10px;min-height: 36px;}#hulkapps_option_list_" + data['pid'] + " .validation_error{color:#FF0808;background-color:#FFF8F7;border-style:solid;border-width:1px;border-color:#FFCBC9;border-bottom: 1px solid #ffcbc9;padding: 8px 8px ;display: inline-block;margin-top: 2px;}#hulkapps_option_list_" + data['pid'] + " .validation_error .hulkapps_option_value{color:#FF0808}#hulkapps_option_list_" + data['pid'] + " .validation_error .hulkapps_option_name{color:#FF0808}.hulkapps_option_value:first-child{display:flex;align-items: center;} .hulkapps_option_value:first-child span{display: flex;padding-right: 10px;}.hulkapps_option_value:first-child a{cursor: pointer;} .hulkapps_helptext{color: #000 !important;}.hulkapps_full_width{width:100%;display:block;}.hulkapps_check_option,.hulkapps_radio_option{display:block;margin-right:0;font-weight:normal !important;}.single_line .hulkapps_option_value .hulkapps_check_option,.single_line .hulkapps_option_value .hulkapps_radio_option{display:inline-flex;margin-right:20px;font-weight:normal; align-items: center; }#hulkapps_option_list_" + data['pid'] + " input[type='checkbox']{margin-right: 5px;vertical-align: baseline;min-height:auto; height: auto;display: none;-webkit-appearance: checkbox;-moz-appearance: checkbox;appearance: checkbox;}.hulkapps_check_option input[type='checkbox']{margin-right:5px;}#hulkapps_option_list_" + data['pid'] + " .radio_input{margin-right:5px;vertical-align:baseline;display: none;}i.hulkapps_tooltip_identifier{color:rgb(255, 255, 255);border-radius:12px;font-size:10px;margin-right:6px;margin-left:4px;padding:0px 4px;background:#000000}span.hulkapps_option_name_additional_info{position:relative}span.hulkapps_option_name_additional_info .hulkapps_tool_tip{display:none}span.hulkapps_option_name_additional_info:hover .hulkapps_tool_tip{content:attr(data-additional-info);padding:4px 8px;color:#fff;position:absolute;left:0;bottom:160%;z-index:20px;-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px;display:block;background:#000000;width:150px}span.hulkapps_option_name_additional_info:hover:after{display:block}i.hulkapps_tooltip_identifier:before{content:'?';font-style:normal}#formatted_option_total{font-weight:bold;margin:0 7px}.td_render .hulkapps_option_name.full_name{float:none;width:auto}.hulkapps_option.full_width .hulkapps_option_name{width:100%;}.hulkapps_option.full_width .hulkapps_option_value{width:100%;display:block;}.hulkapps_option.full_width .hulkapps_option_name{padding-bottom:5px}.hulkapps_option:after{content:'';clear:both;display:block}.hulkapps_option_name a:link {color: grey;text-decoration: none;font-weight: normal;}.hulkapps_option_name a:hover {color: rgb(93, 156, 236);background: transparent;}.hulkapps_swatch_option .hulkapps_option_child:after{border: 1px solid #DADADA;cursor: pointer;content:'';position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px;"+round_corners+"}.hulkapps_mswatch_option .hulkapps_option_child:after{border: 1px solid #DADADA;cursor: pointer;content:'';position:absolute;top:-4px;right:-4px;bottom:-4px;left:-4px; "+round_corners+"}.hulkapps_radio_option .radio_selected{border: 2px solid " + ov_radiobutton_color + ";background:" + ov_radiobutton_color + ";color:#fff;}.radio_div{border: 2px solid #eee;padding: 8px 20px;padding: 6px 12px;}.radio_div:hover{border: 2px solid " + ov_radiobutton_color + ";cursor:pointer;}.tooltip.in{opacity:1 !important;}#option_display_total_format{padding-left:5px;}.hulkapps_swatch_option .tooltip-inner{padding: 0px 5px !important;}.hulkapps_check_option,.hulkapps_radio_option{margin-right:" + single_inline_css + "}.hulkapps_swatch_option,.hulkapps_mswatch_option{ margin-right:10px !important; display: inline-block;vertical-align: middle;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.swatch-tooltip{left: 0 !important;right: auto !important;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.swatch-tooltip:after{right: auto !important;left: 10px !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.swatch-tooltip{right: 0 !important;left: auto !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.swatch-tooltip:after{left: auto !important;right: 10px !important;}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.swatch-tooltip{left: 50% !important;transform: translateX(-50%);}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.swatch-tooltip:after{left: 50% !important;transform: translateX(-50%);}.hulkapps_mswatch_option .swatch_selected:after, .hulkapps_swatch_option .swatch_selected:after{"+swach_selected_border_color+"}.phone_number{padding-left: 50px !important;}#option_total{padding:3px 6px;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.multiswatch-tooltip{left: 0 !important;right: auto !important;}.hulkapps-tooltip.tooltip-left-pos .hulkapps-tooltip-inner.multiswatch-tooltip:after{right: auto !important;left: 10px !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.multiswatch-tooltip{right: 0 !important;left: auto !important;}.hulkapps-tooltip.tooltip-right-pos .hulkapps-tooltip-inner.multiswatch-tooltip:after{left: auto !important;right: 10px !important;}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.multiswatch-tooltip{left: 50% !important;transform: translateX(-50%);}.hulkapps-tooltip.tooltip-center-pos .hulkapps-tooltip-inner.multiswatch-tooltip:after{left: 50% !important;transform: translateX(-50%);}.hulkapps_swatch_option, .hulkapps_mswatch_option{margin-bottom: 10px !important;}.hulkapps_buton_option .hulkapps_option_child{ width: auto;min-height: 36px;padding: 15px;border: 1px solid;border-radius: 0;line-height: 1.13;font-weight: 400;display: flex;justify-content: center;align-items: center;margin-right: 0;margin-bottom: 8px;}.button_selected,.image_customized {color: "+button_option_selected_font_color+" !important;background-color: "+button_option_selected_background+" !important;border-color: "+button_option_selected_border_color+" !important;font-weight: 400 !important;}.hulkapps_option_set input::placeholder,.hulkapps_option_set textarea::placeholder  {color: #a9a9a9;font-size: 16px !important;font-weight: 700;font-family: sans-serif;}.conditional, .is_hulk_hide, .hulk_all_values_hidden{display:none !important}.has-float-label .hulkapps_option_name{display: none !important}.has-float-label .hulkapps_option_value{display: block;width: 100%}.has-inline-label .hulkapps_option_name{display: none !important}.has-inline-label .hulkapps_option_value{display: block;width: 100%}.has-float-label .hulkapps_option_value{ position: relative;}.has-float-label .hulkapps_option_value .floating_label{position: absolute;top: 24%;left: 10px;}input:focus .floating_label { position: absolute;top: 30%;left: 10px;}.has-float-label .hulkapps_option_value textarea,.has-float-label .hulkapps_option_value input,.has-float-label .hulkapps_option_value select{ position: relative;z-index: 1;background-color: transparent;}.has-float-label .hulkapps_option_value .floating_label {position: absolute;top: 24%;left: 10px;transition: all .2s;}.has-float-label .hulkapps_option_value select ~ label.floating_label {cursor: text;opacity: 1;transition: all .2s;top: -0.5em !important;z-index: 3;line-height: 1;padding: 0 1px;left: 10px;position: absolute; z-index: 2;}.has-float-label .hulkapps_option_value input:not(:focus) ~ .floating_label,.has-float-label .hulkapps_option_value textarea:not(:focus) ~ .floating_label {opacity: 1;top: 0.3em;}.has-float-label .hulkapps_option_value input:focus ~ .floating_label,.has-float-label .hulkapps_option_value textarea:focus ~ .floating_label{top: -0.9em !important;z-index: 2;}.has-float-label .hulkapps_option_value .floating_label:after,.has-float-label .hulkapps_option_value input:focus ~ .floating_label:after,.has-float-label .hulkapps_option_value textarea:focus ~ .floating_label:after {content: '';display: block; position: absolute; background: #F7F7F7;height: 2px;top: 50%;left: -0.2em;right: -0.2em;z-index: -1;}.recommended_detail{    position: fixed;z-index: 9999;padding-top: 100px;left: 0;top: 0;width: 100%;height: 100%;background-color: rgba(0,0,0,0.4);overflow: auto;}.recomodation-title { display: flex;padding:20px;}.recomodation_option_desc{ background-color: #fefefe;margin: auto;border: 1px solid #888;max-width: 600px;width: 100%;padding: 20px}.recommended_close_link{ color: #aaaaaa;font-size: 28px;line-height: 18px;float: left;font-weight: lighter;}.recomodation_option_detail{ padding: 10px;padding: 10px;background-color: #f7f7f7;border: 1px solid #d1d1d1;padding: 20px;} #recommended_detail .hulkapps-tooltip-inner,#recommended_detail .hulkapps_option_name .hulkapps-tooltip{display:none;}#recommended_detail input[type='checkbox'],#recommended_detail input[type='radio'] {display: none;}#recommended_detail label,#recommended_detail ul {pointer-events: none;}.font_preview{padding-top: 20px;}.font_preview textarea{ font-size: 40px;}"
                        var all_css = ho_title + oc_style + on_style + ov_style + po_settings + other_css + custom_css + oh_style + ot_style + float_lable_setting + recommended_btn + button_option_continue + button_option_cancel

                        var custom_js = "<script>(function($) {$('.hulkapps_swatch_option, .hulkapps_mswatch_option').mouseover(function() {var x = $(this).find('.hulkapps-tooltip ').position();var right = $(window).width() - x.left - $(this).find('.hulkapps-tooltip ').width();if(x.left < 205){$(this).find('.hulkapps-tooltip ').addClass('tooltip-left-pos');}if(right < 160){$(this).find('.hulkapps-tooltip ').addClass('tooltip-right-pos');}});$(window).width()<=768&&$('.hulkapps-tooltip').each(function(){var t=$(this).position(),i=$(window).width()-t.left-$(this).width(),o=t.left-i;o<50&&o>-50?$(this).addClass('tooltip-center-pos'):t.left<i?$(this).addClass('tooltip-left-pos'):i<t.left&&$(this).addClass('tooltip-right-pos')});" + data['advanced_users']['custom_js'] + "}(hulkapps_jQuery))</script>"
                        var recommended_btn_text = (data['recomodation_setting'] != undefined && data['recomodation_setting']['recomodation_text'] != undefined) ? data['recomodation_setting']['recomodation_text'] : "";
                        var recommended_image_backgrond = (data['recomodation_setting'] != undefined && data['recomodation_setting']['recomodation_background_color'] != undefined) ? data['recomodation_setting']['recomodation_background_color'] : "";
                        var recommended_image_size = (data['recomodation_setting'] != undefined && data['recomodation_setting']['recomodation_font_size'] != undefined) ? data['recomodation_setting']['recomodation_font_size'] : "";
                        var addtocart_html = "<div id='hulkapps_options_" + data['pid'] + "' class="+parentClass+">"
                        var hidden_fields = ''
                        addtocart_html = addtocart_html + hidden_fields + conditional_html + "<style>" + all_css + "</style>" + custom_js
                        window.hulk_inventory_text = (data['display_settings'] != undefined && data['display_settings']['inventory_text'] != undefined) ? data['display_settings']['inventory_text'] : "In stock";
                        window.hulk_out_of_stock_text = (data['display_settings'] != undefined && data['display_settings']['out_of_stock_text'] != undefined) ? data['display_settings']['out_of_stock_text'] : "Out of stock";
                        addtocart_html = addtocart_html + "<div class='hulkapps_option_title'>" + title_text + "</div>"
                        addtocart_html = addtocart_html + "<div id='hulkapps_option_list_" + data['pid'] + "' >"
                        if (amount_note_display !== '' || parseInt(amount_note_display) == 1) {
                            addtocart_html = addtocart_html + "<input type='hidden' id='hulk_amount_dis' value='1'>"
                        } else {
                            addtocart_html = addtocart_html + "<input type='hidden' id='hulk_amount_dis' value='0'>"
                        }
                        var relation = data['relationship']
                        var recomodation_options = data['recomodation_options']
                        var all_html = ''
                        var all_phone_js = ''
                        window.opt_with_otc = {}
                        window.is_hulk_required_options = false
                        var image_change_option_list = []
                        var recommended_html = ''
                        if (data['relationship_option'].length != 0) {
                            if(data['recomodation_options'].length > 0){
                                var recommended_btn_html = "<div class='recommended_btn'><a class='recommended-link'><svg width='"+recommended_image_size+"' height='"+recommended_image_size+"' viewBox='0 0 9 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M4.06442 0.772788C4.25568 0.433466 4.74432 0.433465 4.93558 0.772787L5.81595 2.33474C5.8873 2.46132 6.0102 2.55061 6.15264 2.57935L7.91019 2.93397C8.29201 3.01101 8.443 3.47573 8.17939 3.76248L6.96594 5.08244C6.8676 5.18942 6.82066 5.33389 6.83734 5.47824L7.04319 7.25935C7.08791 7.64629 6.69259 7.9335 6.33841 7.7714L4.70808 7.02523C4.57595 6.96476 4.42405 6.96476 4.29192 7.02523L2.66159 7.7714C2.30741 7.9335 1.91209 7.64629 1.95681 7.25935L2.16266 5.47824C2.17934 5.33389 2.1324 5.18942 2.03406 5.08244L0.82061 3.76249C0.556997 3.47573 0.707994 3.01101 1.08981 2.93397L2.84736 2.57935C2.9898 2.55061 3.1127 2.46132 3.18405 2.33474L4.06442 0.772788Z' fill='"+recommended_image_backgrond+"'/></svg>"+recommended_btn_text+"</a></div>"
                                addtocart_html += recommended_btn_html
                                
                            }
                            
                            var hulkapps_required_html = "<span class='hulkapps-required'> * </span>"
                            addtocart_html = addtocart_html + "<div class='hulkapps_option_set'>"
                            if(window.is_hulk_option_block){
                                var hulk_add_to_cart_ele = null;
                                var selectors = ["input[name='add']", "button[name='add']", "#add-to-cart", "#AddToCartText", "#AddToCart",'form[action$="/cart/add"] input[type="submit"]'];
                                  var found_selectors = 0;
                                  selectors.forEach(function (selector) {
                                      var elements = document.querySelectorAll(selector);
                                      found_selectors += elements.length;
                              
                                      if (hulk_add_to_cart_ele === null && elements.length > 0) {
                                          hulk_add_to_cart_ele = elements[0];
                                      }
                                  });
                              
                                  if (hulk_add_to_cart_ele) {
                                      window.product_form_id = hulk_add_to_cart_ele.closest("form").getAttribute('id');
                                  }
                            }
                            var hdata_form = (window.product_form_id) ? 'form="'+window.product_form_id+'"' : ''

                            $.each(data['relationship_option'], function (key, val) {
                                var option = parseInt(val[0])
                                let com_con_ids = [];
                                for (const [key, value] of Object.entries(a)) {
                                    if (value.includes(option)) {
                                        com_con_ids.push(key);
                                    }
                                }
                                var required = val.length == 3 ? val[1] : (val[1] == 'required' ? val[1] : '' )
                                var image_combine =  val.length == 3 ? val[2] : (val[1] == 'true' ? val[1] : '' )
                                if(image_combine == 'true'){
                                    image_change_option_list.push(parseInt(val[0]))
                                }
                                if (data['option_id_array'].indexOf(option) >= 0) {
                                    var option_name = $.trim(data['option_associative_array'][option]['option_name'])
                                    var is_one_time_charge = $.trim(data['option_associative_array'][option]['is_one_time_charge'])
                                    var option_unique_name = $.trim(data['option_associative_array'][option]['option_unique_name'])
                                    var image_color_position_class = $.trim(data['image_color_position_class'])
                                    var image_color_shape_class = $.trim(data['image_color_shape_class'])
                                    var is_multi_qty_popup_enabled = $.trim(data['option_associative_array'][option]['is_multi_qty_popup'])

                                    var is_font_preview = data['option_associative_array'][option]['is_font_preview']

                                    var font_preview_lable = $.trim(data['option_associative_array'][option]['font_preview_lable'])
                                    var is_view_inventory = data['option_associative_array'][option]['is_view_inventory']

                                    if(is_view_inventory == true){
                                        window.hulk_multi_qty_selector = true
                                    }
                                    

                                    var tooltip_text = $.trim(data['option_associative_array'][option]['tooltip'])
                                    var helptext = $.trim(data['option_associative_array'][option]['helptext'])
                                    var id_name = $.trim(data['option_associative_array'][option]['id_name'])
                                    var idn =  id_name != '' ? 'id="'+id_name+'"' : ''
                                    var class_name = $.trim(data['option_associative_array'][option]['class_name'])
                                    var classn = 'class="'+class_name+'"'
                                    var placeholder = $.trim(data['option_associative_array'][option]['placeholder'])
                                    var tooltip_hyperlink = $.trim(data['option_associative_array'][option]['tooltip_hyperlink'])
                                    var helptext_hyperlink = $.trim(data['option_associative_array'][option]['helptext_hyperlink'])


                                    if (tooltip_text.length > 0)   {
                                        var tooltip =  "<div class='hulkapps-tooltip'><span aria-describedby='tooltip_" + option + "' aria-label='"+tooltip_text+"' tabindex='0' ><img src='" + window.hulkapps.po_url + "/tooltip.svg' style='width:15px;'></span><div class='hulkapps-tooltip-inner' id='tooltip_" + option + "' role='tooltip'>"
                                        if (tooltip_hyperlink.length > 0)   {
                                            var tooltip = tooltip + '<a href="'+tooltip_hyperlink+'" target="_blank"> '+tooltip_text+'</a>' + "</div></div>"

                                        }else{
                                            var tooltip = tooltip + tooltip_text + "</div></div>"
                                        }
                                    }else{
                                        var tooltip = ''
                                    }
                                    if(helptext.length > 0) {
                                        if (helptext_hyperlink.length > 0)   {
                                            var helptext_html = '<span aria-label="'+helptext+'" tabindex="0" class="hulkapps_helptext">' +  '<a href="'+helptext_hyperlink+'" target="_blank"> '+helptext+'</a>'  + "</span>"

                                        }else{
                                            var helptext_html = "<span  aria-label='"+helptext+"' tabindex='0'  class='hulkapps_helptext'>" + helptext + "</span>"
                                        }

                                    }else{
                                        var helptext_html = ''
                                    }
                                    var option_limit = data['option_associative_array'][option]['extra_field']
                                    var option_type = data['option_associative_array'][option]['option_type']
                                    var restrict_past_date = data['option_associative_array'][option]['restrict_past_date']

                                    var is_quantity_selector = data['option_associative_array'][option]['is_quantity_selector']
                                    if (checkPlan('switch_toggle', 'boolean')){
                                        var is_switch_toggle = data['option_associative_array'][option]['is_switch_toggle']
                                    }else{
                                        var is_switch_toggle = false
                                    }
                                    var is_thumbnail_change = data['option_associative_array'][option]['is_thumbnail_change']
                                    var google_fonts = data['option_associative_array'][option]["google_fonts"]
                                    var google_font_with_price = data['option_associative_array'][option]["google_font_with_price"]
                                    var default_selection_google_font = data['option_associative_array'][option]["default_selection_google_font"]
                                    var default_selection_google_price = data['option_associative_array'][option]["default_selection_google_price"]
                                    var option_id = option
                                    var values_json = $.parseJSON(data['option_associative_array'][option]['values_json'])
                                    var is_hide_arr = data['hide_show_array'][option_id] ? data['hide_show_array'][option_id] : ''
                                    let is_com_arr = ''
                                    let new_action_type = ''
                                    var is_value_condition_json = {}
                                    let is_com_val = ""
                                    let is_hide_val = ""
                                    com_con_ids.forEach((item) => {
                                        $.each(data['condition'], function (index, con) {
                                            let condition_id = con['id']
                                            var conditions = hulkapps_jQuery.parseJSON(con['conditions'])
                                            if (condition_id == item) {
                                                $.each(conditions['actions'], function (index, action) {
                                                    // Only this option's own action decides whether it is
                                                    // hidden entirely or by value. A condition can hold actions
                                                    // targeting several options (e.g. hide Option 1 entirely +
                                                    // hide a value of Option 3); without this guard the value
                                                    // action from another option would pollute is_value_condition_json
                                                    // and wrongly drop this option's entire-option hide class.
                                                    if (parseInt(action['option']) !== option) {
                                                        return;
                                                    }
                                                    if (parseInt(action['action_type']) == 1 && is_hide_arr.includes("condition_show")) {
                                                        new_action_type = 'show';
                                                    } else {
                                                        if (is_hide_arr.includes("condition_hide")) {
                                                            new_action_type = 'hide';
                                                        }
                                                    }
                                                    if(new_action_type && checkPlan('enhanced_conditional_logic', 'boolean') && action['action_option_value']){
                                                        if (is_value_condition_json["conditional_logic_" + item + "_" + new_action_type]) {
                                                            is_value_condition_json["conditional_logic_" + item + "_" + new_action_type].push(action['action_option_value'].toString().trim());
                                                        } else {
                                                            is_value_condition_json["conditional_logic_" + item + "_" + new_action_type] = [action['action_option_value'].toString().trim()];
                                                        }
                                                    }
                                                });
                                                $.each(conditions['actions'], function (index, action) {
                                                    if (parseInt(action['option']) !== option) {
                                                        return;
                                                    }
                                                    if (parseInt(action['action_type']) == 1 && is_hide_arr.includes("condition_show")) {
                                                        new_action_type = 'show';
                                                        is_com_arr += " conditional_logic_" + item + "_" + new_action_type
                                                        return false;
                                                    } else {
                                                        if (is_hide_arr.includes("condition_hide")) {
                                                            new_action_type = 'hide';
                                                            is_com_arr += " conditional_logic_" + item + "_" + new_action_type
                                                            return false;
                                                        }
                                                    }
                                                });
                                            }
                                        });
                                    });
                                    if(Object.keys(is_value_condition_json).length > 0){
                                        is_com_val = is_com_arr
                                        is_hide_val = is_hide_arr
                                        is_com_arr = ""
                                        is_hide_arr = ""
                                    }

                                    var is_com_match_val = ''
                                    var is_hide_match_val = ''
                                    var is_required = required == 'required' ? "required" : ''
                                    var aria_require = required == 'required' ? true : false
                                    if(required == 'required'){
                                        window.is_hulk_required_options = true
                                    }
                                    var is_inline = parseInt(option_name_inline) == 0 ? 'full_width' : ''
                                    var is_required_html = required == 'required' ? hulkapps_required_html : ''

                                    var is_enabled_tooltip = data['options_container_style']['enable_tooltip'] == '1' ? tooltip : ''
                                    var is_enable_helptext = (enable_helptext == '1' && helptext_html.length > 0 ) ? "<div class='hulkapps_helptext_div'>" + helptext_html + "</div>" : ''
                                    let opt_with_otc_key = "_hin_"+option_unique_name+"_hin_" + option_name + ""

                                    window.opt_with_otc[opt_with_otc_key] = is_one_time_charge
                                    if(option_type == 'multi_qty_selector'){
                                        window.opt_with_otc[opt_with_otc_key] = true
                                    }
                                    var change_multiple_image_option = image_change_option_list.includes(option)
                                    var is_change_image = ''
                                    if(checkPlan('image_change_based_on_multiple_option_value', 'boolean') && change_multiple_image_option == true){
                                        is_change_image = 'image_change_with_multiple'
                                    }
                                    
                                    
                                    if (option_type == 'dropdown') {

                                        var recommended_value_html = ""
                                        html = "<div class='hulkapps_option dd_render "+  is_change_image +" " + has_float_label + " " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id= " + option_id + ">"
                                        html += "<div role='textbox' aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +"' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"
                                        if(recomodation_options.includes(option)){
                                            recommended_select_html = "<select multiple='true' class='hulkapps_option_child hulkapps_option_" + option_id + "_visible hulkapps_full_width hulkapps_dd hulk_po_dropdown' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-option-key='dd_" + option_id + "' id='" + option_id + "' >"
                                            recommended_value_html +=  html + recommended_select_html 
                                            
                                        }

                                        html += "<select aria-label='"+option_name+"' class='hulkapps_option_child hulkapps_option_" + option_id + "_visible hulkapps_full_width hulkapps_dd hulk_po_dropdown' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-option-key='dd_" + option_id + "' id='" + option_id + "' >"
                                        
                                        if(label_setting == 'inlineLabels'){
                                            placeholder =  option_name
                                        }
                                        if(placeholder == ''){
                                            html += "<option value='' class="+is_com_arr+">Choose " + option_name + "</option>"
                                        }else{
                                            html += "<option value='' class="+is_com_arr+">" + placeholder + "</option>"
                                        }
                                        var is_add_unique_prop = false
                                        var quantity_picker_style = "none"
                                        var valueofhiddenpropinventory = ""
                                        var valueofhiddenprop = ""
                                        var sku_properties = ""
                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                                
                                            }


                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vp2 = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""

                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            if(is_enabled_shopify_default_currency){
                                                if(price != null && price != ""){
                                                    new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                    if(rounding_price){
                                                        new_price = Math.round(new_price);
                                                    }else{
                                                        new_price = new_price; 
                                                    }
                                                    var vp2 = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                }

                                            }
                                            var default_value = ovalue[4]
                                            if (default_value == true){
                                                valueofhiddenprop = ovalue[0].toString().trim() + vp1
                                                quantity_picker_style = "block"
                                            }
                                            var selectedopt = (default_value == true) ? "selected" : ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            var disable_prop = ""
                                            var hide_class = ""
                                            let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                            let inventory_count = parseInt(ovalue[6])
                                            var hinventroy = ""

                                            let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                            let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                            var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                            var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false

                                            var view_inventory = ""
                                            var uniq_val_identifier = ""
                                            var disabled_sku = 'disabled'
                                            if(checkPlan('inventory_and_sku_management', 'boolean')){
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                    if(disabled_out_of_stock.toString() == "true"){
                                                        disable_prop = "disabled"
                                                        selectedopt = ""
                                                    }else{
                                                        hide_class = "is_hulk_hide"
                                                        disable_prop = "disabled"
                                                        selectedopt = ""
                                                    }
                                                }
                                                if(manage_inventory.toString() == "true"){
                                                    is_add_unique_prop = true

                                                }
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                    hinventroy = inventory_count
                                                    if (default_value == true && disable_prop == "") {
                                                        valueofhiddenpropinventory = ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy

                                                    }
                                                    if(is_view_inventory == true  && inventory_count > -1){
                                                            uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                            if(inventory_count == 0){
                                                            view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                            }else{
                                                            view_inventory =  " / " + inventory_count + " " + window.hulk_inventory_text;
                                                            }  
                                                            

                                                    }
                                                }
                                                if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                    disabled_sku = ""
                                                }
                                                if(sku != ""){
                                                    sku_properties = sku_properties+"<input type='hidden' "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' data-sku-identifier='"+ovalue[0].toString().trim()+"' "+disabled_sku+">";
                                                }
                                            }
                                            is_com_match_val = ''
                                            is_hide_match_val = ''
                                            if(Object.keys(is_value_condition_json).length > 0 ){
                                                for (const hide_val in is_value_condition_json) {
                                                    if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                        is_com_match_val += ` ${hide_val} `
                                                        is_hide_match_val = is_hide_val

                                                    }
                                                }
                                            }
                                            data_default_val = selectedopt == 'selected' ? true : false
                                            dropdown_html =  "<option  class='" + opt_class + " " + is_com_match_val + " " + is_hide_match_val + " " + hide_class + "' " + selectedopt + " data-default='"+data_default_val+"' data-hinventory='"+hinventroy+"' "+disable_prop+" data-uid='"+uniq_val_identifier +"' data-display-val='" + ovalue[0].toString().trim() + vp2 +"' data-price='" + vprice + "' data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"'  data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + vp1 + "'>" + ovalue[0].toString().trim() + vp2 + view_inventory +  "</option>"
                                            if(is_recomodation == true){
                                            recommended_value_html +=  dropdown_html
                                            }
                                            html += dropdown_html
                                        });

                                        var unique_prop_html = ""
                                        if(is_add_unique_prop){
                                            unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]' value='"+valueofhiddenpropinventory+"' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "'/>"
                                        }


                                        html += "</select>" + sku_properties + unique_prop_html
                                        if (checkPlan('quantity_selector', 'boolean') && is_quantity_selector) {
                                            html +=  "<input style='display: " + quantity_picker_style + "' type='number' min='1' value='1' class='hulk_options_quantity hulk_po_dropdown_quantity' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' id='quantity_" + option_id + "'/>"
                                        }

                                        html += "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' value='" + valueofhiddenprop + "' class='hulk_dropdown_hidden_prop'/>"

                                        if(label_setting == 'floatingLabels'){
                                            html += "<label class='floating_label'>"+ option_name +"</label>"
                                        }
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += "</select></div></div>"

                                        }
                                        html += "</div></div>"

                                        if(checkPlan('image_change_based_on_option_value', 'boolean') && is_thumbnail_change == true && image_parent != ""){
                                            html += "<script>(function($) {$(document).on('change','.hulkapps_product_options #hulkapps_option_list_" + data['pid'] + " #" + option_id + "', function()  { var option_val  = $(this).find(':selected').data('conditional-value');$('"+image_parent+"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"
                                        }
                                        recommended_html = recommended_html +recommended_value_html

                                        all_html = all_html + html
                                    } else if (option_type == 'dropdown_multiple') {
                                        var recommended_value_html = ""
                                        var min_selection = option_limit != undefined && option_limit != '' && option_limit['minimum_selection'] != '' && option_limit['minimum_selection'] != undefined ? option_limit['minimum_selection'].toString() : '0'
                                        var max_selection = option_limit != undefined && option_limit != '' && option_limit['maximum_selection'] != '' && option_limit['maximum_selection'] != undefined ? option_limit['maximum_selection'].toString() : '0'
                                        var selection_text = (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}]</span>` : (min_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean',data['plan_id'],data['plans_features'])) ? `<span aria-label="${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}]</span>` : (max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}]</span>` : '';
                                        var html = "<div class='hulkapps_option dd_multi_render " + has_float_label + " " + is_com_arr + " " + is_required + " " + is_inline + "  option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        var data_min = min_selection != undefined ? min_selection : ''
                                        var data_max = max_selection != undefined ? max_selection : ''
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + selection_text + "" + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"
                                        html += "<select multiple class='hulkapps_option_child hulkapps_option_" + option_id + "_visible hulkapps_full_width hulkapps_dd hulk_po_dropdown_multiple' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-option-key='dd_" + option_id + "' id='" + option_id + "' name='hulkapps_multiple_dropdown' style='background:none;' data-min='" + min_selection + "' data-max='" + max_selection + "'>"
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += html
                                            
                                        }
                                        var valueofhiddenprop = []
                                        var valueofhiddenpropinventory = []
                                        var default_count = 0
                                        if(label_setting == 'inlineLabels'){
                                            placeholder =  option_name
                                        }
                                        if(placeholder != ''){
                                            html += "<option value='' class="+is_com_arr+">" + placeholder + "</option>"
                                        }
                                        var sku_properties = ""
                                        $.each(values_json, function (index, ovalue) {
                                            var view_inventory = ''
                                            var uniq_val_identifier = ''
                                            is_com_match_val = ''
                                            is_hide_match_val = ''
                                            if(Object.keys(is_value_condition_json).length > 0 ){
                                                for (const hide_val in is_value_condition_json) {
                                                    if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                        is_com_match_val += ` ${hide_val} `
                                                        is_hide_match_val = is_hide_val

                                                    }
                                                }
                                            }
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                                
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vp2 = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'

                                            if(is_enabled_shopify_default_currency){
                                                if(price != null && price != ""){
                                                    new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                    if(rounding_price){
                                                        new_price = Math.round(new_price);
                                                    }else{
                                                        new_price = new_price; 
                                                    }
                                                    var vp2 = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                }

                                            }

                                            var default_value = ovalue[4]
                                            if (default_value == true) {
                                                default_count += 1
                                                valueofhiddenprop.push(ovalue[0].toString().trim() + vp1)
                                            }

                                            var selectedopt = (default_value == true) ? "selected" : ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            var disable_prop = ""
                                            var hide_class = ""
                                            let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                            let inventory_count = parseInt(ovalue[6])
                                            var hinventroy = ""
                                            let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                            let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                            var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                            var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false

                                            var disabled_sku = 'disabled'

                                            if(checkPlan('inventory_and_sku_management', 'boolean')){
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                    if(disabled_out_of_stock.toString() == "true"){
                                                        disable_prop = "disabled"
                                                        selectedopt = ""
                                                        opt_class = ""
                                                        if (default_value == true) {
                                                            valueofhiddenprop.pop(ovalue[0].toString().trim() + vp1)
                                                        }
                                                    }else{
                                                        hide_class = "is_hulk_hide"
                                                        disable_prop = "disabled"
                                                        selectedopt = ""
                                                        opt_class = ""
                                                        if (default_value == true) {
                                                            valueofhiddenprop.pop(ovalue[0].toString().trim() + vp1)
                                                        }
                                                    }
                                                }
                                                if(manage_inventory.toString() == "true"){
                                                    is_add_unique_prop = true

                                                }
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                    hinventroy = inventory_count
                                                    if (default_value == true && hide_class == "" && disable_prop == "") {
                                                        valueofhiddenpropinventory.push(ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy)
                                                    }
                                                    if(is_view_inventory == true &&inventory_count > -1 ){
                                                        uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                        if(inventory_count == 0){
                                                        view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                        }else{
                                                        view_inventory =  " / " + inventory_count + " " + window.hulk_inventory_text; 
                                                        }
                                                    }
                                                }
                                                if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                    disabled_sku = ""
                                                }
                                                if(sku != ""){
                                                    sku_properties = sku_properties+"<input type='hidden' "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' data-sku-identifier='"+ovalue[0].toString().trim()+"' "+disabled_sku+">";
                                                }
                                            }
                                            data_default_val = selectedopt == 'selected' ? true : false
                                            html_drop_multi = "<option class='" + is_com_match_val + " " + is_hide_match_val + " " + opt_class + " " + hide_class + "' " + selectedopt + " data-default='"+data_default_val+"' data-hinventory='"+hinventroy+"' "+disable_prop+"  data-uid='"+uniq_val_identifier +"' data-display-val='" + ovalue[0].toString().trim() + vp2 +"'  data-price='" + vprice + "' data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + vp1 + "'>" + ovalue[0].toString().trim() + vp2 + view_inventory +"</option>"
                                            if(is_recomodation == true){
                                                recommended_value_html +=  html_drop_multi
                                            }
                                            html += html_drop_multi
                                        });
                                        if (default_count > 0) {
                                            if (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean')) {
                                                if (parseInt(default_count) < parseInt(min_selection) || parseInt(default_count) > parseInt(max_selection)) {
                                                    html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`
                                                }
                                            } else if (min_selection != '0' && max_selection == '0' && checkPlan('validation_for_min_max_option_selection', 'boolean')) {
                                                if (parseInt(default_count) < parseInt(min_selection)) {
                                                    html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`
                                                }
                                            } else if (min_selection == '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean')) {
                                                if (parseInt(default_count) > parseInt(max_selection)) {
                                                    html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`
                                                }
                                            }
                                        }
                                        var validation_error = '<span class=\"validation_error error_span\" >'
                                        if(label_setting == 'floatingLabels'){
                                            html += "</select><label class='floating_label'>"+ option_name +"</label>"
                                        }
                                        var unique_prop_html = ""
                                        if(is_add_unique_prop){
                                            unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]' value='" + valueofhiddenpropinventory + "' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "' data-selection-multi='true'/>"
                                        }
                                        html +=  sku_properties + unique_prop_html
                                        html += "<input class='hulkapps_option_child' type='hidden' value='" + valueofhiddenprop.join(', ') + "' id='hulkapps_option_" + option_id + "_hidden' "+hdata_form+"  name='properties[" + option_name + "]'></div></div>"
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += "</select></div></div>"

                                        }
                                        recommended_html = recommended_html +recommended_value_html

                                        all_html = all_html + html
                                    } else if (option_type == 'swatch') {

                                        var swatchcount = 0
                                        var recommended_value_html = ""
                                        var html = "<div class='hulkapps_option swatch_render "+  is_change_image +" " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "' >"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += html
                                            
                                        }
                                        var is_add_unique_prop = false
                                        var valueofhiddenpropinventory = ""
                                        var valueofhiddenprop = ""
                                        var quantity_picker_style = "none"
                                        var is_tab_index = false
                                        $.each(values_json, function (index, ovalue) {
                                            is_com_match_val = ''
                                            is_hide_match_val = ''
                                            if(Object.keys(is_value_condition_json).length > 0 ){
                                                for (const hide_val in is_value_condition_json) {
                                                    if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                        is_hide_match_val = is_hide_val
                                                        is_com_match_val += ` ${hide_val} `
                                                    }
                                                }
                                            }
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                                
                                            }
                                            var swatch_text = (ovalue[0] != '') ? ovalue[0] : ''
                                            var swatch_type = (ovalue[2] != '') ? ovalue[2] : ''
                                            var swatch_val = (ovalue[3] != '') ? ovalue[3] : ''
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vp = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'

                                            if(is_enabled_shopify_default_currency){
                                                if(price != null && price != ""){
                                                    new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                    if(rounding_price){
                                                        new_price = Math.round(new_price);
                                                    }else{
                                                        new_price = new_price; 
                                                    }
                                                    var vp = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                }

                                            }
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            var default_value = ovalue[4]
                                            if (default_value == true){
                                                valueofhiddenprop = ovalue[0].toString().trim() + vp1
                                                quantity_picker_style = "block"
                                            }
                                            var selectedopt = (default_value == true) ? "swatch_selected" : ''
                                            var checkdopt = (default_value == true) ? "checked" : ''
                                            
                                            var disable_prop = ""
                                            var disable_class = ""
                                            var hide_class = ""
                                            let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                            let inventory_count = parseInt(ovalue[6])
                                            var hinventroy = ""
                                            let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                            let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                            var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                            var sku_properties = ""
                                            var disabled_sku = "disabled"
                                            var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false
                                            var view_inventory = ""
                                            var uniq_val_identifier = ''
                                            var swatch_title = "<p>" + ovalue[0] + " <br> " + vp + "</p>"
                                            if(checkPlan('inventory_and_sku_management', 'boolean')){
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                    if(disabled_out_of_stock.toString() == "true"){
                                                        disable_class = "is_hulk_disabled"
                                                        disable_prop = "disabled"
                                                        selectedopt = " "
                                                        opt_class = " "
                                                    }else{
                                                        hide_class = "is_hulk_hide"
                                                        disable_prop = "disabled"
                                                        selectedopt = ''
                                                        opt_class = ""
                                                    }
                                                }
                                                if(manage_inventory.toString() == "true"){
                                                    is_add_unique_prop = true

                                                }
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                    hinventroy = inventory_count
                                                    if(default_value == true && hide_class == "" && disable_prop == ""){
                                                        valueofhiddenpropinventory = ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy
                                                    }
                                                    if(is_view_inventory == true &&inventory_count > -1 ){

                                                        uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`

                                                        if(inventory_count == 0){
                                                        view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                        }else{
                                                        if(price != null && price != ""){
                                                            view_inventory =  " / <p class='hulk_stock' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"  + inventory_count + " " + window.hulk_inventory_text + "</p>";

                                                            
                                                        }else{
                                                            view_inventory =   "<p class='hulk_stock' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"+inventory_count + " " + window.hulk_inventory_text + "</p>"; 
                                                        }
                                                        }
                                                    }
                                                }
                                            
                                                var swatch_title = "<p>" + ovalue[0] + " <br> " + vp + view_inventory + "</p>"
                                            
                                                if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                    disabled_sku = ""
                                                }
                                                if(sku != ""){
                                                    sku_properties = "<input type='hidden' "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' "+disabled_sku+">";
                                                }
                                            }

                                            var s_image = ''
                                            if (swatch_type == 'image') {
                                                swatch_style = "background-image:url(" + swatch_val + "); background-size:cover;background-position: center center;" + round_corners + ""
                                                swatch_image = "data-image='" + swatch_val + "'"
                                                s_image = swatch_val
                                            } else {
                                                try {
                                                    var swatch_color_option = swatch_val.split(",")
                                                } catch (err) {
                                                    swatch_color_option = null
                                                }
                                                if (swatch_color_option != null) {
                                                    if (swatch_color_option[1] != undefined) {
                                                        swatch_color_dual_ton = "background: linear-gradient(to bottom, " + swatch_color_option[0] + " 0%, " + swatch_color_option[0] + " 50%, " + swatch_color_option[1] + " 50%, " + swatch_color_option[1] + " 100%); " + round_corners + ""
                                                        var swatch_style = swatch_color_dual_ton
                                                        var swatch_image = "data-image=''"
                                                    } else {
                                                        var swatch_style = "background-color:" + swatch_color_option[0] + ";" + round_corners + ""
                                                        var swatch_image = "data-image=''"
                                                    }
                                                }
                                            }
                                            if (swatch_title != undefined) {
                                                if (swatch_val != undefined) {
                                                    if (tooltip_contains == "both") {
                                                        var titlee = "<div style='text-align:center;'><div class='swatch_tooltip_title'> " + swatch_title + "</div><div class='swatch_tooltip_data' style='width:100%;padding-top:100%;display: block !important;" + swatch_style + "'></div></div>"
                                                    } else if (tooltip_contains == "image_only") {
                                                        titlee = "<div style='text-align:center;'><div class='swatch_tooltip_data' style='width:100%;padding-top:100%;display: block !important;" + swatch_style + "'></div></div>"
                                                    } else {
                                                        titlee = "<div style='text-align:center;'><div class='swatch_tooltip_title'> " + swatch_title + "</div></div>"
                                                    }
                                                } else {
                                                    titlee = "<div style='text-align:center;'><div class='swatch_tooltip_title'> " + swatch_title + "</div></div>"
                                                }
                                            } else {
                                                titlee = "<div style='text-align:center;'><div class='swatch_tooltip_title'></div></div>"
                                            }
                                            tooltip_val = "<div class='hulkapps-tooltip-inner swatch-tooltip' style='width:200px;'><div>" + titlee + "</div></div>"
                                            tooltip_display_html = parseInt(tooltip_display) == 1 ? tooltip_val : ''
                                            swatch_with_text = parseInt(enable_swatch_with_text) == 1 ? swatch_text : ''
                                            if(index == '0' && hide_class == ''){
                                                var tabindex = 0
                                                is_tab_index = true
                                            }else if(index != '0' && is_tab_index == false){
                                                var tabindex = 0
                                                is_tab_index = true
                                            }else{
                                                var tabindex = -1
                                            }
                                            data_default_val = selectedopt == 'swatch_selected' ? true : false
                                            var swatch_html = "<label aria-label='"+ovalue[0].toString().trim()+" "+ vp1 +"' tabindex='"+tabindex+"' class='hulkapps_swatch_option " + hide_class + " " + is_com_match_val + " " + is_hide_match_val + " "+disable_class+"' ><div class='hulkapps-tooltip " + tooltip_position + "'>" + tooltip_display_html + "<div class='  '><div id='" + option_id + "_" + swatchcount + "' data-single_valid-class='swatch_render' data-val-selected-class='swatch_selected' data-radio-class='swatch_radio' data-hidden-class='hulk_swatch_hidden_prop' data-oid='" + option_id + "' data-option-key='rb_" + option_id + "_" + swatchcount + "' class='hulk_po_radio hulkapps_option_child " + selectedopt + " hulkapps_option_" + option_id + " " + opt_class + " '  data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' value='" + ovalue[0].toString().trim() + "' style='" + swatch_width + swatch_height + swatch_style + "' " + tooltip_position + "><input name='hulk_swatch_"+ option_id +"' type='radio'  data-default='"+data_default_val+"' data-hinventory='"+hinventroy+"' "+ disable_prop +" value='" + ovalue[0].toString().trim() + vp1 + "' class=' swatch_radio' " + checkdopt + " style='display:none;' " + swatch_image + " ></div></div></div><div style='display: inline-block;vertical-align: middle;margin-left: 10px;'>" + swatch_with_text + "</div>"+ sku_properties+"</label>"
                                            if(is_recomodation == true){
                                                recommended_value_html +=  swatch_html
                                            }
                                            html += swatch_html
                                            swatchcount += 1
                                        });
                                        var unique_prop_html = ""
                                        if(is_add_unique_prop){
                                            unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]' value='"+ valueofhiddenpropinventory +"' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "' />"
                                        }
                                        html += unique_prop_html
                                        if (checkPlan('quantity_selector', 'boolean') && is_quantity_selector) {
                                            html += "<input style='display: " + quantity_picker_style + "'type='number' min='1' value='1' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' class='hulk_options_quantity hulk_po_swatch_quantity'  id='quantity_" + option_id + "'/>"
                                        }
                                        html +="<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' value='"+valueofhiddenprop+"' class='hulk_swatch_hidden_prop'/>" + "</div></div>"
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += "</div></div>"

                                        }

                                        if(checkPlan('image_change_based_on_option_value', 'boolean' ) && is_thumbnail_change == true && image_parent != ""){
                                            html += "<script>(function($) {$('.hulkapps_product_options').on('click change', '.hulkapps_option_" + option_id + "', function() { var option_val  = $(this).data('conditional-value');$('"+image_parent+"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"
                                        }
                                        recommended_html = recommended_html +recommended_value_html
                                        all_html = all_html + html
                                    } else if (option_type == 'color_image_dropdown') {
                                        if (checkPlan('color_image_dropdown', 'boolean' )) {
                                            var recommended_value_html = ""

                                            html = "<div class='hulkapps_option ci_render dd_render "+  is_change_image +" " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " " + class_name + "' " + idn + " data-parent-id= " + option_id + ">"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name' data-option-name='"+option_name+"'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value hulkapps_product_options_ul_parent'>"
                                            html += "<ul data-parent='" + parentClass + "' data-pid='" + data['pid'] + "'  data-val-selected-class='dropdown_selected' class='hulkapps_option_child hulkapps_product_options_ul hulkapps_option_" + option_id + "_visible hulkapps_full_width hulkapps_dd ' data-option-key='dd_" + option_id + "' id='" + option_id + "' >"
                                            if(recomodation_options.includes(option)){
                                                recommended_value_html += html
                                                
                                            }
                                            var init_html = ""
                                            if (placeholder == '') {
                                                init_html = "<li tabindex='0' value='' class='init'>Choose " + option_name + "</li>"
                                            } else {
                                                init_html = "<li value='' tabindex='0' class='init'>" + placeholder + "</li>"
                                            }
                                            var option_li_html = ""
                                            var is_add_unique_prop = false
                                            var valueofhiddenpropinventory = ""
                                            var valueofhiddenprop = ""
                                            var quantity_picker_style = "none"
                                            var is_tab_index = false
                                            var default_selected_html = ""
                                            var default_selected_tabindex = 0
                                            
                                            $.each(values_json, function (index, ovalue) {
                                                var dropdown_type = "image"
                                                if (ovalue[2] == "color") {
                                                    dropdown_type = "color"
                                                }
                                                var dropdown_value = ovalue[3]
                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if (option_charge_type == 'percentage_charge' && price != null && price != "") {
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" && checkPlan('multiplication_charge',true)){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true

                                                }
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vp2 = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'
                                                var vactual_price = (ovalue[14] != null && ovalue[14] != "") ? ovalue[14] : ''
                                                if(is_enabled_shopify_default_currency){
                                                    if(price != null && price != ""){
                                                        new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                        if(rounding_price){
                                                            new_price = Math.round(new_price);
                                                        }else{
                                                            new_price = new_price; 
                                                        }
                                                        var vp2 = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""
    
                                                    }
    
                                                }
                                                var default_value = ovalue[4]

                                                var selectedopt = (default_value == true) ? "selected" : ''
                                                var checkdopt = (default_value == true) ? "dropdown_selected" : ''
                                                var opt_class = vprice != '' ? 'price-change' : ''
                                                var disable_class = ''
                                                var disable_prop = ""
                                                var hide_class = ""
                                                let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                                let inventory_count = parseInt(ovalue[6])
                                                var hinventroy = ""

                                                let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                                let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                                var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                                var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false


                                                var sku_properties = ""
                                                var disabled_sku = "disabled"
                                                var view_inventory = ""
                                                var uniq_val_identifier = ""
                                                if (checkPlan('inventory_and_sku_management', 'boolean' )) {
                                                    if (manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0) {
                                                        if (disabled_out_of_stock.toString() == "true") {
                                                            disable_prop = "disabled"
                                                            disable_class = "is_hulk_disabled"
                                                            selectedopt = ""
                                                        } else {
                                                            hide_class = "is_hulk_hide"
                                                            disable_prop = "disabled"
                                                            selectedopt = ""
                                                        }
                                                    }
                                                    if (manage_inventory.toString() == "true") {
                                                        is_add_unique_prop = true

                                                    }
                                                    if (manage_inventory.toString() == "true" && is_continue_selling.toString() != "true") {
                                                        hinventroy = inventory_count
                                                        if (default_value == true && disable_prop == "") {
                                                            valueofhiddenpropinventory = ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy
                                                        }
                                                        if(is_view_inventory == true  && inventory_count > 0){
                                                            uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                            if(inventory_count == 0){
                                                                view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                            }else{
                                                            view_inventory =  " / " + inventory_count + " " + window.hulk_inventory_text;
                                                            }
                                                            
                                                        }else if(is_view_inventory == true  && inventory_count < 0){
                                                            uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                            view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                        }
                                                    }
                                                    if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                        disabled_sku = ""
                                                    }
                                                    if(sku != ""){
                                                        sku_properties = "<input type='hidden' "+hdata_form+" name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' "+disabled_sku+">";
                                                    }
                                                }
                                                is_com_match_val = ''
                                                is_hide_match_val = ''
                                                if(Object.keys(is_value_condition_json).length > 0 ){
                                                    for (const hide_val in is_value_condition_json) {
                                                        if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                            is_com_match_val += ` ${hide_val} `
                                                            is_hide_match_val = is_hide_val
                                                        }
                                                    }
                                                }
                                                if(index == '0' && hide_class == ''){
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                }else if(index != '0' && is_tab_index == false){
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                }else{
                                                    var tabindex = -1
                                                }
                                                if(default_value == true){
                                                    valueofhiddenprop = ovalue[0].toString().trim() + vp1
                                                    quantity_picker_style = "block"
                                                    // Store the selected value's HTML to display in init_html
                                                    default_selected_html = "<span class='dropdown-text'>" + ovalue[0].toString().trim() + vp2 + "</span>"
                                                    if (dropdown_type == "image") {
                                                        default_selected_html = default_selected_html + "<span class='dropdown_img " + image_color_shape_class + "'><img class='' src=" + dropdown_value + "></span>"
                                                    } else {
                                                        default_selected_html = default_selected_html + "<span class='dropdown_color " + image_color_shape_class + "' style='background-color: " + dropdown_value + "'></span>"
                                                    }
                                                    default_selected_tabindex = tabindex
                                                }

                                                data_default_val = selectedopt == 'selected' ? true : false
                                                li_html =  "<li aria-label='"+ovalue[0].toString().trim()+ vp1 + "' tabindex='"+tabindex+"'  class='dropdown_swatch " + image_color_position_class + " " + disable_class + " " + opt_class + " " + is_com_match_val + " " + is_hide_match_val + " " + hide_class + " "+ checkdopt +"' " + selectedopt + " data-default='"+data_default_val+"' data-hinventory='" + hinventroy + "' data-uid='"+uniq_val_identifier +"' data-display-val='" + ovalue[0].toString().trim() + vp2 +"' " + disable_prop + " data-price='" + vprice + "' data-actual_price='" + vactual_price + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' data-value='" + ovalue[0].toString().trim() + vp1 + "' value='" + ovalue[0].toString().trim() + vp1 + "'><span class='dropdown-text'>" + ovalue[0].toString().trim() + vp2 + view_inventory + "</span>"
                                                if (dropdown_type == "image") {
                                                    li_html = li_html + "<span class='dropdown_img " + image_color_shape_class + "'><img class='' src=" + dropdown_value + "></span>"+sku_properties+"</li>"
                                                } else {
                                                    li_html = li_html + "<span class='dropdown_color " + image_color_shape_class + "' style='background-color: " + dropdown_value + "'></span>"+sku_properties+"</li>"
                                                }
                                                option_li_html = option_li_html + li_html
                                                if(is_recomodation == true){
                                                    recommended_value_html += li_html
                                                }
                                            });

                                            // If a default value is selected, update init_html to show it
                                            if(default_selected_html != ""){
                                                if (placeholder == '') {
                                                    init_html = "<li aria-label='Choose " + option_name + "' tabindex='"+default_selected_tabindex+"' value='' class='init'>" + default_selected_html + "</li>"
                                                } else {
                                                    init_html = "<li aria-label='"+placeholder+"' tabindex='"+default_selected_tabindex+"' value='' class='init'>" + default_selected_html + "</li>"
                                                }
                                            }
                                            
                                            // Add placeholder as a selectable option in the dropdown list for unselecting
                                            var placeholder_option_html = ""
                                            if (placeholder == '') {
                                                placeholder_option_html = "<li aria-label='Choose " + option_name + "' tabindex='0' value='' class='dropdown_swatch placeholder-option' data-uid='' data-display-val='Choose " + option_name + "' data-hinventory='' data-value='' data-price='0.00' data-variant-id='' data-shipping-weight='' data-conditional-value=''><span class='dropdown-text'>Choose " + option_name + "</span></li>"
                                            } else {
                                                placeholder_option_html = "<li aria-label='"+placeholder+"' tabindex='0' value='' class='dropdown_swatch placeholder-option' data-uid='' data-display-val='"+placeholder+"' data-hinventory='' data-value='' data-price='0.00' data-variant-id='' data-shipping-weight='' data-conditional-value=''><span class='dropdown-text'>" + placeholder + "</span></li>"
                                            }
                                            
                                            html = html + init_html + placeholder_option_html + option_li_html
                                            var unique_prop_html = ""
                                            if (is_add_unique_prop) {
                                                unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_" + option_unique_name + "_hin_" + option_name + "]' value='" + valueofhiddenpropinventory + "' class='hulk_unique_prop' data-unique_prop_name='_hin_" + option_unique_name + "_hin_" + option_name + "'/>"
                                            }
                                            html += "<input class='hulk_opt_prop' "+hdata_form+"   type='hidden' name='properties[" + option_name + "]'  value='"+valueofhiddenprop+"'/></ul>"
                                            if(recomodation_options.includes(option)){
                                                recommended_value_html =  recommended_value_html  + "</ul></div></div>"

                                            }
                                            if (checkPlan('quantity_selector', 'boolean' ) && is_quantity_selector) {
                                                html += "<input style='display: " + quantity_picker_style + "' type='number' min='1' value='1' class='hulk_options_quantity' id='quantity_" + option_id + "'/>"
                                            }
                                            html +=  unique_prop_html + "</div></div>"
                                            recommended_html = recommended_html +recommended_value_html


                                            all_html = all_html + html
                                        }
                                    }else if (option_type == 'button') {
                                        if (checkPlan('button_option', 'boolean' )) {
                                            var buttoncount = 0
                                            var recommended_value_html = ""
                                            var html = "<div class='hulkapps_option button_render "+  is_change_image +" " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "' >"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value'>"
                                            if(recomodation_options.includes(option)){
                                                recommended_value_html += html
                                                
                                            }
                                            var is_add_unique_prop = false
                                            var valueofhiddenpropinventory = ""
                                            var valueofhiddenprop = ""
                                            var quantity_picker_style = "none"
                                            var is_tab_index = false
                                            $.each(values_json, function (index, ovalue) {
                                                is_com_match_val = ''
                                                is_hide_match_val = ''
                                                if(Object.keys(is_value_condition_json).length > 0 ){
                                                    for (const hide_val in is_value_condition_json) {
                                                        if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                            is_com_match_val += ` ${hide_val} `
                                                            is_hide_match_val = is_hide_val
                                                        }
                                                    }
                                                }

                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }
                                                var button_text = (ovalue[0] != '') ? ovalue[0] : ''
                                                var button_val = (ovalue[2] != '') ? ovalue[2] : ''
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vp = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'

                                                if(is_enabled_shopify_default_currency){
                                                    if(price != null && price != ""){
                                                        new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                        if(rounding_price){
                                                            new_price = Math.round(new_price);
                                                        }else{
                                                            new_price = new_price; 
                                                        }
                                                        var vp = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""
    
                                                    }
    
                                                }
                                                var opt_class = vprice != '' ? 'price-change' : ''
                                                var default_value = ovalue[4]
                                                if (default_value == true){
                                                    valueofhiddenprop = ovalue[0].toString().trim() + vp1
                                                    quantity_picker_style = "block"


                                                }
                                                var selectedopt = (default_value == true) ? "button_selected" : ''
                                                var checkdopt = (default_value == true) ? "checked" : ''
                                                var disable_class = ""
                                                var disable_prop = ""
                                                var hide_class = ""
                                                let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                                let inventory_count = parseInt(ovalue[6])
                                                var hinventroy = ""
                                                let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                                let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""

                                                var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                                var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false

                                                var sku_properties = ""
                                                var disabled_sku = "disabled"
                                                var view_inventory = ""
                                                var uniq_val_identifier = ""
                                                if(checkPlan('inventory_and_sku_management', 'boolean' )){
                                                    if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                        if(disabled_out_of_stock.toString() == "true"){
                                                            disable_class = "is_hulk_disabled"
                                                            disable_prop = "disabled"
                                                            opt_class = ''
                                                            selectedopt = ''
                                                        }else{
                                                            hide_class = "is_hulk_hide"
                                                            disable_prop = "disabled"
                                                            opt_class = ''
                                                            selectedopt = ''
                                                        }
                                                    }
                                                    if(manage_inventory.toString() == "true"){
                                                        is_add_unique_prop = true

                                                    }
                                                    if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                        hinventroy = inventory_count
                                                        if(default_value == true && hide_class == "" && disable_prop == ""){
                                                            valueofhiddenpropinventory = ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy
                                                        }
                                                        if(is_view_inventory == true && inventory_count > -1 ){
                                                            uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}` 
                                                            if(inventory_count == 0){
                                                                view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                            }else{
                                                            if(price != null && price != ""){
                                                                view_inventory =  " / <p class='hulk_stock' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"  + inventory_count + " " + window.hulk_inventory_text + "</p>"; 

                                                            }else{
                                                                view_inventory =   "<p class='hulk_stock' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"+inventory_count + " " + window.hulk_inventory_text + "</p>"; 
                                                            }
                                                            }

                                                        }
                                                    }
                                                    if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                        disabled_sku = ""
                                                    }
                                                    if(sku != ""){
                                                        sku_properties = "<input type='hidden' "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku'"+disabled_sku+" />";
                                                    }
                                                }
                                                //var button_title = "<p>"+ovalue[0]+" <br> "+vp+"</p>"
                                                var button_title = ovalue[0] + " <br> " + vp  + view_inventory

                                                if (button_title != undefined) {
                                                    titlee = "<div style='text-align:center;'><div class='button_tooltip_title'> " + button_title + "</div></div>"
                                                } else {
                                                    titlee = "<div style='text-align:center;'><div class='button_tooltip_title'></div></div>"
                                                }
                                                //tooltip_val = "<div class='hulkapps-tooltip-inner button-tooltip' style='width:200px;'><div>"+titlee+"</div></div>"
                                                tooltip_val = "<div class='hulkapps-tooltip-inner button-tooltip'>" + button_title + "</div>"

                                                tooltip_display_html = parseInt(tooltip_display) == 1 ? tooltip_val : ''
                                                if(index == '0' && hide_class == ''){
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                }else if(index != '0' && is_tab_index == false){
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                }else{
                                                    var tabindex = -1
                                                }
                                                data_default_val = selectedopt == 'button_selected' ? true : false
                                                html_btn = "<label aria-label='"+ovalue[0].toString().trim()+" "+vp1+"'  tabindex='"+tabindex+"' class='hulkapps_buton_option "+hide_class+" "+disable_class+"'><div class='hulkapps-tooltip'>" + tooltip_display_html + "<div class='"+is_com_match_val+" "+is_hide_match_val+" '><div id='" + option_id + "_" + buttoncount + "' data-option-key='rb_" + option_id + "_" + buttoncount + "' class='hulkapps_option_child " + selectedopt + " hulkapps_option_" + option_id + " " + opt_class + " hulk_po_radio'  data-hidden-class='hulk_button_hidden_prop'  data-single_valid-class='button_render' data-val-selected-class='button_selected' data-radio-class='button_radio' data-oid='" + option_id + "' data-pid='" + data['pid'] + "' data-parent='" + parentClass + "' data-price='" + vprice + "'  data-variant-id='" + ovalue[12] + "' data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + "' style='" + button_option_background + button_option_font_color + button_option_border_color + "'><input name='hulk_button_"+option_id+"' type='radio' "+disable_prop +" data-default='" + data_default_val + "' data-hinventory='"+hinventroy+"' value='" + ovalue[0].toString().trim() + vp1 + "' class=' button_radio' " + checkdopt + " style='display:none;'><span>" + button_val + "</span></div></div></div>"+sku_properties +"</label>"
                                                if(is_recomodation == true){
                                                    recommended_value_html +=  html_btn
                                                }
                                                html += html_btn
                                                buttoncount += 1
                                            });
                                            var unique_prop_html = ""
                                            if(is_add_unique_prop){
                                                unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]' value='"+valueofhiddenpropinventory+"' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "'/>"
                                            }

                                            html += unique_prop_html
                                            if (checkPlan('quantity_selector', 'boolean' ) && is_quantity_selector) {
                                                html += "<input style='display: " + quantity_picker_style + "' type='number' min='1' value='1' class='hulk_options_quantity hulk_po_button_quantity' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' id='quantity_" + option_id + "'/>"
                                            }
                                            html += "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' value='"+valueofhiddenprop+"' class='hulk_button_hidden_prop'/>" + "</div></div>"
                                            if(recomodation_options.includes(option)){
                                                recommended_value_html += "</div></div>"

                                            }

                                            if(checkPlan('image_change_based_on_option_value', 'boolean' ) && is_thumbnail_change == true && image_parent != ""){
                                                html += "<script>(function($) {$('.hulkapps_product_options .hulkapps_option_" + option_id + "').on('click change', function() { var option_val  = $(this).data('conditional-value');$('"+image_parent+"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"

                                            }
                                            recommended_html = recommended_html +recommended_value_html

                                            all_html = all_html + html
                                        }
                                    } else if (option_type == 'swatch_multiple') {
                                        if (checkPlan('multiple_swatch_select_option', 'boolean' ) || (checkPlan('multiple_swatch_select_option', 'boolean' ) == false && oldStore() == true) ) {

                                        var recommended_value_html = ""

                                        var min_selection = option_limit != undefined && option_limit['minimum_selection'] != undefined && option_limit != '' && option_limit['minimum_selection'] != '' ? option_limit['minimum_selection'].toString() : '0'
                                        var max_selection = option_limit != undefined && option_limit['maximum_selection'] != undefined && option_limit != '' && option_limit['maximum_selection'] != '' ? option_limit['maximum_selection'].toString() : '0'
                                        var swatchcount = 0
                                        var selection_text = (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}]</span>` : (min_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean',data['plan_id'],data['plans_features'])) ? `<span aria-label="${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}]</span>` : (max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}]</span>` : '';

                                        var html = "<div class='hulkapps_option multiswatch_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "' data-min='" + min_selection + "' data-max='" + max_selection + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'><div>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + "</div> " + selection_text + " " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += html
                                            
                                        }
                                        var valueofhiddenprop = []
                                        var default_count = 0
                                        var valueofhiddenpropinventory = []
                                        var is_tab_index = false
                                        $.each(values_json, function (index, ovalue) {
                                            is_com_match_val = ''
                                            is_hide_match_val = ''
                                            if(Object.keys(is_value_condition_json).length > 0 ){
                                                for (const hide_val in is_value_condition_json) {
                                                    if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                        is_com_match_val += ` ${hide_val} `
                                                        is_hide_match_val = is_hide_val
                                                    }
                                                }
                                            }
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }
                                            var swatch_text = (ovalue[0] != '') ? ovalue[0] : ''
                                            var swatch_type = (ovalue[2] != '') ? ovalue[2] : ''
                                            var swatch_val = (ovalue[3] != '') ? ovalue[3] : ''
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vp = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'

                                            if(is_enabled_shopify_default_currency){
                                                if(price != null && price != ""){
                                                    new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                    if(rounding_price){
                                                        new_price = Math.round(new_price);
                                                    }else{
                                                        new_price = new_price; 
                                                    }
                                                    
                                                    var vp = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                }

                                            }
                                            var opt_class = vprice != '' ? 'price-change' : ''

                                            var default_value = ovalue[4]
                                            if (default_value == true) {
                                                default_count += 1
                                                valueofhiddenprop.push(ovalue[0].toString().trim() + vp1)
                                            }

                                            var selectedopt = (default_value == true) ? "swatch_selected" : ''
                                            var checkdopt = (default_value == true) ? "checked" : ''
                                            
                                            var disable_class = ""
                                            var disable_prop = ""
                                            var hide_class = ""
                                            let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                            let inventory_count = parseInt(ovalue[6])
                                            var hinventroy = ""
                                            let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                            let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                            var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                            var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false

                                            var sku_properties = ""
                                            var disabled_sku = "disabled"
                                            var view_inventory = ""
                                            var uniq_val_identifier = ''
                                            if(checkPlan('inventory_and_sku_management', 'boolean' )){
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                    if(disabled_out_of_stock.toString() == "true"){
                                                        disable_prop = "disabled"
                                                        disable_class = "is_hulk_disabled"
                                                        opt_class = ''
                                                        selectedopt = ''
                                                        valueofhiddenprop.pop(ovalue[0].toString().trim() + vp1)
                                                    }else{
                                                        hide_class = "is_hulk_hide"
                                                        disable_prop = "disabled"
                                                        opt_class = ''
                                                        selectedopt = ''
                                                        valueofhiddenprop.pop(ovalue[0].toString().trim() + vp1)
                                                    }
                                                }
                                                if(manage_inventory.toString() == "true"){
                                                    is_add_unique_prop = true

                                                }
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                    hinventroy = inventory_count
                                                    if (default_value == true && hide_class == "" && disable_prop == "") {
                                                        valueofhiddenpropinventory.push(ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy)
                                                    }
                                                    if(is_view_inventory == true &&inventory_count > -1 ){
                                                        uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                        if(inventory_count == 0){
                                                                view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                        }else{
                                                        if(price != null && price != ""){
                                                            view_inventory =  " / <p class='hulk_stock' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"  + inventory_count + " " + window.hulk_inventory_text + "</p>";

                                                        }else{
                                                            view_inventory =   "<p class='hulk_stock' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"+inventory_count + " " + window.hulk_inventory_text + "</p>";
                                                        }
                                                        }
                                                        
                                                    }
                                                }
                                                if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                    disabled_sku = ""
                                                }

                                                if(sku != ""){
                                                    sku_properties = "<input type='hidden' "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' "+disabled_sku+"/>";
                                                }
                                            }
                                            var swatch_title = "<p>" + ovalue[0] + " <br> " + vp +  view_inventory + "</p>"
                                            var s_image = ''
                                            if (swatch_type == 'image') {
                                                swatch_style = "background-image:url(" + swatch_val + ");background-size:cover;background-position: center center;" + round_corners + ""
                                                swatch_image = "data-image='" + swatch_val + "'"
                                                s_image = swatch_val
                                            } else {

                                                try {
                                                    var swatch_color_option = swatch_val.split(",")
                                                } catch (err) {
                                                    swatch_color_option = null
                                                }
                                                if (swatch_color_option != null) {
                                                    if (swatch_color_option[1] != null) {
                                                        swatch_color_dual_ton = "background: linear-gradient(to bottom, " + swatch_color_option[0] + " 0%, " + swatch_color_option[0] + " 50%, " + swatch_color_option[1] + " 50%, " + swatch_color_option[1] + " 100%); " + round_corners + ""
                                                        var swatch_style = swatch_color_dual_ton
                                                        var swatch_image = "data-image=''"
                                                    } else {
                                                        var swatch_style = "background-color:" + swatch_color_option[0] + ";" + round_corners + ""
                                                        var swatch_image = "data-image=''"
                                                    }
                                                }
                                            }
                                            if (swatch_title != undefined) {
                                                if (swatch_val != '') {
                                                    if (tooltip_contains == "both") {
                                                        var titlee = "<div style='text-align:center;'><div class='multiswatch_tooltip_title'> " + swatch_title + "</div><div class='multiswatch_tooltip_data' style='width:100%;padding-top:100%;display: block !important;" + swatch_style + "'></div></div>"
                                                    } else if (tooltip_contains == "image_only") {
                                                        titlee = "<div style='text-align:center;'><div class='multiswatch_tooltip_data' style='width:100%;padding-top:100%;display: block !important;" + swatch_style + "'></div></div>"
                                                    } else {
                                                        titlee = "<div style='text-align:center;'><div class='multiswatch_tooltip_title'> " + swatch_title + "</div></div>"
                                                    }
                                                } else {
                                                    titlee = "<div style='text-align:center;'><div class='multiswatch_tooltip_title'> " + swatch_title + "</div></div>"
                                                }
                                            } else {
                                                titlee = "<div style='text-align:center;'><div class='swatch_tooltip_title'></div></div>"
                                            }
                                            tooltip_val = "<div class='hulkapps-tooltip-inner multiswatch-tooltip' style='width:200px;'><div>" + titlee + "</div></div>"
                                            tooltip_display_html = parseInt(tooltip_display) == 1 ? tooltip_val : ''
                                            swatch_with_text = parseInt(enable_swatch_with_text) == 1 ? swatch_text : ''

                                            if(index == '0' && hide_class == ''){
                                                var tabindex = 0
                                                is_tab_index = true
                                            }else if(index != '0' && is_tab_index == false){
                                                var tabindex = 0
                                                is_tab_index = true
                                            }else{
                                                var tabindex = -1
                                            }
                                            data_default_val = selectedopt == 'swatch_selected' ? true : false
                                            html_swatchmulti = "<label aria-label='"+ovalue[0].toString().trim()+" "+vp1+"' tabindex='"+tabindex+"' class='hulkapps_mswatch_option " + is_com_match_val + " " + is_hide_match_val + " " + hide_class + " "+ disable_class +"'><div class='hulkapps-tooltip " + tooltip_position + "'>" + tooltip_display_html + "<div class=''><div id='" + option_id + "_" + swatchcount + "' data-option-key='rb_" + option_id + "_" + swatchcount + "' data-oid='" + option_id + "' data-min='" + min_selection + "' data-single_valid-class='multiswatch_render' data-max='" + max_selection + "' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' class='hulk_po_checkbox hulkapps_option_child  " + selectedopt + " hulkapps_option_" + option_id + " " + opt_class + "'  data-price=" + vprice + "  data-variant-id= '"+ ovalue[12] +"'  data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + "' style='" + swatch_width + swatch_height + swatch_style + "' " + tooltip_position + "><input type='checkbox'  data-conditional-value='" + ovalue[0].toString().trim() + "' data-price=" + vprice + "  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-default='"+data_default_val+"' data-hinventory='"+hinventroy+"' "+disable_prop+" id='" + option_id + "' value='" + ovalue[0].toString().trim() + vp1 + "' class='hulk_po_swatch_multiple_checkbox swatch_checkbox hulkapps_option_child hulkapps_option_" + option_id + "_visible " + opt_class + " ' " + checkdopt + " style='display:none !important;' " + swatch_image + " ></div></div></div><div style='display: inline-block;vertical-align: middle;margin-left: 10px;'>" + swatch_with_text + "</div>"+sku_properties+"</label>"
                                            if(is_recomodation == true){
                                                recommended_value_html +=  html_swatchmulti
                                            }
                                            html += html_swatchmulti
                                            swatchcount += 1
                                        });
                                        if (enable_swatch_images == 1) {
                                            html += "var swatch_image_url = " + $(this).find('.swatch_radio').attr('data-image') + "if (" + swatch_image_url + " != ''){$('.hulkapps_swatch_image_change img').attr('src'," + swatch_image_url + ");$('.hulkapps_swatch_image_change img').attr('srcset'," + swatch_image_url + ");$('.hulkapps_swatch_image_change img').attr('data-srcset'," + swatch_image_url + ");}"
                                        }
                                        if (default_count > 0) {
                                            if (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                if (parseInt(default_count) < parseInt(min_selection) || parseInt(default_count) > parseInt(max_selection)) {
                                                    html += `<span class=\"validation_error error_span\">${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`
                                                }
                                            } else if (min_selection != '0' && max_selection == '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                if (parseInt(default_count) < parseInt(min_selection)) {
                                                    html += `<span class=\"validation_error error_span\">${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`
                                                }
                                            } else if (min_selection == '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                if (parseInt(default_count) > parseInt(max_selection)) {
                                                    html += `<span class=\"validation_error error_span\">${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`
                                                }
                                            }
                                        }
                                        var validation_error = '<span class=\"validation_error error_span\" >'

                                        var unique_prop_html = ""
                                        if(is_add_unique_prop){
                                            unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]'  value='"+valueofhiddenpropinventory+"' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "' data-selection-multi='true'/>"
                                        }
                                        html +=  unique_prop_html
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += "</div></div>"

                                        }
                                        html += "<input class='hulkapps_option_child' value='" + valueofhiddenprop.join(', ') + "' type='hidden' id='hulkapps_option_" + option_id + "_hidden' "+hdata_form+"    name='properties[" + option_name + "]'></div></div>"
                                        recommended_html = recommended_html +recommended_value_html

                                        all_html = all_html + html
                                        }
                                    } else if (option_type == 'checkbox'  || option_type == 'product_image_customizer') {
                                        if(option_type == 'product_image_customizer'){
                                            var is_option_premium = checkPlan('product_image_customizer', 'boolean' )
                                            var isEditCart = ''
                                            if(hpage_type == 'is_edit_cart'){
                                                isEditCart = "style='display:none;'"
                                            }
                                        }else{
                                            var is_option_premium = true
                                        }
                                        if(is_option_premium == true){
                                            var recommended_value_html = ""
                                            var min_selection = option_limit != undefined && option_limit != '' && option_limit['minimum_selection'] != undefined && option_limit['minimum_selection'] != '' ? option_limit['minimum_selection'].toString() : '0'
                                            var max_selection = option_limit != undefined && option_limit != '' && option_limit['maximum_selection'] != undefined && option_limit['maximum_selection'] != '' ? option_limit['maximum_selection'].toString() : '0'
                                            var is_single_line = parseInt(single_line) == 1 ? 'single_line' : ''
                                            var selection_text = (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}]</span>` : (min_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean',data['plan_id'],data['plans_features'])) ? `<span aria-label="${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}]</span>` : (max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}]</span>` : '';
                                            var html = "<div class='hulkapps_option cb_render " + is_com_arr + " " + is_required + " " + is_inline + " " + is_single_line + " " + "option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" "+isEditCart+" data-parent-id='" + option_id + "' data-min='" + min_selection + "' data-max='" + max_selection + "'>"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'><div>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + " </div>" + selection_text + " " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value hulkapps_product_page_options'>"
                                            if(recomodation_options.includes(option)){
                                                recommended_value_html += html
                                                
                                            }
                                            var valueofhiddenprop = []
                                            var default_count = 0
                                            var valueofhiddenpropinventory = []
                                            var is_tab_index = false
                                            $.each(values_json, function (index, ovalue) {
                                                is_com_match_val = ''
                                                is_hide_match_val = ''
                                                if(Object.keys(is_value_condition_json).length > 0 ){
                                                    for (const hide_val in is_value_condition_json) {
                                                        if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                            is_com_match_val += ` ${hide_val} `
                                                            is_hide_match_val = is_hide_val
                                                        }
                                                    }
                                                }
                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }
                                            
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vp2 = (price != null && price != "" && disabled_option_price == 0 ) ? " (+" + store_currency + price + ")" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'

                                                if(is_enabled_shopify_default_currency){
                                                        if(price != null && price != ""){
                                                            new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                            if(rounding_price){
                                                                new_price = Math.round(new_price);
                                                            }else{
                                                                new_price = new_price;
                                                            }
                                                            var vp2 = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                        }
                                                    
                                                }
                                                var default_value = ovalue[4]
                                                if (default_value == true) {
                                                    default_count += 1
                                                    valueofhiddenprop.push(ovalue[0].toString().trim() + vp1)
                                                }
                                                var selectedopt = (default_value == true) ? "checked" : ''
                                                var opt_class = vprice != '' ? 'price-change' : ''
                                                var disable_prop = ""
                                                var hide_class = ""
                                                var disable_class = ''
                                                let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                                let inventory_count = parseInt(ovalue[6])
                                                var hinventroy = ""
                                                let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                                let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                                var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                                var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false
                                                var sku_properties = ""
                                                var disabled_sku = "disabled"
                                                var view_inventory = ""
                                                var uniq_val_identifier = ''
                                                if(checkPlan('inventory_and_sku_management', 'boolean' )){
                                                    if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                        if(disabled_out_of_stock.toString() == "true"){
                                                            disable_prop = "disabled"
                                                            disable_class = "is_hulk_disabled"
                                                            selectedopt = ""
                                                            opt_class = ""
                                                            if (default_value == true) {
                                                                valueofhiddenprop.pop(ovalue[0].toString().trim() + vp1)
                                                            }
                                                        }else{
                                                            hide_class = "is_hulk_hide"
                                                            selectedopt = ""
                                                            opt_class = ""
                                                            if (default_value == true) {
                                                                valueofhiddenprop.pop(ovalue[0].toString().trim() + vp1)
                                                            }
                                                        }
                                                    }
                                                    if(manage_inventory.toString() == "true"){
                                                        is_add_unique_prop = true

                                                    }

                                                    if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                        hinventroy = inventory_count
                                                        if (default_value == true && hide_class == "" && disable_prop == "") {
                                                            valueofhiddenpropinventory.push(ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy)
                                                        }
                                                        if(is_view_inventory == true &&inventory_count > -1 ){
                                                            uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                            if(inventory_count == 0){
                                                            view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                            }else{
                                                            view_inventory =  " /&nbsp; " + " <p class='hulk_stock' style='margin: 0;' data-uid='"+ uniq_val_identifier +"' data-hinventory='"+hinventroy+"'>"+  inventory_count + " " + window.hulk_inventory_text + "</p>";
                                                            }
                                                        }
                                                    }
                                                    if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                        disabled_sku = ""
                                                    }

                                                    if(sku != ""){
                                                        sku_properties = "<input type='hidden' "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' "+disabled_sku+"/>";
                                                    }
                                                }
                                                if(index == '0' && hide_class == ''){
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                }else if(index != '0' && is_tab_index == false){
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                }else{
                                                    var tabindex = -1
                                                }
                                                var dis_value = ovalue[0].toString().trim()
                                                var product_image_customizer_class = ''
                                                var hulk_product_image_ccheckbox = ''
                                                var product_image_customizer_style = ''
                                                if(option_type == 'product_image_customizer'){
                                                    product_image_customizer_class = 'hulk_product_image_customizer'
                                                    product_image_customizer_style = 'style= "' + button_option_background + button_option_font_color + button_option_border_color + '"'
                                                    hulk_product_image_ccheckbox = 'hulk_product_image_ccheckbox'
                                                    dis_value = ovalue[13].toString().trim()
                                                }

                                                html_checkbox = "<label  aria-label='"+ovalue[0].toString().trim()+" "+vp1+"' tabindex='"+tabindex+"' "+product_image_customizer_style+" class='hulkapps_check_option "+disable_class+" "+product_image_customizer_class +" " + is_com_match_val + " " + is_hide_match_val + " " + hide_class + "'><input type='checkbox' " + selectedopt + " data-option-key='cbm_" + option_id + "' data-hinventory='"+hinventroy+"' "+disable_prop+" data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-single_valid-class='cb_render' data-min='"+min_selection+"' data-max='"+max_selection+"' data-oid='" + option_id + "' id='" + option_id + "' class='  hulk_po_checkbox hulkapps_option_child hulkapps_option_" + option_id + "_visible " + "hulkapps_product_option_" + option_id + "_visible " + opt_class + " "+hulk_product_image_ccheckbox+"' data-price='" + vprice + " '  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-shipping-weight= '"+ ovalue[13] +"'  data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + vp1 + "'><div class='hulkapps-custom-check'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"7\" viewBox=\"0 0 9 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.46989 6.79557L0.219933 4.69527C-0.073311 4.42153 -0.073311 3.97907 0.219933 3.70533C0.513177 3.43159 0.987167 3.43159 1.28041 3.70533L2.95738 5.27075L7.68078 0.244745C7.95078 -0.049296 8.42402 -0.0829008 8.73751 0.168435C9.0525 0.42047 9.08925 0.861532 8.81926 1.15487L3.56936 6.75566C3.43362 6.90408 3.23712 6.99229 3.02863 6.99999C2.80138 7.00069 2.61013 6.92718 2.46989 6.79557Z\" fill=\"" + ov_checkbox_color + "\"  style=\"&#10;\"/></svg></div>" + dis_value + vp2 + view_inventory + sku_properties + " </label>"
                                                if(is_recomodation == true){
                                                    recommended_value_html +=  html_checkbox
                                                }
                                                html += html_checkbox
                                            });
                                            if (default_count > 0) {
                                                if (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                    if (parseInt(default_count) < parseInt(min_selection) || parseInt(default_count) > parseInt(max_selection)) {
                                                        html += `</select><span class="validation_error error_span">${buildValidationMessage(window.min_max_validation_message, { min: min_selection, max: max_selection })}</span>`;
                                                    }
                                                } else if (min_selection != '0' && max_selection == '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                    if (parseInt(default_count) < parseInt(min_selection)) {
                                                        html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`
                                                    }
                                                } else if (min_selection == '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                    if (parseInt(default_count) > parseInt(max_selection)) {
                                                        html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`
                                                    }
                                                }
                                            }
                                            var validation_error = '<span class=\"validation_error error_span\" >'

                                            var unique_prop_html = ""
                                            if(is_add_unique_prop){
                                                unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]' value='"+valueofhiddenpropinventory+"' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "' data-selection-multi='true'/>"
                                            }
                                            html +=  unique_prop_html
                                            html += "<input class='hulkapps_option_child' value='" + valueofhiddenprop.join(', ') + "' type='hidden' id='hulkapps_option_" + option_id + "_hidden' "+hdata_form+"  name='properties[" + option_name + "]'></div></div>"
                                            if(recomodation_options.includes(option)){
                                                recommended_value_html += "</div></div>"

                                            }
                                            recommended_html = recommended_html +recommended_value_html

                                            all_html = all_html + html
                                        }
                                    } else if (option_type == 'textbox') {
                                        var cc = ''
                                        var is_option_limit = option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined ? '[Maximum ' + option_limit['character_limit'] + ' character]' : ''
                                        var html = "<div class='hulkapps_option tb_render " +has_float_label + " " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'><div>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " </div> " + is_option_limit + " " + is_enable_helptext + "</div>"
                                        if(label_setting == 'inlineLabels'){
                                            placeholder =  option_name
                                        }
                                        if(label_setting == 'floatingLabels'){
                                            placeholder =  ""
                                        }
                                        html += "<div class='hulkapps_option_value'>"
                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                                
                                            }else if (option_charge_type == 'character_charge' && price != null && price != "") {
                                                price = parseFloat(price)
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            var maxlength_limit = ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {
                                                maxlength_limit = "maxlength=" + option_limit['character_limit'] + ""
                                            }
                                            html += "<input type='text' data-is-charge='"+option_charge_type+"' data-single_valid-class='tb_render' data-val-selected-class='textbox_selected'  data-option-key='tb_" + option_id + "' id='" + option_id + "' placeholder='" + placeholder + "' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' class='hulkapps_option_child hulk_po_other_options hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-main-price='" + vprice + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' " + maxlength_limit + "><input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='tb_property_val other_options_prop_val'>"
                                            if(label_setting == 'floatingLabels'){
                                                html += "<label class='floating_label'>"+ option_name +"</label>"
                                            }
                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {

                                                html += "<input type='hidden' value='" + option_limit['character_limit'] + "' class='character_count'><div id='char_count_" + option_id + "'>" + option_limit['character_limit'] + " " + data['display_settings']['charcter_count_message'] + "</div>"
                                            }


                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {

                                                cc += "<script>(function($) {$(document).on('input', '.hulkapps_product_options .hulkapps_option_" + option_id + "', function() { check_character_limit(" + option_limit['character_limit'] + ",'" + option_id + "','" + data['display_settings']['charcter_count_message'] + "','hulkapps_product_options');});}(hulkapps_jQuery))</script>"
                                            }

                                        });
                                        html = html + cc + "</div></div>"
                                        all_html = all_html + html
                                    } else if (option_type == 'textarea') {
                                        var cc = ''
                                        var is_option_limit = option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined ? '[Maximum ' + option_limit['character_limit'] + ' character]' : ''
                                        var html = "<div class='hulkapps_option ta_render " + has_float_label + " " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'><div>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " </div> " + is_option_limit + " " + is_enable_helptext + "</div>"
                                        if(label_setting == 'inlineLabels'){
                                            placeholder =  option_name
                                        }
                                        if(label_setting == 'floatingLabels'){
                                            placeholder =  ""
                                        }
                                        html += "<div class='hulkapps_option_value'>"
                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if (option_charge_type == 'character_charge' && price != null && price != "") {
                                                price = parseFloat(price)
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            var maxlength_limit = ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {
                                                maxlength_limit = "maxlength=" + option_limit['character_limit'] + ""
                                            }
                                            html += "<textarea placeholder='" + placeholder + "' data-is-charge='"+option_charge_type+"' data-main-price='" + vprice + "' data-single_valid-class='ta_render' data-val-selected-class='textbox_selected' data-option-key='ta_" + option_id + "' id='" + option_id + "' data-pid='" + data['pid'] + "' data-parent='" + parentClass + "' class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' " + maxlength_limit + "></textarea>"
                                            if(label_setting == 'floatingLabels'){
                                                html += "<label class='floating_label'>"+ option_name +"</label>"
                                            }
                                            html += "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='ta_property_val other_options_prop_val'>"
                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {

                                                html += "<input type='hidden' value='" + option_limit['character_limit'] + "' class='character_count'><div id='char_count_" + option_id + "'>" + option_limit['character_limit'] + " " + data['display_settings']['charcter_count_message'] + "</div>"
                                            }

                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {

                                                cc += "<script>(function($) {$(document).on('input', '.hulkapps_product_options .hulkapps_option_" + option_id + "', function() { check_character_limit(" + option_limit['character_limit'] + ",'" + option_id + "','" + data['display_settings']['charcter_count_message'] + "','hulkapps_product_options');});}(hulkapps_jQuery))</script>"
                                            }

                                        });
                                        html = html + cc + "</div></div>"
                                        all_html = all_html + html
                                    } else if (option_type == 'radiobutton') {
                                        var rbcount = 0
                                        var is_single_line = parseInt(single_line) == 1 ? 'single_line' : ''
                                        var recommended_value_html = ""
                                        var radiobutton_current_behaviour_class = is_current_behaviour_radiobutton ? '' : 'radio_div';
                                        var radioinputClass = is_current_behaviour_radiobutton ? '' : 'radio_input';
                                        var radioinputnoClass = is_current_behaviour_radiobutton ? 'no-radio-style' : '';

                                        html = "<div class='hulkapps_option rb_render "+  is_change_image +"  " + is_com_arr + " " + is_required + " " + is_inline + " " + is_single_line + "  option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "' >"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"
                                        if(is_switch_toggle){
                                            html += "<div class='switches-container'>"
                                            var switch_values_location = data['switch_style']['values_location']
                                            values_location_css = `${switch_values_location == 'inside' ? 'width: auto;' : "width: 7rem; height: 3rem;"}`
                                            css = `.switches-container { border-radius: ${data['switch_style']['container_border_radius']}px; background: ${data['switch_style']['background_color']}; border-color: ${data['switch_style']['border_color']}; ${values_location_css}}.switch { border-radius: ${data['switch_style']['toggle_border_radius']}px;}.switch div, .switch_radio_div{ color: ${data['switch_style']['button_color']} !important; }`
                                            html += "<style> " + css + " </style>"
                                            switch_toggle_html = `<div class='switch-wrapper'><div class='switch' ${switch_values_location == "outside" ? 'style="display: block;"' : ""} >`
                                        }
                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += html
                                            
                                        }
                                        var valueofhiddenpropinventory = ""
                                        var valueofhiddenprop = ""
                                        var quantity_picker_style = "none"
                                        var is_tab_index = false
                                        $.each(values_json, function (index, ovalue) {
                                            is_com_match_val = ''
                                            is_hide_match_val = ''
                                            if(Object.keys(is_value_condition_json).length > 0 ){
                                                for (const hide_val in is_value_condition_json) {
                                                    if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                        is_com_match_val += ` ${hide_val} `
                                                        is_hide_match_val = is_hide_val
                                                    }
                                                }
                                            }
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vp2 = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            if(is_enabled_shopify_default_currency){
                                                if(price != null && price != ""){
                                                    new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                    if(rounding_price){
                                                        new_price = Math.round(new_price);
                                                    }else{
                                                        new_price = new_price;
                                                    }
                                                    var vp2 = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                }

                                            }
                                            var default_value = ovalue[4]
                                            if (default_value == true){
                                                valueofhiddenprop = ovalue[0].toString().trim() + vp1
                                                quantity_picker_style = "block"
                                            }
                                            var selectedopt = (default_value == true && is_current_behaviour_radiobutton == false) ? "radio_selected" : ''
                                            var checkdopt = (default_value == true) ? "checked" : ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            var disable_prop = ""
                                            var disable_class = ""
                                            var hide_class = ""
                                            let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                            let inventory_count = parseInt(ovalue[6])
                                            var hinventroy = ""
                                            let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                            let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                            var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                            var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false

                                            var sku_properties = ""
                                            var disabled_sku = "disabled"
                                            var view_inventory = ""
                                            var uniq_val_identifier = ''
                                            if(checkPlan('inventory_and_sku_management', 'boolean' )){
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                    if(disabled_out_of_stock.toString() == "true"){
                                                        disable_prop = "disabled"
                                                        disable_class = "is_hulk_disabled"
                                                        selectedopt = ""
                                                        checkdopt = ""
                                                        opt_class = ""
                                                    }else{
                                                        hide_class = "is_hulk_hide"
                                                        disable_prop = "disabled"
                                                        selectedopt = ""
                                                        checkdopt = ""
                                                        opt_class = ""
                                                    }
                                                }
                                                if(manage_inventory.toString() == "true"){
                                                    is_add_unique_prop = true

                                                }
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true"){
                                                    hinventroy = inventory_count
                                                    if (default_value == true && disable_prop == "") {
                                                        quantity_picker_style = "block"
                                                        valueofhiddenpropinventory = ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy
                                                    }
                                                    if(is_view_inventory == true &&inventory_count > -1 ){
                                                        uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`
                                                        if(inventory_count == 0){
                                                        view_inventory =  " / " + window.hulk_out_of_stock_text;
                                                        }else{
                                                        view_inventory =  " / " + inventory_count + " " + window.hulk_inventory_text;
                                                        }
                                                    }
                                                }
                                                if((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")){
                                                    disabled_sku = ""
                                                }
                                                if(sku != ""){
                                                    sku_properties = "<input type='hidden'  "+hdata_form+"  name='properties[_SKU_"+option_name+"(" + ovalue[0].toString().trim() + ")]' value='"+sku+"' class='hulk_unique_sku' "+disabled_sku+">";
                                                }
                                            }

                                            if(index == '0' && hide_class == ''){
                                                var tabindex = 0
                                                is_tab_index = true
                                            }else if(index != '0' && is_tab_index == false){
                                                var tabindex = 0
                                                is_tab_index = true
                                            }else{
                                                var tabindex = -1
                                            }
                                            data_default_val = (default_value == true) ? true : false
                                            if(is_switch_toggle){
                                                switch_div_css = 'text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;'
                                                switch_div_left_css = switch_div_css + 'margin-left: -100px; max-width: 110px; min-width: 100px;'
                                                switch_div_right_css = switch_div_css + 'margin-right: -100px; max-width: 150px; padding-left: 50px;'
                                                switch_left_css = `${switch_values_location == 'outside' ? switch_div_left_css : ""}`
                                                switch_right_css = `${switch_values_location == 'outside' ? switch_div_right_css : ""}`
                                                switch_css = `${index == 0 ? switch_left_css : switch_right_css }`
                                                if(switch_values_location == 'inside'){
                                                    switch_toggle_html += `${index === 0 ? `<div class="switch_radio_div_inside">${ovalue[0].toString().trim()} ${data['switch_style']['inside_display_value'] == 'with_price' ? `<span>${vp2}</span>` : ""}</div>` : ''} ${index === 1 ? `<div class="switch_radio_div_inside">${ovalue[0].toString().trim()} ${data['switch_style']['inside_display_value'] == 'with_price' ? `<span>${vp2}</span>` : ""}</div></div></div>` : ''}`;
                                                }else{
                                                    switch_toggle_html += "</div>"
                                                }
                                                div_title = `${ovalue[0].toString().trim()} ${(data['switch_style']['outside_display_value'] == 'with_price' || switch_values_location == "outside" ? vp2 : "")} ${view_inventory}`
                                                div_content = `${ovalue[0].toString().trim()} ${(data['switch_style']['outside_display_value'] == 'with_price' || switch_values_location == "outside" ? `<span>${vp2}</span>` : "")} ${view_inventory}`
                                                
                                                html_radio = "<input name='hulk_radio_" + option_id + "' data-val-selected-class='radio_selected'  data-oid='"+option_id+"' data-pid='" + data['pid'] + "' data-parent='" + parentClass + "' id='" + option_id + "_" + rbcount + "' data-option-key='rb_" + option_id + "_" + rbcount + "'  data-default='"+data_default_val+"' data-hinventory='"+hinventroy+"' type='radio' " + checkdopt + " " + disable_prop +" class='switch_input hulkapps_option_child hulk_po_radiobutton hulkapps_option_" + option_id + " " + opt_class + " ' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + vp1 + "'><label aria-label='"+ovalue[0].toString().trim()+" "+vp1+"' for='" + option_id + "_" + rbcount + "' aria-required='true' tabindex='"+tabindex+"' class='hulkapps_radio_option "+is_com_match_val+"  "+hide_class+" "+ disable_class +" "+is_hide_match_val+"'><div style='" + switch_css + "' title='"+ div_title +"' id='radio_div_" + option_id + "_" + rbcount + "' class='radio_div switch_radio_div " + (switch_values_location == "inside" ? "switch_radio_div_inside " : "") + selectedopt + "' data-uid='"+uniq_val_identifier +"' data-display-val='" + ovalue[0].toString().trim() + vp2 +"' data-hinventory='"+hinventroy+"'>"+ div_content +"</div>" +sku_properties +"</label> "+(index === 1 ? switch_toggle_html : "") +""
                                                if(switch_values_location == "inside" && data['switch_style']['inside_display_value'] == "with_price" && data['switch_style']['outside_display_value'] == "without_price"){
                                                    html_radio += "<script>"+
                                                    "var newElement = hulkapps_jQuery('#radio_div_" + option_id + "_" + rbcount + "');" +
                                                    "var switchContainer = newElement.closest('.switches-container')[0];" +
                                                    "if (switchContainer) {" +
                                                        "var switchContainerHeight = switchContainer.offsetHeight + 20;" +
                                                        "hulkapps_jQuery(switchContainer).css('min-height', switchContainerHeight + 'px');" +
                                                    "}" +
                                                    "</script>";

                                                }
                                            
                                            
                                            }else{
                                                html_radio = "<label aria-label='"+ovalue[0].toString().trim()+" "+vp1+"' aria-required='true' tabindex='"+tabindex+"' class='hulkapps_radio_option "+is_com_match_val+"  "+hide_class+" "+ disable_class +" "+is_hide_match_val+"'><input name='hulk_radio_" + option_id + "' data-val-selected-class='radio_selected'  data-oid='"+option_id+"' data-pid='" + data['pid'] + "' data-parent='" + parentClass + "' id='" + option_id + "_" + rbcount + "' data-option-key='rb_" + option_id + "_" + rbcount + "'  data-default='"+data_default_val+"' data-hinventory='"+hinventroy+"' type='radio' " + checkdopt + " " + disable_prop +" class='hulkapps_option_child hulk_po_radiobutton hulkapps_option_" + option_id + " " + radioinputClass + " "+radioinputnoClass+" " + opt_class + " ' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' value='" + ovalue[0].toString().trim() + vp1 + "'><div class='"+radiobutton_current_behaviour_class+" " + selectedopt + "' for='" + option_id + "_" + rbcount + "' data-uid='"+uniq_val_identifier +"' data-display-val='" + ovalue[0].toString().trim() + vp2 +"' data-hinventory='"+hinventroy+"'>" + ovalue[0].toString().trim() + vp2 + view_inventory +"</div>" +sku_properties +"</label>"
                                            }
                                            if(is_recomodation == true){
                                                recommended_value_html +=  html_radio
                                            }
                                            html += html_radio
                                            rbcount += 1
                                        });
                                        var unique_prop_html = ""
                                        if(is_add_unique_prop){
                                            unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_"+option_unique_name+"_hin_" + option_name + "]' value='"+valueofhiddenpropinventory+"' class='hulk_unique_prop' data-unique_prop_name='_hin_"+option_unique_name+"_hin_" + option_name + "'/>"
                                        }
                                        html += unique_prop_html
                                        if(is_switch_toggle){
                                            html += "</div>"
                                        }
                                        if (checkPlan('quantity_selector', 'boolean' ) && is_quantity_selector) {
                                            html += "<input style='display: " + quantity_picker_style + "' type='number'  min='1' value='1' class='hulk_options_quantity hulk_po_radiobutton_quanity' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' id='quantity_" + option_id + "'/>"
                                        }
                                        html +=  "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' value='"+valueofhiddenprop+"' class='hulk_radiobutton_hidden_prop'/>" + "</div></div>"

                                        if(recomodation_options.includes(option)){
                                            recommended_value_html += "</div></div>"

                                        }
                                        recommended_html = recommended_html +recommended_value_html
                                        if(checkPlan('image_change_based_on_option_value', 'boolean' ) && is_thumbnail_change == true && image_parent != ""){
                                            html += "<script>(function($) {$('.hulkapps_product_options .hulkapps_option_" + option_id + "').change(function() { var option_val  = $(this).data('conditional-value');$('"+image_parent+"').each(function(){data_title = $(this).attr('alt');if(option_val === data_title){$(this).click();}});});;}(hulkapps_jQuery))</script>"

                                        }

                                        all_html = all_html + html
                                    } else if (option_type == 'file_upload') {
                                        html = "<div class='hulkapps_option fu_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+"  data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'><div class='file-upload' tabindex='0' aria-label='Choose File'> <div class='file-select'> <div class='file-select-name noFile' >No file chosen...</div><div class='file-select-button' id='fileName' >Choose File</div><input type='file' multiple data-option-key='fu_" + option_id + "' id='" + option_id + "' class='hulkapps_option_child hulkapps_full_width hulk_file_upload hulkapps_option_" + option_id + "' "+hdata_form+"  name='properties[" + option_name + "]'> </div></div><script>(function($) {$('.hulkapps_product_options #" + option_id + "').change(function (){ conditional_rules(" + data['pid'] + ",'hulkapps_product_options');validate_single_option('option_type_id_" + option_id + "','fu_render','hulkapps_product_options');})}(hulkapps_jQuery))</script></div></div>"
                                        all_html = all_html + html
                                    } else if (option_type == 'email') {
                                        var cc = ''
                                        html = "<div class='hulkapps_option et_render " + has_float_label + " " +  is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + " </div>"
                                        if(label_setting == 'inlineLabels'){
                                            placeholder =  option_name
                                        }
                                        if(label_setting == 'floatingLabels'){
                                            placeholder =  ""
                                        }
                                        html += "<div class='hulkapps_option_value'>"
                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            var default_value = ovalue[4]
                                            var selectedopt = (default_value == true) ? "selected" : ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            html += "<input type='email' placeholder='" + placeholder + "' data-option-key='et_" + option_id + "' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-val-selected-class='emailbox_selected' data-single_valid-class='et_render' id='" + option_id + "' class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"'><input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='et_property_val other_options_prop_val'>"
                                            if(label_setting == 'floatingLabels'){
                                                html += "<label class='floating_label'>"+ option_name +"</label>"
                                            }

                                        });
                                        html = html + cc + "</div></div>"
                                        all_html = all_html + html
                                    } else if (option_type == 'date_picker') {

                                        if (checkPlan('date_field_option', 'boolean' ) || (checkPlan('date_field_option', 'boolean' ) == false && oldStore() == true) ) {
                                        var cc = ''
                                        var min_selection = option_limit != undefined && option_limit != '' && option_limit['minimum_selection'] != '' && option_limit['minimum_selection'] != undefined ? option_limit['minimum_selection'].toString() : ''
                                        var max_selection = option_limit != undefined && option_limit != '' && option_limit['maximum_selection'] != '' && option_limit['maximum_selection'] != undefined ? option_limit['maximum_selection'].toString() : ''

                                        var date_min = min_selection != undefined ? min_selection : ''
                                        var date_max = max_selection != undefined ? max_selection : ''
                                            if(restrict_past_date == true){
                                                var today_date = new Date();
                                                var year = today_date.getFullYear();
                                                var month = String(today_date.getMonth() + 1).padStart(2, '0');
                                                var day = String(today_date.getDate()).padStart(2, '0');
                                                date_min = year + '-' + month + '-' + day;
                                            }

                                        var use_date_range = $.trim(data['option_associative_array'][option]['use_date_range']) === 'true';
                                        if(use_date_range){
                                            date_type = "text"
                                            date_range_class = "date-range"
                                        }else{
                                            date_type = "date"
                                            date_range_class = ""
                                        }
                                        html = "<div class='hulkapps_option dp_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + "   " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"

                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            var default_value = ovalue[4]
                                            var selectedopt = (default_value == true) ? "selected" : ''
                                            var opt_class = vprice != '' ? 'price-change' : ''

                                            html += "<input type='"+date_type+"' min='" + date_min + "' max='" + date_max + "' tabindex='0' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-single_valid-class='dp_render'  data-val-selected-class='datepicker_selected'  data-option-key='dp_" + option_id + "' id='" + option_id + "' name='input' placeholder='mm/dd/yyyy' class='hulk_po_other_options "+ date_range_class +" hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"'><input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='dp_property_val other_options_prop_val'>"

                                        });
                                        html = html  + "</div></div>"
                                        all_html = all_html + html
                                        }
                                    }else if (option_type == 'time_picker') {
                                        if (checkPlan('time_picker', 'boolean' ) ) {
                                            var cc = ''
                                            var min_selection = option_limit != undefined && option_limit != '' && option_limit['minimum_selection'] != '' && option_limit['minimum_selection'] != undefined ? option_limit['minimum_selection'].toString() : ''
                                            var max_selection = option_limit != undefined && option_limit != '' && option_limit['maximum_selection'] != '' && option_limit['maximum_selection'] != undefined ? option_limit['maximum_selection'].toString() : ''
                                            var selection_text = (min_selection  && max_selection  && checkPlan('validation_for_min_max_option_selection', 'boolean')) ? '<span class="selection-text">[Select time between ' + min_selection + ' to ' + max_selection + ' ]</span>' : (min_selection  && checkPlan('validation_for_min_max_option_selection', 'boolean')) ? '<span class="selection-text">[Select a time from ' + min_selection + ']</span>' : (max_selection  && checkPlan('validation_for_min_max_option_selection', 'boolean')) ? '<span class="selection-text">[Select a time earlier than ' + max_selection + ']</span>' : ''
                                            var time_min = min_selection != undefined ? min_selection : ''
                                            var time_max = max_selection != undefined ? max_selection : ''

                                            html = "<div class='hulkapps_option dt_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " "+selection_text+" " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value'>"


                                            $.each(values_json, function (index, ovalue) {
                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'
                                                var default_value = ovalue[4]
                                                var selectedopt = (default_value == true) ? "selected" : ''
                                                var opt_class = vprice != '' ? 'price-change' : ''

                                                html += "<input type='time' min='"+time_min+"' max='"+time_max+"' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-single_valid-class='dt_render'  data-val-selected-class='datetimepicker_selected'  data-option-key='dt_" + option_id + "' id='" + option_id + "' name='input' placeholder='mm/dd/yyyy' class='hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"'><input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='dp_property_val other_options_prop_val'>"

                                            });
                                            html = html  + "</div></div>"
                                            all_html = all_html + html
                                        }
                                    } else if (option_type == 'color_picker') {
                                        if (checkPlan('color_picker_option', 'boolean' )) {
                                            var cc = ''
                                            html = "<div class='hulkapps_option cp_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value'>"
                                            $.each(values_json, function (index, ovalue) {
                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'
                                                var opt_class = vprice != '' ? 'price-change' : ''

                                                html += "<input type='color' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-val-selected-class='colorpicker_selected' data-single_valid-class='cp_render'  data-option-key='cp_" + option_id + "' id='" + option_id + "' name='input' style='padding: 0;width: 100px;' class='hulk_po_other_options hulkapps_option_child  hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"'><input type='hidden'"+hdata_form+"   name='properties[" + option_name + "]' class='cp_property_val other_options_prop_val'>"

                                            });
                                            html = html  + "</div></div>"
                                            all_html = all_html + html
                                        }
                                    } else if (option_type == 'number_field') {
                                        cc = ''
                                        var char_limit = option_limit != undefined && checkPlan('character_limit', 'boolean', data['plan_id'], data['plans_features']) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined
                                        var is_option_limit = option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined ? '[Maximum ' + option_limit['character_limit'] + ' character]' : ''
                                        var use_range_slider = $.trim(data['option_associative_array'][option]['use_range_slider']) || 'false'
                                        var min_selection = option_limit != undefined && option_limit != '' && option_limit['minimum_selection'] != undefined && option_limit['minimum_selection'] != '' ? option_limit['minimum_selection'].toString() : ''
                                        var max_selection = option_limit != undefined && option_limit != '' && option_limit['maximum_selection'] != undefined && option_limit['maximum_selection'] != '' ? option_limit['maximum_selection'].toString() : ''
                                        var number_field_type = (use_range_slider === 'true') ? "range" : "number"
                                        var range_slider_class = (use_range_slider === 'true') ? " hulk_range_slider" : ""
                                        var html = "<div class='hulkapps_option nf_render" + range_slider_class + " " + has_float_label +" " +  is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'><div>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " </div> " + is_option_limit + " " + is_enable_helptext + "</div>"
                                        if(label_setting == 'inlineLabels'){
                                            placeholder =  option_name
                                        }
                                        if(label_setting == 'floatingLabels'){
                                            placeholder =  ""
                                        }
                                        html += "<div class='hulkapps_option_value" + range_slider_class + "'>"
                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if (option_charge_type == 'character_charge' && price != null && price != "") {
                                                price = parseFloat(price)
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            var maxlength_limit = ''
                                            var length_validation = ''
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {
                                                maxlength_limit = "maxlength=" + option_limit['character_limit'] + ""
                                                length_validation = "onKeyPress='if(this.value.length==" + option_limit['character_limit'] + ") return false;'"
                                            }

                                            var range_attrs = "data-min='"+min_selection+"' data-max='"+max_selection+"' value='"+min_selection+"' min='"+min_selection+"' max='"+max_selection+"' ";
                                            var range_labels = (use_range_slider === 'true') ? "<div class='range-labels'><span class='range-label-min'>"+min_selection+"</span><span class='range-label-max'>"+max_selection+"</span></div>" : ""
                                            html += range_labels + "<input type='"+number_field_type+"' step='1' data-is-charge='"+option_charge_type+"' " + length_validation + " pattern='\d*'" + range_attrs + " step='any' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-val-selected-class='numberfield_selected' data-single_valid-class='nf_render' data-option-key='nf_" + option_id + "' id='" + option_id + "' placeholder='" + placeholder + "'  class='hulk_po_other_options hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-main-price='" + vprice + "' data-price='" + vprice + "' " + maxlength_limit + "  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"'><input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='nf_property_val other_options_prop_val'>"
                                            if(label_setting == 'floatingLabels'){
                                                html += "<label class='floating_label'>"+ option_name +"</label>"
                                            }
                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {
                                                html += "<input type='hidden' value='" + option_limit['character_limit'] + "' class='character_count'><div id='char_count_" + option_id + "'>" + option_limit['character_limit'] + " " + data['display_settings']['charcter_count_message'] + "</div>"
                                            }


                                            if (option_limit != undefined && checkPlan('character_limit', 'boolean' ) && option_limit['character_limit'] != '' && option_limit['character_limit'] != undefined) {
                                                cc += "<script>(function($) {$(document).on('input', '.hulkapps_product_options .hulkapps_option_" + option_id + "', function() { if(this.value.length > Number($(this).attr('maxlength'))){val=this.value.slice(0, $(this).attr('maxlength'));$(this).val(val);}check_character_limit(" + option_limit['character_limit'] + ",'" + option_id + "','" + data['display_settings']['charcter_count_message'] + "','hulkapps_product_options');});}(hulkapps_jQuery))</script>"
                                            }

                                        });
                                        if(use_range_slider === 'true'){
                                            var progress_bar_background_color = data['display_settings']['progress_bar_background_color'] || '#4f46e5'
                                            cc += "<style>.hulk_range_slider.hulkapps_option_value { position: relative; padding-top: 28px; }.hulk_range_slider.hulkapps_option_value .range-labels { display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 12px; color: #666; }.hulk_range_slider.hulkapps_option_value .range-label-min, .hulk_range_slider.hulkapps_option_value .range-label-max { font-size: 12px; color: #666; }.hulk_range_slider.hulkapps_option_value input[type=\"range\"] { -webkit-appearance: none; width: 100%; height: 6px; border-radius: 6px; background: linear-gradient(to right, " + progress_bar_background_color + " 0%, " + progress_bar_background_color + " var(--range-progress, 0%), #e5e7eb var(--range-progress, 0%), #e5e7eb 100%); outline: none; }.hulk_range_slider.hulkapps_option_value input[type=\"range\"]::-webkit-slider-thumb { -webkit-appearance: none; height: 18px; width: 18px; border-radius: 50%; background: " + progress_bar_background_color + "; cursor: pointer; border: 2px solid #fff; }.hulk_range_slider.hulkapps_option_value input[type=\"range\"]::-moz-range-thumb { height: 18px; width: 18px; border-radius: 50%; background: " + progress_bar_background_color + "; cursor: pointer; border: none; }.hulk_range_slider.hulkapps_option_value .range-value { position: absolute; top: 0; transform: translateX(-50%); background: " + progress_bar_background_color + "; color: #fff; font-size: 12px; padding: 2px 8px; border-radius: 6px; white-space: nowrap; pointer-events: none; }</style>"
                                            cc += "<script>(function($) { function initRangeSlider" + option_id + "() { var range = document.querySelector('.hulkapps_product_options .hulk_range_slider.hulkapps_option_value input[type=\"range\"][id=\"" + option_id + "\"]'); if(range && !range.hasAttribute('data-range-initialized')) { range.setAttribute('data-range-initialized', 'true'); var min = parseInt(range.dataset.min || 0, 10); var max = parseInt(range.dataset.max || 100, 10); var bubble = document.createElement('div'); bubble.className = 'range-value'; range.parentNode.appendChild(bubble); var userInteracted = false; function updateRange(updateHidden) { var val = parseInt(range.value || min, 10); if(val < min) val = min; if(val > max) val = max; range.value = val; var percent = max > min ? ((val - min) / (max - min)) * 100 : 0; range.style.setProperty('--range-progress', percent + '%'); bubble.textContent = val; bubble.style.left = percent + '%'; if(updateHidden !== false) { var hidden = range.parentNode.querySelector('.nf_property_val'); if (hidden) hidden.value = userInteracted ? val : ''; } } range.addEventListener('input', function() { userInteracted = true; updateRange(true); }); range.addEventListener('change', function() { userInteracted = true; updateRange(true); }); updateRange(false); } } setTimeout(function() { initRangeSlider" + option_id + "(); }, 0); $(document).ready(function() { initRangeSlider" + option_id + "(); }); })(hulkapps_jQuery);</script>"
                                        }
                                        html = html + cc + "</div></div>"
                                        all_html = all_html + html
                                    } else if (option_type == 'phone_number') {
                                        var cc = ''
                                        var phone_option = true
                                        var phone_number_js = ''
                                        var html = "<div class='hulkapps_option pn_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                        html += "<div class='hulkapps_option_value'>"
                                        $.each(values_json, function (index, ovalue) {
                                            var price = ovalue[1]
                                            var option_charge_type = ovalue[9]
                                            if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                price = parseFloat(price.toFixed(2));
                                                window.need_varaint_change = true
                                            }
                                            var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                            var vprice = (price != null && price != "") ? price : '0.00'
                                            var opt_class = vprice != '' ? 'price-change' : ''
                                            html += "<input type='text' data-option-key='tb_" + option_id + "' id='" + option_id + "' class='phone_number phone_number" + option_id + " hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' ><input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='tb_property_val '><span id='valid-msg' class='hide'>✓ Valid</span><span id='error-msg' class='hide' tabindex='0' aria-label='"+ window.invalid_phone_validation_message +"'>"+ window.invalid_phone_validation_message +"</span>"
                                            cc += "<script>(function($) {$(document).ready(function(){$('.hulkapps_product_options .phone_number" + option_id + "').keypress(function (e) {if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {return false;}});var telInput = $('.hulkapps_product_options').find('.phone_number" + option_id + "');var errorMsg = $('.hulkapps_product_options').find('.phone_number" + option_id + "').closest('.hulkapps_option_value').find('#error-msg');var validMsg = $('.hulkapps_product_options').find('.phone_number" + option_id + "').closest('.hulkapps_option_value').find('#valid-msg');var iti = window.intlTelInput(telInput.get(0), {initialCountry: 'auto',geoIpLookup: function(callback) {var countryCode = '" + Shopify.country + "';callback(countryCode);},customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {return 'e.g. ' + selectedCountryPlaceholder;}, utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.5/js/utils.min.js'});var reset = function() {telInput.removeClass('error');errorMsg.innerHTML = '';errorMsg.addClass('hide');validMsg.addClass('hide');};telInput.blur(function() {reset();if ($.trim($('.phone_number" + option_id + "').val())) {if(iti.isValidNumber()){validMsg.removeClass('hide');$('.hulkapps_product_options').find('.phone_number" + option_id + "').parents('.hulkapps_option_value').find('#error-msg').css('cssText', 'display: none !important');telInput.val(iti.getNumber(intlTelInputUtils.numberFormat.E164));var tb_val = $('.hulkapps_product_options').find('.phone_number" + option_id + "').val();var price = $(this).data('price');if(price != '0.00'){var res = tb_val + ' [ " + store_currency + "' + price + ' ]';}else{var res = tb_val}$(this).parents('.hulkapps_option_value').find('.tb_property_val').val(res);$(this).addClass('textbox_selected');} else {telInput.addClass('error');$('.hulkapps_product_options').find('.phone_number" + option_id + "').parents('.hulkapps_option_value').find('#error-msg').css('cssText', 'display: block !important');$(this).parents('.hulkapps_option_value').find('.tb_property_val').val(res);$(this).removeClass('textbox_selected');}}else{$('.hulkapps_product_options').find('.phone_number').parents('.hulkapps_option_value').find('#error-msg').css('cssText', 'display: none !important');$(this).parents('.hulkapps_option_value').find('.tb_property_val').val(res);$(this).removeClass('textbox_selected');}conditional_rules(" + data['pid'] + ",'hulkapps_product_options');if($('#hulk_amount_dis').val() == '1'){calc_options_total(" + data['pid'] + ",'hulkapps_product_options');}validate_single_option('option_type_id_" + option_id + "', 'pn_render','hulkapps_product_options');});});}(hulkapps_jQuery))</script>"
                                        });
                                        html = html + cc + "</div></div>"
                                        all_html = all_html + html
                                    } else if (option_type == 'hidden') {
                                        if (checkPlan('hidden_field_option', 'boolean' )) {
                                            $.each(values_json, function (index, ovalue) {
                                                var val = ovalue[0]
                                                html = "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='hf_property_val   hulkapps_option_" + option_id + " " + is_com_arr + " " + is_hide_arr + "' value='" + val + "'>"
                                            });
                                            all_html = all_html + html
                                        }
                                    } else if (option_type == 'popup') {
                                        if (checkPlan('popup_option', 'boolean' )) {
                                            html = "<div class='hulkapps_option popup_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                            html += "<div class='hulkapps_option_name' style='display: none !important;'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value'>"
                                            $.each(values_json, function (index, ovalue) {
                                                var val = ovalue[0]
                                                var popup_image = ovalue[3] != null ? ovalue[3] : ''
                                                if (popup_image != '') {
                                                    html += "<div  class='cut-popup-icon'><span class='cut-popup-icon-span'><img src='" + popup_image + "' style='width: 24px;'></span><a  tabindex='0'  style='cursor: pointer;' data-id='" + option_id + "' data-option-key='popup_" + option_id + "' id='" + option_id + "' class='hulkapps_option_child hulkapps_full_width popup_open_link hulkapps_option_" + option_id + "'>" + val + "</a></div>"
                                                } else {
                                                    html += "<div style='display: flex; align-items: center;'><a  tabindex='0' style='cursor: pointer;' data-id='" + option_id + "' data-option-key='popup_" + option_id + "' id='" + option_id + "' class='hulkapps_option_child hulkapps_full_width popup_open_link hulkapps_option_" + option_id + "'>" + val + "</a></div>"
                                                }


                                                html += "<div class='popup_detail'  id='popupdetailsdesing_" + option_id + "' style='display: none'><div><div class='des-title'></div><div tabindex='0' class='des-detail' style='padding: 10px;'>" + ovalue[2] + "</div></div><a class='popup_close_link' tabindex='0' aria-label='close popup' data-id='" + option_id + "'><img src='" + window.hulkapps.po_url + "/images/close.png' alt='close-icon'></a></div><div class='overlay-popup'></div>"
                                            });
                                            css = "<style> table, th, td{  border:  0 !important; } </style>"
                                            html = html + "</div></div>" + css
                                            all_html = all_html + html
                                        }
                                    }else if (option_type == 'information') {
                                        html = "<div class='hulkapps_option information_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                        html += "<div class='hulkapps_option_value'>"
                                        $.each(values_json, function (index, ovalue) {
                                            var val = ovalue[0]
                                            html += "<div>"+ ovalue[2] +"</div>"
                                        });
                                        html = html + "</div></div>"
                                        all_html = all_html + html
                                    }else if (option_type == 'google_font') {
                                        if (checkPlan('google_font_option', 'boolean' )) {
                                            var cc = ''
                                            html = "<div class='hulkapps_option gf_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + " </div>"
                                            html += "<div class='hulkapps_option_value'>"
                                            default_price = ""
                                            option_charge_type = default_selection_google_price['option_charge_type']
                                            default_selection_google_price =  default_selection_google_price['price']

                                            if(option_charge_type == 'percentage_charge' && default_selection_google_price != null && default_selection_google_price != "" &&  checkPlan('percentage_charge','boolean')){
                                                default_selection_google_price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*default_selection_google_price)/100
                                                window.need_varaint_change = true
                                                default_selection_google_price = parseFloat(default_selection_google_price.toFixed(2));
                                            }else if(option_charge_type == 'multiplication_charge' && default_selection_google_price != null && default_selection_google_price != "" ){
                                                default_selection_google_price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*default_selection_google_price)
                                                default_selection_google_price = parseFloat(default_selection_google_price.toFixed(2));
                                                window.need_varaint_change = true
                                            }
                                            if(default_selection_google_price != null && default_selection_google_price != ""){
                                                var opt_class = 'price-change'
                                                var selectedopt = "googlefont_selected"
                                                var default_price = " [ " + store_currency + default_selection_google_price + " ]"

                                            }else{
                                                default_selection_google_price = "0.00"
                                                var opt_class = 'price-change'
                                            }
                                            data_default_val = selectedopt == 'googlefont_selected' ? true : false
                                            html += "<input type='text' tabindex='0' data-option-key='gf_" + option_id + "' id='" + option_id + "' value='"+default_selection_google_font+"' class='hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + " " + selectedopt + " ' data-default='"+data_default_val+"' data-price='"+default_selection_google_price+"'>"

                                            if(default_price == ""){
                                                html += "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='gf_property_val'>"
                                            }else{
                                                html += "<input type='hidden' "+hdata_form+" name='properties[" + option_name + "]' class='gf_property_val' value='"+default_selection_google_font+" "+default_price+"'>"
                                            }
                                            html += "</div>"
                                            if(is_font_preview  == true){
                                                html += "<div class='font_preview " + is_inline + " font_preview_" + option_id + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'><div aria-label='preview your font' tabindex='0' aria-required='false' class='hulkapps_option_name'>"+font_preview_lable+"</div><div class='hulkapps_option_value'><textarea placeholder='"+placeholder+"'  class='hulkapps_full_width' >"+placeholder+"</textarea></div></div>"
                                            }
                                            var google_font_with_price_format = JSON.stringify(google_font_with_price)

                                            var google_fonts_data = JSON.stringify(google_fonts)

    
                                            cc += "<script>(function($) {var google_font_with_price_format = "+google_font_with_price_format+";var google_fonts_data = "+google_fonts_data+";$('.hulkapps_option_"+option_id +"').fontselect(google_fonts_data).change(function(){var font = $(this).val().replace('/\+/g', ' ');font = font.split(':')[0];var option_charge_type = google_font_with_price_format[font]['option_charge_type'];var price=google_font_with_price_format[font]['price'];var variant_id=google_font_with_price_format[font]['variant_id']; var shipping_weight=google_font_with_price_format[font]['shipping_weight'];if(option_charge_type == 'percentage_charge' && price != null && price != ''){price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100;price = parseFloat(price.toFixed(2));}if(option_charge_type == 'create_mulitplication_charge' && price != null && price != ''){price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price);price = parseFloat(price.toFixed(2));}if(price == null){price = '0.00'};$('.hulkapps_option_"+option_id +"').attr('data-variant-id',variant_id);$('.hulkapps_option_"+option_id +"').attr('data-shipping-weight',shipping_weight);$('.hulkapps_option_"+option_id +"').attr('data-price',price)});$(document).on('change','.hulkapps_product_options .hulkapps_option_" + option_id + "',function() {var price = $(this).attr('data-price');var gf_val = $(this).val();$('.font_preview_"+ option_id +" textarea').css('font-family', gf_val).css('--ph-font', gf_val);if (gf_val != '') {if(price != '0.00'){var res = gf_val + ' [ " + store_currency + "' + price + ' ]';}else{var res = gf_val}$(this).parent().find('.gf_property_val').val(res);$(this).addClass('googlefont_selected');}else{ $(this).parent().find('.gf_property_val').val('');$(this).removeClass('googlefont_selected');}conditional_rules(" + data['pid'] + ",'hulkapps_product_options');if($('#hulk_amount_dis').val() == '1'){calc_options_total(" + data['pid'] + ",'hulkapps_product_options');}validate_single_option('option_type_id_" + option_id + "', 'gf_render','hulkapps_product_options');});}(hulkapps_jQuery))</script>"

                                            html = html + cc + "</div>"

                                            all_html = all_html + html
                                        }
                                    }else if (option_type == 'formula_based_options') {
                                        if (checkPlan('formula_based_options', 'boolean')){
                                        
                                            var formula_inline = formula_option_name_inline == true ? '' : 'full_width'
                                            html = "<div class='hulkapps_option fm_render required " + is_required + " " + is_com_arr + "  " + formula_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id= " + option_id + " ><div class='hulkapps_option_name'  aria-label='"+option_name+"' tabindex='0' >" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + "</div><div class='hulkapps_option_value fm_option_val' data-parent='" + parentClass + "' data-pid='" + data['pid'] + "'>"
                                            var valueofhiddenprop = ""
                                            var hulk_not_default = false
                                            $.each(values_json, function (index, ovalue) {
                                                formula_tooltip_text = ''
                                                if (ovalue[4])   {
                                                    var formula_tooltip_text =  "<div class='hulkapps-tooltip'><span aria-describedby='tooltip_" + option + "' aria-label='"+ovalue[4]+"' tabindex='0' ><img src='" + window.hulkapps.po_url + "/tooltip.svg' style='width:15px;'></span><div class='hulkapps-tooltip-inner' id='tooltip_" + option + "' role='tooltip'>"+ovalue[4]+"</div></div>"

                                                }

                                                if(ovalue[3] == "plus"){
                                                    var arithmatic = "+"
                                                }else if (ovalue[3] == "minus"){
                                                    var arithmatic = "-"
                                                }else if (ovalue[3] == "divide") {
                                                    var arithmatic = "/"
                                                }else if (ovalue[3] == "multiple") {
                                                    var arithmatic = "*"
                                                }
                                                var input_box_html = ""
                                                if(ovalue[0] == 'default_value'){
                                                    if(is_enabled_shopify_default_currency){
                                                        if(ovalue[2] != null && ovalue[2] != ""){
                                                            new_price = parseFloat(ovalue[2]) * parseFloat(window.hulkapps_shopify_rate)
                                                            if(rounding_price){
                                                                ovalue[2] = Math.round(new_price);
                                                            }else{
                                                                ovalue[2] = new_price;
                                                            }        
                                                        }
        
                                                    }
                                                    input_box_html = "<div class='hulk-form-field'><div class='hulkapps_option_name' tabindex='0' aria-label='"+ovalue[1]+"' >"+ovalue[1]+"</div><div class='hulkapps_option_value'><input type='number'   value='"+parseFloat(ovalue[2])+"' data-oid='" + option_id + "' class='po_changed_formula' data-arithmatic='"+arithmatic+"' readonly data-name='"+ovalue[1]+"' min='"+ovalue[5]+"' max='"+ovalue[6]+"'>"+formula_tooltip_text+"</div></div>"
                                                }else{
                                                    hulk_not_default = true
                                                    input_box_html = "<div class='hulk-form-field'><div class='hulkapps_option_name' tabindex='0' aria-label='"+ovalue[1]+"'>"+ovalue[1]+"</div><div class='hulkapps_option_value'><input type='number'  data-oid='" + option_id + "'  data-arithmatic='"+arithmatic+"' class='po_changed_formula hulkapps_option_child' data-name='"+ovalue[1]+"'  min='"+ovalue[5]+"' max='"+ovalue[6]+"' >"+formula_tooltip_text+"</div></div>"

                                                }
                                                html += input_box_html
                                            });
                                            html += "<input type='hidden' "+hdata_form+"   name='properties[" + option_name + "]'  class='hulk_formula_hidden_prop hulkapps_option_child'/>"
                                            html += `<script>(function($) {if(${hulk_not_default} != true){$('.option_type_id_${option_id}').find('.po_changed_formula').change();}}(hulkapps_jQuery))</script></div></div>`
                                            all_html = all_html + html
                                        }
                                    }else if (option_type == 'short_text_group') {
                                        if (checkPlan('short_text_group', 'boolean')) {
                                            var cc = ''
                                            html = "<div class='hulkapps_option stg_render " + is_com_arr + " " + is_required + " " + is_inline + " option_type_id_" + option_id + " " + is_hide_arr + " "+class_name+"' "+idn+" data-parent-id='" + option_id + "'>"
                                            html += "<div aria-label='"+option_name+"' tabindex='0' aria-required='"+ aria_require +" ' class='hulkapps_option_name'>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + is_enable_helptext + " </div>"
                                            html += "<div class='hulkapps_option_value'>"
                                            $.each(values_json, function (index, ovalue) {
                                                var option_text =  ovalue[0]
                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if(option_charge_type == 'percentage_charge' && price != null && price != ""){
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                    }else if(option_charge_type == 'create_mulitplication_charge' && price != null && price != "" ){
                                                        price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                        price = parseFloat(price.toFixed(2));
                                                        window.need_varaint_change = true
                                                    }
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'
                                                is_com_match_val = ''
                                                is_hide_match_val = ''
                                                if(Object.keys(is_value_condition_json).length > 0 ){
                                                    for (const hide_val in is_value_condition_json) {
                                                        if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                            is_com_match_val += ` ${hide_val} `
                                                            is_hide_match_val = is_hide_val
                                                        }
                                                    }
                                                }
                                                if(option_text != 'none'){

                                                    html += "<div class='hulkapps_short_option_value "+is_com_match_val+ " "+is_hide_match_val +"' ><div class='hulkapps_option_name' tabindex='0' aria-label='"+ ovalue[0] +"'>" + ovalue[0] + " </div>"
                                                    html = html + "<input type='text' placeholder='" + placeholder + "' data-option-key='stg_" + option_id + "' id='" + option_id + "' class='hulkapps_option_child hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-shipping-weight= '"+ ovalue[13] +"' data-pid='" + data['pid'] + "'  data-oid='" + option_id + "' data-parent='" + parentClass + "' data-key-name='"+ option_text +"' data-single_valid-class='stg_render' data-val-selected-class='stg_selected'></div>"

                                                }else{
                                                    html = html + "<input type='hidden' placeholder='" + placeholder + "' data-option-key='stg_" + option_id + "' id='" + option_id + "' class='hulkapps_option_child stg_hidden stg_hidden_"+ option_id +" hulkapps_full_width hulkapps_option_" + option_id + " " + opt_class + "' data-price='" + vprice + "'  data-variant-id= '"+ ovalue[12] +"' data-currency-symbol='" + store_currency + "' data-pid='" + data['pid'] + "' data-shipping-weight= '"+ ovalue[13] +"'  data-oid='" + option_id + "' data-parent='" + parentClass + "' data-single_valid-class='stg_render' data-val-selected-class='stg_selected'>"

                                                }

                                            });
                                            html = html + "<input type='hidden' "+hdata_form+"  name='properties[" + option_name + "]' class='stg_property_val'>"
                                            html = html + "</div></div>"
                                            all_html = all_html + html
                                        }
                                    }else if (option_type == 'multi_qty_selector') {
                                        window.hulk_multi_qty_selector = true
                                        if (checkPlan('multi_qty_selector', 'boolean')) {
                                            var  multi_qty_short_code = ''
                                            var opt_val_class = ''
                                            var starting_modal = ''
                                            var ending_modal = ''
                                            var is_popup_class = ''
                                            var min_selection = option_limit != undefined && option_limit != '' && option_limit['minimum_selection'] != undefined && option_limit['minimum_selection'] != '' ? option_limit['minimum_selection'].toString() : '0'
                                            var max_selection = option_limit != undefined && option_limit != '' && option_limit['maximum_selection'] != undefined && option_limit['maximum_selection'] != '' ? option_limit['maximum_selection'].toString() : '0'
                                            var selection_text = (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_max_validation_message,{min:min_selection,max:max_selection})}]</span>` : (min_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean',data['plan_id'],data['plans_features'])) ? `<span aria-label="${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.min_only_validation_message,{min:min_selection})}]</span>` : (max_selection != '0' && checkPlan('validation_for_min_max_option_selection','boolean')) ? `<span aria-label="${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}" tabindex="0" class="selection-text">[${buildValidationMessage(window.max_only_validation_message,{max:max_selection})}]</span>` : '';
                                                if(is_multi_qty_popup_enabled == 'true'){
                                                    var multi_qty_short_code = '<div class="hulk-custom-values-display prop_display_' + option_id + ' "  data-option-id="' + option_id + '"><p><span class="hulkselectedValue"></span><a href="javascript:void(0);" id="hulkModalBtn" class="hulkModalBtn hulkModalBtnSelect" data-prop-class="hulkapps_option_'+ option_id +'_hidden" data-update-div-class="prop_display_' + option_id + '"  data-render-class="option_type_id_' + option_id + '" >'+select_button_text+'</a></p></div>'
                                                    var opt_val_class = "is_hulk_hide"
                                                    var is_popup_class = "hulk_quantity_popup"
                                                    var is_inline = ''
                                                    var isEditCart = ''
                                                    if(hpage_type == 'is_edit_cart'){
                                                        isEditCart = "style='display:none;'"
                                                    }
                                                }
                                                var html =  starting_modal + "<div class='hulkapps_option mq_render "+is_popup_class+" " + is_com_arr + " " + is_required + " " + is_inline + " " + is_single_line + " " + "option_type_id_" + option_id + " " + is_hide_arr + " " + class_name + "' " + idn + " "+isEditCart+" data-parent-id='" + option_id + "'" + (checkPlan('validation_for_min_max_option_selection', 'boolean') ? " data-min='" + min_selection + "' data-max='" + max_selection + "'" : "") + ">";

                                            html += "<div aria-label='" + option_name + "' tabindex='0' aria-required='" + aria_require + " ' class='hulkapps_option_name'><div>" + option_name + " " + is_required_html + " " + is_enabled_tooltip + " " + " </div> "  + selection_text + " " + is_enable_helptext + "</div>"
                                            html += "<div class='hulkapps_option_value hulkapps_product_page_options "+opt_val_class+"'><div class='hulk_multi_qty_main'>"
                                            var valueofhiddenprop = []
                                            var default_count = 0
                                            var valueofhiddenpropinventory = []
                                            var is_tab_index = false
                                            $.each(values_json, function (index, ovalue) {
                                                is_com_match_val = ''
                                                is_hide_match_val = ''
                                                if (Object.keys(is_value_condition_json).length > 0) {
                                                    for (const hide_val in is_value_condition_json) {
                                                        if (is_value_condition_json.hasOwnProperty(hide_val) && Array.isArray(is_value_condition_json[hide_val]) && is_value_condition_json[hide_val].includes(ovalue[0].toString().trim())) {
                                                            is_com_match_val += ` ${hide_val} `
                                                            is_hide_match_val = is_hide_val
                                                        }
                                                    }
                                                }
                                                var price = ovalue[1]
                                                var option_charge_type = ovalue[9]
                                                if (option_charge_type == 'percentage_charge' && price != null && price != "") {
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)/100
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                } else if (option_charge_type == 'create_mulitplication_charge' && price != null && price != "") {
                                                    price = (((parseFloat(product_price)/100)/parseFloat(window.hulkapps_shopify_rate))*price)
                                                    price = parseFloat(price.toFixed(2));
                                                    window.need_varaint_change = true
                                                }
                                                var vp1 = (price != null && price != "") ? " [ " + store_currency + price + " ]" : ""
                                                var vp2 = (price != null && price != "" && disabled_option_price == 0) ? " (+" + store_currency + price + ")" : ""
                                                var vprice = (price != null && price != "") ? price : '0.00'
                                                if(is_enabled_shopify_default_currency){
                                                    if(price != null && price != ""){
                                                        new_price = parseFloat(price) * parseFloat(window.hulkapps_shopify_rate)
                                                        if(rounding_price){
                                                            new_price = Math.round(new_price);
                                                        }else{
                                                            new_price = new_price;
                                                        }
                                                        var vp2 = (new_price != null && new_price != "" && disabled_option_price == 0) ? " [ " + currency_conversion(new_price) + " ]" : ""

                                                    }

                                                }
                                                var default_value = ovalue[4]
                                                if (default_value == true) {
                                                    default_count += 1
                                                    valueofhiddenprop.push(ovalue[0].toString().trim() + vp1)
                                                }
                                                var selectedopt = (default_value == true) ? "checked" : ''
                                                var opt_class = vprice != '' ? 'price-change' : ''
                                                var disable_prop = ""
                                                var hide_class = ""
                                                var disable_class = ''
                                                let manage_inventory = (ovalue[5] != "" && ovalue[5] != null) ? ovalue[5] : ""
                                                let inventory_count = parseInt(ovalue[6])
                                                var hinventroy = ""
                                                let is_continue_selling = (ovalue[7] != "" && ovalue[7] != null) ? ovalue[7] : ""
                                                let disabled_out_of_stock = (ovalue[8] != "" && ovalue[8] != null) ? ovalue[8] : ""
                                                var sku = (ovalue[10] != "" && ovalue[10] != null) ? ovalue[10] : ""
                                                var is_recomodation = (ovalue[11] != "" && ovalue[11] != null) ? ovalue[11] : false
                                                var sku_properties = ""
                                                var disabled_sku = "disabled"
                                                if (manage_inventory.toString() == "true") {
                                                    is_add_unique_prop = true
                                                }
                                                if (manage_inventory.toString() == "true" && is_continue_selling.toString() != "true") {

                                                    hinventroy = inventory_count

                                                    if (default_value == true && hide_class == "" && disable_prop == "") {
                                                        valueofhiddenpropinventory.push(ovalue[0].toString().trim() + vp1 + "_hin_" + hinventroy)
                                                    }
                                                }
                                                if ((default_value == true && inventory_count > 0 && is_continue_selling.toString() != "true") || (default_value == true && inventory_count <= 0 && is_continue_selling.toString() == "true")) {
                                                    disabled_sku = ""
                                                }

                                                if (sku != "") {
                                                    sku_properties = "<input type='hidden' "+hdata_form+"  name='properties[_SKU_" + option_name + "(" + ovalue[0].toString().trim() + ")]' value='" + sku + "' class='hulk_unique_sku' " + disabled_sku + "/>";
                                                }
                                                if (index == '0' && hide_class == '') {
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                } else if (index != '0' && is_tab_index == false) {
                                                    var tabindex = 0
                                                    is_tab_index = true
                                                } else {
                                                    var tabindex = -1
                                                }
                                                if(manage_inventory.toString() == "true" && is_continue_selling.toString() != "true" && inventory_count <= 0){
                                                }else{
                                                            html_checkbox = "<div class='muti-qty-div hulk_quantity_info' ><div class='hulk_swatch_Image is_hulk_hide '><img src='"+ovalue[3]+"'></div>"
                                                            if(is_multi_qty_popup_enabled == 'true'){ 
                                                                html_checkbox +=   "<div class='hulk_merge_qty'>"
                                                            }

                                                            html_checkbox +=   "<div class='hulk_quantity_left'><h5 class='qty-val hulk_size' data-qty-val='" + ovalue[0].toString().trim() + vp1 + "'>" + ovalue[0].toString().trim() + vp2 + sku_properties + "</h5></div><div class='hulk_swatch_desciption is_hulk_hide '><p class='hulk-limited-height'>"+ovalue[12]+"</p><a href='javascript:void(0);' class='hulk-content-display'>See more</a></div><div class='hulk_quantity_div'><div class='hulk_quantity_right'>"
                                                            if (hinventroy > 0 && is_continue_selling.toString() != "true") {
                                                                let uniq_val_identifier = `_hin_${option_unique_name}_hin_${option_name}${ovalue[0].toString().trim()}`

                                                                html_checkbox += "<div class='hulk_stock' data-uid='" + uniq_val_identifier + "' data-hinventory='"+hinventroy+"'> " + hinventroy + " "+window.hulk_inventory_text+" </div>"
                                                            }else{
                                                                html_checkbox += "<div class='hulk_stock' > "+window.hulk_inventory_text+" </div>"
                                                            }
                                                            html_checkbox += "</div><div class='quantity_selector'><button type='button' data-htype='decrement' class='hulk_quantity_button multi-qty-option  hulkapps_option_child hulkapps_option_" + option_id + "_visible " + "hulkapps_product_option_" + option_id + "_visible " + opt_class + " ' >-</button><input  data-min='" + min_selection + "' data-max='" + max_selection + "' step='1' data-htype='number_input' type='number' class='hulk_quantity_amount multi-qty-option' data-qval='0' id='multy_options_quantity'  data-hinventory='" + hinventroy + "' " + disable_prop + " data-parent='" + parentClass + "' data-pid='" + data['pid'] + "' data-single_valid-class='mq_render' data-min='" + min_selection + "' data-max='" + max_selection + "' data-oid='" + option_id + "' id='" + option_id + "' value='0' data-price='" + vprice + " '  data-shipping-weight= '"+ ovalue[14] +"' data-conditional-value='" + ovalue[0].toString().trim() + "' data-value='" + ovalue[0].toString().trim() + vp1 + "' ></input><button type='button' data-htype='increment' class='hulk_quantity_button multi-qty-option  hulkapps_option_child hulkapps_option_" + option_id + "_visible " + "hulkapps_product_option_" + option_id + "_visible " + opt_class + " '>+</button></div></div>"
                                                            if(is_multi_qty_popup_enabled == 'true'){html_checkbox += "</div>"}
                                                            html_checkbox += "</div>"
                                                        html += html_checkbox

                                                }
                                            });

                                            if (checkPlan('validation_for_min_max_option_selection', 'boolean') && ((min_selection && min_selection > 0) || (max_selection && max_selection > 0))) {
                                                var progress_bar_background_color = data['display_settings']['progress_bar_background_color']
                                                html += `
                                                    <div class="hulk-progress-bar-wrapper" data-min="${min_selection}" data-max="${max_selection}">
                                                        <div class="hulk-progress-bar" style="background: ${progress_bar_background_color}"></div>
                                                        <span class="hulk-progress-label">0 / ${max_selection}</span>
                                                    </div>
                                                `;
                                            }

                                            if((is_required == 'required' && (min_selection != 0 || max_selection != 0))){
                                                if (min_selection != '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                    if (parseInt(default_count) < parseInt(min_selection) || parseInt(default_count) > parseInt(max_selection)) {
                                                        html += `</select><span class="validation_error error_span">${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`
                                                    }
                                                } else if (min_selection != '0' && max_selection == '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                    if (parseInt(default_count) < parseInt(min_selection)) {
                                                        html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`
                                                    }
                                                } else if (min_selection == '0' && max_selection != '0' && checkPlan('validation_for_min_max_option_selection', 'boolean' )) {
                                                    if (parseInt(default_count) > parseInt(max_selection)) {
                                                        html += `</select><span class=\"validation_error error_span\">${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`
                                                    }
                                                }
                                            }
                                            var validation_error = '</div><span class=\"validation_error error_span\" >'
                                            var unique_prop_html = ""
                                                unique_prop_html = "<input type='hidden' "+hdata_form+"  name='properties[_hin_" + option_unique_name + "_hin_" + option_name + "]' value='" + valueofhiddenpropinventory + "' class='hulk_unique_prop hulk_mqty_session'  data-unique_prop_name='_hin_" + option_unique_name + "_hin_" + option_name + "' data-selection-multi='true'/>"
                                            html += unique_prop_html
                                            html += "<input class='hulkapps_option_child hulk_mutli_qty' value='" + valueofhiddenprop.join(', ') + "' type='hidden' id='hulkapps_option_" + option_id + "_hidden' "+hdata_form+"  name='properties[" + option_name + "]'></div>"
                                            html = html + "</div>"
                                            html = html + multi_qty_short_code 
                                            html = html + "</div>"
                                            all_html = all_html + html  
                                        }
                                    }
                                }
                            });
                            var recommended_btn_html_desc = "<div class=''  id='recommended_detail' style='display: none'><div class='recommended_detail'><div class='recomodation_option_desc'><div class='recomodation-title'><span class='hulkapp_close close recommended_close_link' tabindex='0' aria-label='close recommended popup' >x</span></div><div tabindex='0' class='recomodation_option_detail' style='padding: 10px;'>"+recommended_html+"</div></div></div><div class='overlay-popup'></div></div>"

                            var currency_hidden_field = "<input type='hidden' name='currency_symbol' value='" + store_currency + "'>"
                            if (all_html !== '') {
                                addtocart_html = addtocart_html + all_html  + currency_hidden_field
                            }
                            $("body").append(recommended_btn_html_desc)
                            addtocart_html += "</div>"
                            if (parseInt(amount_note_display) == 1 || amount_note_display == '') {
                                addtocart_html += "<div id='option_total' style='display: none;'><input type='hidden' id='raw_option_total' value='0'><div id='option_display_total_format' tabindex='0'>" + update_total_text + "<span id='formatted_option_total'>" + data['currency_symbol'] + "<span id='calculated_option_total'>0.00</span></span>" + post_total_text + "</div></div>"
                            }
                            addtocart_html += "<div id='error_text'></div>"
                            addtocart_html += "</div></div>"
                        }
                        if ($('#hulkapps_custom_options_' + window.hulkapps.product_id).length == 0 && !['is_collection_page', 'is_edit_cart'].includes(hpage_type)) {
                            let found_selectors = 0;
                            let selectors = cart_selectors.split(',')
                            selectors.forEach(function (selector) {
                                found_selectors += $(selector).length;
                                if (window.hulk_add_to_cart_ele == null && found_selectors) {
                                    window.hulk_add_to_cart_ele = $(selector).first()
                                }
                            });

                            var vol_el_after = window.hulk_add_to_cart_ele;
                            if (vol_el_after.parent().is("div")) {
                                vol_el_after = vol_el_after.parent()
                            }
                            vol_el_after.before('<div id="hulkapps_custom_options_' + window.hulkapps.product_id + '"></div><div class="product-hulkapps-discount-code-html"></div>');
                        }
                        if(hpage_type == 'is_collection_page'){
                               addtocart_html = `<div class="col_hulkapp_popupOverlay hulk_po_${window.hulkapps.product_id}"><div class="col_hulkapp_popupBox"><div class="col_hulkapp_mainHead"><p class="col_hulkapp_popup-heading">Choose options</p><span class="col_hulkapp_close close">×</span></div><div class="col_hulkapp_mainContent">${addtocart_html}</div><div class="co_hulkapp_popup-footer">
                               <button class="col_hulkapp_close btn btn--secondary button hulkapps_btn_cancel" type="button">Cancel</button>
                               <button class=" btn btn--primary button hulkapps_btn_save co_options_save" data-quantity="1" data-product_id='${window.hulkapps.product_id}'>Save changes</button>
                             </div></div></div>`
                             $(`.hulkapps-po-main_parent_${window.hulkapps.product_id}`).find(`.col_hulkapp_popupOverlay`).remove();

                             $(`.hulkapps-po-main_parent_${window.hulkapps.product_id}`).append(addtocart_html);
                             window.is_on_click = true;
                             $('.col_hulkapp_popupOverlay').appendTo('body');
                        }else if (hpage_type == 'is_edit_cart') { 
                            var itemFound = null;
                            var itemKey = editCartButton.data("key");
                            var cart = window.hulkapps.cart;
                            var cartItem = (cart && cart.items) ? cart.items.find(i => i.key === itemKey) : null;
                            if (!cartItem || !cartItem.properties) return;
                            // Find the cart item matching this product (and variant if needed)
                            cart.items.forEach(function(item, index) {
                                if (item.product_id == window.hulkapps.product_id) {
                                    itemFound = { index: index, variant_id: item.variant_id };
                                }
                            });

                            if (itemFound) {
                                // Add hidden inputs into the addtocart_html before showing popup
                                addtocart_html += `
                                    <input type="hidden"  name="h_index" class="h_index" value="${itemFound.index}">
                                    <input type="hidden"  name="id" class="h_variant_id" value="${itemFound.variant_id}">
                                `;

                                // Build popup
                                var popupHtml = `
                                    <div class="hulkapp_popupOverlay hulk_po_${window.hulkapps.product_id}">
                                        <div class="hulkapp_popupBox">
                                            <div class="hulkapp_mainHead">
                                                <p class="hulkapp_popup-heading">${window.hulkapps.product_title}</p>
                                                <span class="hulkapp_close hulkapp_close close">×</span>
                                            </div>
                                            <div class="hulkapp_mainContent">${addtocart_html}</div>
                                            <div class="co_hulkapp_popup-footer">
                                                <button class="hulkapp_close btn btn--secondary button hulkapps_btn_cancel" type="button">Cancel</button>
                                                <button class="hulkapp_save btn btn--primary button hulkapps_btn_save" 
                                                    data-quantity="${cartItem.quantity}"
                                                    data-product_id="${window.hulkapps.product_id}">
                                                    Save changes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                `;

                                $('body').addClass('body_fixed');
                                $('body').find('.edit_popup').remove();
                                $('body').append('<div class="edit_popup" style="display: none;"><form method="post" data-action="/cart/add" id="edit_cart_popup" class="edit_form" enctype="multipart/form-data"></form></div>');
                                $('#edit_cart_popup').last().html(popupHtml);
                                $('.edit_popup').show();
                            }

                                setTimeout(function() {
                                    preSelectCartOptions(editCartButton);
                                }, 100);
                        }else{
                             $("#hulkapps_custom_options_" + window.hulkapps.product_id).html(addtocart_html);
                        }
                        initDatePickers(hpage_type);
                        // Pass the correct parent class so requireInventory / conditional_rules
                        // target the edit-cart popup's wrapper (hulkapps_edit_product_options)
                        // when the options were rendered for the edit-in-cart flow. Previously
                        // both calls were hard-coded to 'hulkapps_product_options', so the
                        // popup's #conditional_rules block was never evaluated and conditions
                        // (including variant-based show/hide) silently did nothing.
                        requireInventory(window.hulkapps.product_id, parentClass)
                        keybordAccess();
                        window.dynamic_checkout_button_integration = data['display_settings']['dynamic_checkout_button_integration']
                        if(Shopify.shop == "demo-bhavya.myshopify.com" || Shopify.shop == "amish-baskets.myshopify.com" || Shopify.shop == "fws-rushking.myshopify.com"){
                            window.is_checkout_api = data['display_settings']['is_checkout_api']
                        }
                        window.is_product_page_doscount_code = data['display_settings']['dynamic_checkout_discount_code']
                        window.ignore_min_max_validation = data['display_settings']['ignore_min_max_validation']
                        conditional_rules(window.hulkapps.product_id, parentClass);
                        $('#hulkapps_options_' + window.hulkapps.product_id).closest("form").find(':submit').addClass('hulkapps_submit_cart');
                        if(window.$first_add_to_cart_el){
                            window.$first_add_to_cart_el.removeClass('hulkapps_submit_cart').addClass('hulkapps_submit_cart');
                        }
                        if ($('#hulkapps_option_list_' + window.hulkapps.product_id + ' .hulkapps_option_set').html() == "") {
                            $('#hulkapps_options_' + window.hulkapps.product_id).css("display", "none");
                        }

                        if(window.hulk_multi_qty_selector){
                            window.hulkUpdateStockStatus($);
                        }
                        // }, 500);
                },
                error: function (request, error) {
                    if(window.$first_add_to_cart_el){
                        window.$first_add_to_cart_el.removeAttr("disabled")
                    }
                }

            });
        }
        window.hulkappsStart = function ($) {
            window.$first_add_to_cart_el = null;
            var selectors = ["input[name='add']", "button[name='add']", "#add-to-cart", "#AddToCartText", "#AddToCart",'form[action$="/cart/add"] :input[type="submit"], .hulkapps_submit_cart'];
            var found_selectors = 0;
            selectors.forEach(function (selector) {
                found_selectors += $(selector).length;
                if (window.$first_add_to_cart_el == null && found_selectors) {
                    window.$first_add_to_cart_el = $(selector).first()
                }
            });
            if(window.$first_add_to_cart_el){

                window.$first_add_to_cart_el.attr("disabled", true);
                setTimeout(
                    function()
                    {
                        window.$first_add_to_cart_el.removeAttr("disabled")
                    }, 2500);
            }



            if (window.hulkapps.page_type == "product" && window.hulkapps.product_id && window.hulkapps.store_id) {            
                function handleVariantChange(event) {
                    var selected_option_list = [];
                    var selector_var = document.querySelectorAll(".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio'], variant-picker select")
            
                    selector_var.forEach(function (selector) {
                        var dropdown_selector = selector.options ? selector.options[selector.options.selectedIndex].selected : false;
                        if (selector.checked || dropdown_selector) {
                            selected_option_list.push(selector.value);
                        }
                    });
            
                    selected_option_list = selected_option_list.join(' / ');
            
                    Object.keys(hulk_variants).forEach(function (key) {
                        var val = hulk_variants[key];
                        if (val.options.length < 2) {
                            selected_variant_title = event.target.value.toString().toLowerCase();
                            var variantTitle = val.title.toString().toLowerCase();
                            if (variantTitle.trim() == selected_variant_title.trim()) {
                                var variantId = val.id;
                                window.hulkapps.product.selected_variant = val.id;
                                product_price = val.price;
                                compare_product_price = val.compare_at_price;
                                window.hulkapps.product.selected_variant_price = product_price;
                                window.hulkapps.product.selected_variant_compare_price = compare_product_price;
                            }
                        } else {
                            selected_variant_title = selected_option_list.toString().toLowerCase();
                            var variantTitle = val.title.toString().toLowerCase();
                            if (selected_variant_title.includes(variantTitle)) {
                                var variantId = val.id;
                                window.hulkapps.product.selected_variant = val.id;
                                product_price = val.price;
                                compare_product_price = val.compare_at_price;
                                window.hulkapps.product.selected_variant_price = product_price;
                                window.hulkapps.product.selected_variant_compare_price = compare_product_price;
                            }
                        }
                        if(document.querySelector('script[type="application/json"][data-variant]')){
                            updateSelectedVariant();
                        }
                    });
            
                    setTimeout(function () {             
                        conditional_rules(window.hulkapps.product_id,'hulkapps_product_options');
                        
                    }, 800);
                }
            
                // Call product_page_btn_condition initially
                product_page_btn_condition();
            
                // Use event delegation
                document.addEventListener('change', function(event) {
                    var targetSelectors = ".single-option-selector,.swatch-element input[type='radio'],.single-option-selector__radio, select[data-option='option1'], select[data-option='option1']:checked, select[data-option='option2'], select[data-option='option1']:checked, select[data-option='option3'], select[data-option='option3']:checked, select[data-index='option1'], select[data-index='option1']:checked, select[data-index='option2'], select[data-index='option1']:checked, select[data-index='option3'], select[data-index='option3']:checked, ul li div[swatch-option='option1'], input[type='radio']"
                    
                    if (event.target.matches(targetSelectors)) {
                        handleVariantChange(event);
                    }
                });

                // Call productPageAjax
                productPageAjax($);
            }

            $("body").on("change", 'input[name="updates[]"]', function (ev) {
                $('[name="update"]').click()
            });

            window.hulkUpdateStockStatus = function ($) {
                let prop_json = {};

                new Promise((resolve, reject) => {
                    $.getJSON('/cart.js', { _: new Date().getTime() }, function (cart) {
                        if (cart && cart.item_count > 0) {
                            cart.items.forEach(function (selector) {
                                var quantity = selector.quantity;
                                if (selector['properties'] != null && selector['properties'] != {}) {
                                    $.each(selector['properties'], function (key, value) {
                                        if (key.startsWith("_hin") && value) {
                                            //quantity = 1;
                                            if(window.opt_with_otc[key] == true || window.opt_with_otc[key] == 'true'){
                                                quantity = 1
                                            }
                                            if (value.includes(",")) {
                                                let values = value.split(",");
                                                values.forEach(function (value) {
                                                    let json_key = value.split("_hin_")[0];
                                                    var options_qty = $.trim(value.split('_hin_')[1].split('|')[1]);
                                                    if (options_qty.includes(")")) {
                                                        options_qty = parseInt(options_qty.split(")"));
                                                    } else {
                                                        options_qty = options_qty;
                                                    }
                                                    if (options_qty <= 0) {
                                                        options_qty = 1;
                                                    }
                                                    json_key = key + $.trim(json_key.split('[')[0]);
                                                    if (prop_json[json_key]) {
                                                        prop_json[json_key] = prop_json[json_key] + (quantity * options_qty);
                                                    } else {
                                                        prop_json[json_key] = quantity * options_qty;
                                                    }
                                                });
                                            } else {
                                                var options_qty = $.trim(value.split('_hin_')[1].split('|')[1]);
                                                if (options_qty.includes(")")) {
                                                    options_qty = parseInt(options_qty.split(")"));
                                                } else {
                                                    options_qty = options_qty;
                                                }
                                                if (options_qty <= 0) {
                                                    options_qty = 1;
                                                }
                                                let json_key = key + $.trim(value.split('_hin_')[0].split('[')[0]);
                                                if (prop_json[json_key]) {
                                                    prop_json[json_key] = prop_json[json_key] + (quantity * options_qty);
                                                } else {
                                                    prop_json[json_key] = quantity * options_qty;
                                                }
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        resolve(prop_json);
                    });
                }).then(function (prop_json) {
                    for (const key in prop_json) {
                        if (prop_json.hasOwnProperty(key)) {
                            let mqty_selector = $(`[data-uid='${key}']`);
                            if (mqty_selector.length > 0) {
                                let databse_qty = parseInt(mqty_selector.attr('data-hinventory'));
                                let value_remaining_qty = databse_qty - parseInt(prop_json[key]);
                                
                                if(mqty_selector.hasClass('hulk_stock')){
                                    if (value_remaining_qty > 0) {
                                        if(mqty_selector.hasClass('dropdown_swatch')){
                                            mqty_selector.find('.dropdown-text').text(`${value_remaining_qty} ${window.hulk_inventory_text}`);

                                        }else{
                                            mqty_selector.text(`${value_remaining_qty} ${window.hulk_inventory_text}`);
                                        }
                                    } else {
                                        if(mqty_selector.hasClass('dropdown_swatch')){
                                            mqty_selector.find('.dropdown-text').text(`${window.hulk_out_of_stock_text}`);
                                        }else{
                                            mqty_selector.text(`${window.hulk_out_of_stock_text}`);
                                        }
                                    } 
                                }
                                else{
                                    let data_display_value = mqty_selector.attr('data-display-val') + " / "
                                    if (value_remaining_qty > 0) {
                                        
                                        if(mqty_selector.hasClass('dropdown_swatch')){
                                            mqty_selector.find('.dropdown-text').text(`${data_display_value} ${value_remaining_qty} ${window.hulk_inventory_text}`);
                                        }else{
                                            mqty_selector.text(`${data_display_value} ${value_remaining_qty} ${window.hulk_inventory_text}`);
                                        }
                                    } else {
                                        if(mqty_selector.hasClass('dropdown_swatch')){
                                            mqty_selector.find('.dropdown-text').text(`${data_display_value} ${window.hulk_out_of_stock_text}`);

                                            }else{
                                            mqty_selector.text(`${data_display_value} ${window.hulk_out_of_stock_text}`);

                                        }
                                    } 
                                }
                                
                            }
                        }
                    }
                });
            }

            
        }

        window.hulkappsParseURL = function (url) {
            if(url){
                var pattern = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
                var matches = url.match(pattern);
                var query = matches[7];
                if (query) {
                    query = new URLSearchParams(query);
                }
                return {
                    scheme: matches[2],
                    authority: matches[4],
                    path: matches[5],
                    query: query,
                    fragment: matches[9]
                };
            }

        }
        hulkappsStart($);
        window.dispatchEvent(new CustomEvent('HulkEvents',{
            detail: {
                app: 'Product Options',
                status: 'CommonJS Loaded'
            }
        }))

        // Escape HTML to prevent XSS attacks
        window.escapeHtml = function(text) {
            if (!text) return '';
            var map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };
            return String(text).replace(/[&<>"']/g, function(m) { return map[m]; });
        };

        window.buildValidationMessage = function (template, values) {
            if (!template) return '';

            return template.replace(/\{(\w+)\}/g, function(match, key) {
                return (values[key] !== undefined && values[key] !== null) ? values[key] : match;
            }); 
        }

    }

    window.getCartInfo = function (cart_item = 0, cart = "", $ = hulkapps_jQuery) {
        var cart = cart
        if (cart_item != 0) {
            var updated_item_key = cart_item.key
            let properties = cart_item.properties
            if (properties) {
                var proprtyHTML = ''
                Object.keys(properties).forEach(function (key) {
                    if (properties[key].includes("uploads")) {
                        var file_array = properties[key].split("/");
                        var find_position = file_array.length - 1;
                        var file_property_val = file_array[find_position]
                        proprtyHTML += '<div class="product-option"><dt>' + key + ': </dt><dd>  <a href="' + properties[key] + '" class="link" target="_blank">' + file_property_val + '</a></dd></div>';
                    } else {
                        if(!key.startsWith("_hin")){
                            if(!key.startsWith("_SKU")){
                                proprtyHTML += '<div class="product-option"><dt>' + key + ': </dt><dd class="hpo-price">' + properties[key] + '</dd></div>';
                            }

                        }
                    }
                });
                window.currentEditOptionSelector.parents(window.cart_lineitem_parents_selectors
                ).find(window.cart_item_properties_selectors).html(proprtyHTML);
            } else {
                window.currentEditOptionSelector.parents(window.cart_lineitem_parents_selectors
                ).find(window.cart_item_properties_selectors).html("");
            }
        }
        new Promise(function (resolve, reject) {
            if (!cart) {
                $.getJSON('/cart.js', {_: new Date().getTime()}, function (cart) {
                    resolve(cart);
                });
            } else {
                resolve(cart);
            }
        }).then(function (cart) {
            if(cart && cart.item_count > 0) {
                var storage_code = localStorage.getItem('discount_code')
                window.hulkapps.cart = cart
                new Promise((resolve, reject) => {
                    $.ajax({
                        url: "/cart?view=hulkapps_cart_collections.json", success: function (result) {
                            try {
                                if (result) {
                                    var obj = JSON.parse(result)
                                    if (obj) {
                                        var items = obj.items
                                        $.each(items, function (index, pcollections) {
                                            window.hulkapps.cart_collections[pcollections['variant_id']] = pcollections['product_collections']
                                        });
                                    }
                                }
                                resolve(window.hulkapps.cart_collections)
                            } catch (err) {
                                resolve(window.hulkapps.cart_collections)
                            }
                        },
                        error: function (error) {
                            resolve(window.hulkapps.cart_collections)
                        }
                    })
                }).then(function (cart_collections) {
                    window.hulkapps.cart_collections = cart_collections
                    let updated_cart_data = Object.assign({}, window.hulkapps); // Cloning the object
                    delete updated_cart_data["product"];

                    if (storage_code != '') {
                        $('.hulkapps_discount_code').val(storage_code);
                                                   
                        var get_cart_data = {
                            cart_data: updated_cart_data,
                            store_id: window.hulkapps.store_id,
                            discount_code: storage_code,
                            cart_collections: JSON.stringify(window.hulkapps.cart_collections),
                            customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',
                            currency_rate: window.hulkapps_shopify_rate
                        }
                    } else {
                        var get_cart_data = {
                            cart_data: updated_cart_data,
                            store_id: window.hulkapps.store_id,
                            cart_collections: JSON.stringify(window.hulkapps.cart_collections),
                            customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',
                            currency_rate: window.hulkapps_shopify_rate
                        }
                    }
                    // var get_cart_data = {
                    //     cart_data: window.hulkapps,
                    //     store_id: window.hulkapps.store_id,
                    //     cart_collections: JSON.stringify(window.hulkapps.cart_collections),
                    //     customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',
                    // }
                    var count = 0
                    cart.items.forEach(function (selector) {
                        if (selector['properties'] != null && selector['properties'] != {})
                            count++
                    });
                    if (count > 1)
                        $(checkout_selectors).attr('disabled', true);
                    else
                        $(checkout_selectors).attr('disabled', false);
                    $(checkout_selectors).attr('disabled', true);
                    $.ajax({
                        type: "POST",
                        url: window.hulkapps.po_url + "/store/get_cart_details",
                        data: get_cart_data,
                        crossDomain: true,
                        success: function (data) {
                            $(checkout_selectors).attr('disabled', false);
                            // Normalize response
                            if (typeof data === "string") {
                                try {
                                    data = JSON.parse(data);
                                } catch (e) {
                                    console.warn("Invalid JSON response from get_cart_details");
                                    return;
                                }
                            }
                            if(!$.isEmptyObject(data)){
                                var cart_item_price_selectors = data.discounts['cart_item_price_selectors']
                                window.hulk_po_currency_symbol = data.discounts['currency_symbol']
                                var cart_item_line_price_selectors =  data.discounts['cart_item_line_price_selectors']
                                var cart_item_line_price_before_discount =  data.discounts['cart_item_line_price_before_discount']

                                window.cart_lineitem_parents_selectors =  data.discounts['cart_lineitem_parents_selectors'].split(',')[0]
                                window.cart_item_properties_selectors =  data.discounts['cart_item_properties_selectors'].split(',')[0]
                                data.discounts.cart.items.forEach(function (item, index) {
                                    setTimeout(function () {
                                        var $btn = $('.edit_cart_option[data-key="'+ item.key +'"]');

                                        if (item.has_properties) {
                                            $btn.show();
                                        } else {
                                            $btn.hide();
                                        }
                                        if (updated_item_key) {
                                            if (item.key == updated_item_key) {
                                                cart_item_price_selectors = cart_item_price_selectors.split(',')
                                                $.each(cart_item_price_selectors, function( index, selector ) {
                                                    window.currentEditOptionSelector.parents(window.cart_lineitem_parents_selectors).find(selector).html(item.original_price_format)
                                                });
                                                cart_item_line_price_selectors = cart_item_line_price_selectors.split(',')
                                                $.each(cart_item_line_price_selectors, function( index, selector ) {
                                                    window.currentEditOptionSelector.parents(window.cart_lineitem_parents_selectors).find(selector).html(item.original_line_price_format)
                                                });
                                                cart_item_line_price_before_discount = cart_item_line_price_before_discount.split(',')
                                                $.each(cart_item_line_price_before_discount, function( index, selector ) {
                                                    window.currentEditOptionSelector.parents(window.cart_lineitem_parents_selectors).find(selector).html(item.cart_item_line_price_before_discount)
                                                });
                                            }
                                        }
                                    }, 500);
                                });


                                hulkappsDoActions(data)
                                window.hulk_inventory_arr = data.discounts.inventory_arr
                                if (data.discounts.is_draft_order) {
                                    window.is_draft_order = true;
                                } else {
                                    window.is_draft_order = false;
                                }
                                if (data.discounts.inventory_arr &&  data.discounts.inventory_arr.length <= 0) {
                                    $(".inventory_validation_hulkapps").remove();
                                }

                                if(data.discounts['is_enabled_shopify_default_currency'] && data.discounts['is_enabled_shopify_default_currency'] == true){
                                    $('.hpo-price').each(function(){
                                        let updatedStr = $(this).text()
                                        pricesArray = updatedStr.split(",")
                                    
                                        pricesArray.forEach((item, index) => {
                                            let match = item.match(/\[\s*[^\d]*([\d,.]+)\s*\]/); // Focus only on the numeric part
                                            if (match) {
                                                let price = parseFloat(match[1].replace(',', '')); // Convert to float, remove commas
                                                let updated_price = (price * parseFloat(window.hulkapps_shopify_rate)); // Multiply and format to 2 decimal places
                                                
                                                // Replace the old price with the updated price in the same format

                                                pricesArray[index] = item.replace(match[0], `[ ${currency_conversion(updated_price)} ]`);
                                            }
                                        });
                                        updatedStr = pricesArray.join(",")
                                        $(this).html(updatedStr);
                                    });
                                }

                            }else{
                            window.is_draft_order = false;
                           
                        }
                        },

                        error: function (request, error) {
                            $(checkout_selectors).attr('disabled', false);
                        }
                    })
                }).catch(function (error) {
                    console.error(error);
                })
            }
        }).catch(function (error) {
        })
    }

    window.cartPageJS = function ($) {
        
        $(document).on('keypress', '.hulkapps_discount_code', function (e) {
            if (e.which == 13) {
                $(".hulkapps_discount_button").click();
            }
        });

        // Button click for Apply Discount.
        $(document).on('click', '.hulkapps_discount_button', function (e) {
            e.preventDefault();
            var code = $(this).parents(".discount_code_box").find('.hulkapps_discount_code').val();
            code = $.trim(code)
            if (code == '') {
                $('.hulkapps_discount_code').addClass('discount_error');
            } else {
                localStorage.setItem('discount_code', code);
                $('.hulkapps_discount_code').removeClass('discount_error');

            }
            window.getCartInfo();
        });


        $(document).on('click', '.close-tag', function (e) {
            localStorage.removeItem('discount_code');
            window.getCartInfo();
        });

        
        // When user click on edit_cart save popup.
        $(document).on('click', '.hulkapp_save', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var line = parseInt($(this).parents('.hulkapp_popupBox').find('.hulkapp_mainContent').find('.h_index').val()) + 1;
            var qty = $(this).attr('data-quantity');
            var line_variant_id = $(this).parents('.hulkapp_popupBox').find('.hulkapp_mainContent').find('.h_variant_id').val();
            var properties = {};
            new Promise((resolve, reject) => {
                var is_good = validate_options($(this).data('product_id'),"hulkapps_edit_product_options",$(this).attr('data-quantity'));
                resolve(is_good)
            }).then(function (is_good) {
                if (is_good) {
                    $(checkout_selectors).attr('disabled', true);
                    isFilePresent = false
                    $("#edit_cart_popup [name^='properties']").each(function (index, el) {
                        if ($(this).val() == '') {
                            $(this).remove();
                        }
                        var name;
                        if (this.type == "radio") {
                            if (this.checked) {
                                name = this.name.replace('properties[', '').replace(']', '');
                                if ($.trim(this.value).length > 0) {
                                    properties[name] = this.value;
                                }
                            }
                        } else if (this.type == "file") {
                            isFilePresent = true
                            name = this.name.replace('properties[', '').replace(']', '');
                            if ($.trim(this.value).length > 0) {
                                properties[name] = this.value;
                            }

                        } else {
                            name = this.name.replace('properties[', '').replace(']', '');
                            if ($.trim(this.value).length > 0) {
                                properties[name] = this.value;
                            }
                        }

                    });
                    if ($.isEmptyObject(properties)) {
                        if ($('.upload_cls').val() != '') {
                            $('.upload_h_cls').remove();
                        } else {
                            $('.upload_cls').remove();
                        }
                        $('#edit_cart_popup .conditional').each(function (index, element) {
                            $(this).find('.hulkapps_option_value input[type="hidden"]').val('');
                        });
                        $("[name^='properties']").each(function (index, el) {
                            if ($(this).val() == '') {
                                $(this).remove();
                            }
                        });
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: {
                                quantity: 0,
                                line: line
                            },
                            dataType: 'json',
                            success: function (cart) {

                                if ($('.upload_cls').val() != '') {
                                    $('.upload_h_cls').remove();
                                } else {
                                    $('.upload_cls').remove();
                                }
                                $('#edit_cart_popup .conditional').each(function (index, element) {
                                    $(this).find('.hulkapps_option_value input[type="hidden"]').val('');
                                });
                                $("[name^='properties']").each(function (index, el) {
                                    if ($(this).val() == '') {
                                        $(this).remove();
                                    }
                                });
                                $.ajax({
                                    type: 'POST',
                                    url: '/cart/add.js',
                                    data: {
                                        quantity: qty,
                                        id: line_variant_id
                                    },
                                    dataType: 'json',
                                    success: function (cart_item) {
                                        window.currentEditOptionSelector.data("key", cart_item.key)
                                        window.getCartInfo(cart_item);
                                        $(".hulkapp_close").click();
                                        if(Shopify.shop == 'wine-delight.myshopify.com'){
                                            location.reload();
                                        }
                                    }
                                });
                            }
                        });
                    } else {
                        var formData = new FormData($('#edit_cart_popup')[0]);
                        formData.append('quantity', qty);
                        formData.append('line', line);
                        if ($('.upload_cls').val() != '') {
                            $('.upload_h_cls').remove();
                        } else {
                            $('.upload_cls').remove();
                        }
                        $('#edit_cart_popup .conditional').each(function (index, element) {
                            $(this).find('.hulkapps_option_value input[type="hidden"]').val('');
                        });
                        $("[name^='properties']").each(function (index, el) {
                            if ($(this).val() == '') {
                                $(this).remove();
                            }
                        });

                        if(isFilePresent){
                            oldCartUpdateCall();
                        }else{
                            newCartUpdateCall();
                        }

                        function oldCartUpdateCall(){
                            $.ajax({
                                type: 'POST',
                                url: '/cart/change.js',
                                data: {
                                    quantity: 0,
                                    line: line
                                },
                                dataType: 'json',
                                success: function (cart) {
                                    if ($('.upload_cls').val() != '') {
                                        $('.upload_h_cls').remove();
                                    } else {
                                        $('.upload_cls').remove();
                                    }
                                    $('#edit_cart_popup .conditional').each(function (index, element) {
                                        $(this).find('.hulkapps_option_value input[type="hidden"]').val('');
                                    });
                                    $("[name^='properties']").each(function (index, el) {
                                        if ($(this).val() == '') {
                                            $(this).remove();
                                        }
                                    });
                            
                                    $.ajax({
                                        type: 'POST',
                                        url: '/cart/add.js',
                                        data: formData,
                                        dataType: 'json',
                                        contentType: false,
                                        processData: false,
                                        success: function (cart_item) {
                                            window.currentEditOptionSelector.data("key", cart_item.key)
                                            window.getCartInfo(cart_item);
                                            $(".hulkapp_close").click();
                                        }
                                    });
                                }
                            });
                        }
                        
                        function newCartUpdateCall(){
                            formData.append('id', window.currentEditOptionSelector.data('key'));
                            let newProps = {};
                            formData.forEach((v,k)=>{
                                if (k.startsWith('properties[')) {
                                    let key = k.replace('properties[','').replace(']','');
                                    newProps[key] = v;
                                }
                            });

                            $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: formData,
                            dataType: 'json',
                            contentType: false,
                            processData: false,
                            success: function(cart) {
                                updated = cart.items.find(i =>
                                    i.product_id == window.hulkapps.product_id &&
                                    JSON.stringify(i.properties) == JSON.stringify(newProps)
                                );
                                if (updated) {
                                    window.currentEditOptionSelector.data('key', updated.key);
                                    window.getCartInfo(updated);
                                }
                                $(".hulkapp_close").click();
                            }
                            });

                        }

                    }
                }
                ;
            }).catch(function (error) {
                console.log(error)
            });
        });
        $(document).on('change', '.hulk_product_image_ccheckbox', function(e) {
            $(this).is(':checked') ? $(this).parent().addClass('image_customized') : $(this).parent().removeClass('image_customized');
        });

        // When edit_cart popup is close.
        $(document).on('click touchstart', '.hulkapp_close', function (e) {
            $('.edit_popup').hide();
            $('body').removeClass('body_fixed');
        });
        $(document).on('click touchstart', '.col_hulkapp_close', function (e) {
            $(`.hulk_po_${window.hulkapps.product_id}`).hide();
            $('body').removeClass('body_fixed');
        });
        $(document).on('click touchstart', '.co_options_save', function (e) {
            e.preventDefault();
               var this_else = $(this);
                new Promise((resolve, reject) => {
                    var is_good = validate_options(window.hulkapps.product_id,"hulkapps_product_options")
                    resolve(is_good)
                }).then(function (is_good) {
                    if (is_good) {
                        
                        var currentSelector = this_else.parent('.co_hulkapp_popup-footer').parent('.col_hulkapp_popupBox').find('.col_hulkapp_mainContent');
                        var hulk_properties_elements = currentSelector.find('input[name^="properties"][value!=""]');
                        $(`.hulkapps-po-main_form_${window.hulkapps.product_id}`).find(`.hulkapps_po_properties_${window.hulkapps.product_id}`).remove();
                        $(`.hulkapps-po-main_form_${window.hulkapps.product_id}`).append(`<div class="hulkapps_po_properties_${window.hulkapps.product_id}" style="display: none;"></div>`)
                        hulk_properties_elements.each(function() {
                            if($(this).val() != ""){
                                $(`.hulkapps_po_properties_${window.hulkapps.product_id}`).append($(this).clone());
                            }
                        });
                        $(`.hulk_po_${window.hulkapps.product_id}`).hide();

                        $('body').removeClass('body_fixed');
                        hulk_flag = 1;
                    }
                }).catch(function (error) {

                })
            
        });
        $(document).on('keyup', '.hulkapps_discount_code', function (e) {
            if($.trim($(this).val()) != "" ){
                $(".hulkapps_product_discount_button").removeAttr("disabled");
                $(".hulkapps_product_discount_button").removeClass("hulkapps_product_discount_disabled_button");
            }else{
                $(".hulkapps_product_discount_button").attr("disabled","disabled");
                $(".hulkapps_product_discount_button").addClass("hulkapps_product_discount_disabled_button");
            }
        });
    }

    window.productPageJS = function ($) {
        $(document).on('click', '.hulkModalBtnSelect', function (e) {
            var popup_html_class = $(this).attr("data-render-class");
            var update_prop_class = $(this).attr("data-update-div-class");
            var data_prop_class = $(this).attr("data-prop-class");
            var popup_html = $(`.${popup_html_class}`).html();
            $("body").find('#hulk_form_modal').remove();
            $("body").prepend('<div id="hulk_form_modal" class="hulk_form_modal" data-option-id="multi_qty" style="display:none"><div class="hulk-modal-content"><div class="hulk-modal-header"><h6></h6><span class="close hulkcloseBtn">×</span></div><div class="hulk-modal-body"></div><div class="hulk-modal-footer"><button class="hulkresetBtn">Reset</button><button class="hulkcloseBtn hulkCancelBtn">Cancel</button><button class="hulkSaveBtn">Continue</button></div></div></div>')
            $('.hulk_form_modal').show();
            if($('.muti-qty-div').length > 0){
                $('.hulk_form_modal').find('.hulk-modal-body').html(popup_html);
                $('#hulk_form_modal > div > div.hulk-modal-body > p.inventory_error').remove();

                $('.hulk_form_modal').find('.hulk-modal-body').find('.hulkapps_option_value').removeClass('is_hulk_hide');
                $('.hulk_form_modal').find('.hulk-modal-body').find('.hulkapps_option_value').find('.hulk_swatch_Image').removeClass('is_hulk_hide');
                $('.hulk_form_modal').find('.hulk-modal-body').find('.hulk_swatch_desciption').removeClass('is_hulk_hide');
                var header_text = $('.hulk_form_modal').find('.hulk-modal-body').find('.hulkapps_option_name').attr('aria-label').trim()
                var selected_val = $(this).attr("data-selected-val");
                var totalSelected = 0
                if(selected_val && selected_val.length > 0){
                    var all_selected_values = selected_val.split(',');
                    // Loop through each selected value
                    $.each(all_selected_values, function(index, value) {
                        // Trim spaces from the value and split it by '|'
                        var parts = value.trim().split('|');
                        if (parts.length === 2) {
                            var desiredDataValue = parts[0].trim(); // Extract the data-value
                            var qvalValue = parts[1].trim(); // Extract the value for data-qval
                            totalSelected = totalSelected + parseInt(qvalValue)
                            // Select the element based on data-value and class
                            var element = $('.hulk_form_modal').find('.hulk_quantity_amount[data-value="' + desiredDataValue + '"]');
                            // Check if the element is found
                            if (element.length > 0) {
                                element.attr('data-qval', qvalValue);
                                element.val(qvalValue);
                            } 
                        }
                    });
                }else{
                    $(".hulk_quantity_amount").each(function(index, element) {
                        $(this).attr('data-qval', 0);
                        $(this).val(0);
                    });
                }
                $(`#${data_prop_class}`).val(selected_val);
                $('.hulk_form_modal').find('.hulk-modal-header').find('h6').text(header_text);
                $('.hulk_form_modal').find('.hulk-modal-body').find('.hulkapps_option_name').hide();
                $('.hulkSaveBtn').attr('data-get-class',data_prop_class);
                $('.hulkSaveBtn').attr('data-prop-class',update_prop_class);
                $('.hulk_form_modal').find('.hulk-modal-body').find('.hulk-custom-values-display').hide();
                $('.hulk_swatch_desciption').each(function() {
                    var contentSection = $(this);
                    var content = contentSection.find('p');
                    var seeMoreButton = contentSection.find('.hulk-content-display');

                    if (content.prop('scrollHeight') > content.innerHeight()) {
                        seeMoreButton.show(); // Display the button only if content exceeds the max height
                    }

                    });
            const $progressBar = $('.hulk_form_modal').find('.hulk-progress-bar');
            const $progressWrapper = $('.hulk_form_modal').find('.hulk-progress-bar-wrapper');
            const minValue = $progressWrapper.data("min");
            const maxValue = $progressWrapper.data("max");
            var safeCount = Math.min(totalSelected, maxValue);
            var percentage = maxValue > 0 ? (safeCount / maxValue) * 100 : 0;
            $progressWrapper.find('.hulk-progress-bar').css('width', percentage + '%');
            $progressWrapper.find('.hulk-progress-label').text(safeCount + " / " + maxValue);
            }else{
                $('.hulk_form_modal').find('.hulk-modal-body').html("<p style='text-align: center;'>All products are out of stock</p>");
                $('.hulkresetBtn,.hulkCancelBtn,.hulkSaveBtn').hide();
                $('.hulk_form_modal .hulk-modal-header').css('border-bottom','none');
                $('.hulk_form_modal .hulk-modal-header').css('display','block');
                $('.hulk_form_modal .hulk-modal-body').css('padding','0px');
                

            }
        });


        $(document).on('click', '.hulkresetBtn', function (e) {
            const $modal = $(this).closest('.hulk_form_modal');
            var element = $modal.find('.hulk_quantity_amount');
            element.attr('data-qval', 0);
            element.text(0);
            element.val(0);
            $('.hulk_unique_prop').val('');
            const $progressBar = $modal.find('.hulk-progress-bar');
            const $progressWrapper = $modal.find('.hulk-progress-bar-wrapper');
            limit = $progressWrapper.attr("data-max")
            $progressWrapper.find('.hulk-progress-bar').css('width', 0 + '%');
            $progressWrapper.find('.hulk-progress-label').text(0 + " / " + limit);
            $modal.find('.hulk_mutli_qty').val('');
            $modal.find('.hulk_multi_qty_main').find('.hulk_unique_prop').removeClass('mqty_selected');
            $modal.find('.hulk_multi_qty_main').find('.hulk_unique_prop').attr('data-price',0)

        });

        $(document).on('click', '.hulkcloseBtn', function (e) {
            $('.hulk_form_modal').hide();
            $('.hulk_form_modal').find('.hulk-modal-body').html('');
            $('.hulk_form_modal').find('.hulk-modal-header').find('h6').text('');
        });
        $(document).on('click', '.hulk-content-display', function (e) {
            $(this).parent('.hulk_swatch_desciption').find('p').toggleClass('hulk-limited-height');
            var buttonText = $(this).parent('.hulk_swatch_desciption').find('p').hasClass("hulk-limited-height") ? "See more" : "See less";
            $(this).parent('.hulk_swatch_desciption').find('a').text(buttonText);

        });

        $(document).on('click', '.hulkSaveBtn', function (e) {
            $('.hulk_form_modal').hide();
            var data_get_class = $(this).attr("data-get-class");
            var selected_opt = $(`#${data_get_class}`).val();
            var selected_opt_arr = selected_opt.split(',');
            var vhtml = ''
            if(selected_opt_arr.length > 0){
                selected_opt_arr.forEach(function(element) {
                    element = element.trim();
                    vhtml += `<span>${element}</span>`
                })
            }

            var selected_hidden_prop =  $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').val();
            var inventory_record =  $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr('data-inventory-record');
            var calc_price = $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr('data-price');
            var data_prop_class = $(this).attr("data-prop-class");
            $(`.${data_prop_class}`).find('.hulkselectedValue').html(vhtml);
            if(selected_hidden_prop.length > 0){
                $(`.${data_prop_class}`).find('a').text(window.change_button_text);
            }else{
                $(`.${data_prop_class}`).find('a').text(window.select_button_text);
            }
            $(`.${data_prop_class}`).find('a').attr('data-selected-val',selected_opt);
            $('.hulk_form_modal').find('.hulk-modal-body').html('');
            $(`#${data_get_class}`).val(selected_opt);

            $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').val(selected_hidden_prop);
            $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr('data-inventory-record',inventory_record);
            if(parseFloat(calc_price) > 0){
                $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').addClass('mqty_selected');
                $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr('data-price',calc_price)

            }else{
                $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').removeClass('mqty_selected');
                $(`#${data_get_class}`).parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr('data-price',calc_price)

            }
            $('.hulk_quantity_popup').find('p.inventory_error').css('display','none');
            $('.hulk_quantity_popup').removeClass('validation_error')
            if($('#hulk_amount_dis').val() == '1'){calc_options_total(parseInt(window.hulkapps.product_id),'hulkapps_product_options');}
            conditional_rules(parseInt(window.hulkapps.product_id),'hulkapps_product_options');

        });
        $(document).on('click', '.popup_open_link', function (e) {
            var id = $(this).attr("data-id");
            $("#popupdetailsdesing_" + id).css("display", "flex");
            $(".overlay-popup").css("display", "block");
        });
        $(document).on('click', '.popup_close_link', function (e) {
            var id = $(this).attr("data-id");
            $("#popupdetailsdesing_" + id).css("display", "none");
            $(".overlay-popup").css("display", "none");
        });
        $(document).on('click', '.recommended-link', function (e) {
            $("#recommended_detail select,#recommended_detail input[type='radio'],#recommended_detail input[type='checkbox'],.dropdown_swatch").prop("disabled", true);    
            $("#recommended_detail").css("display", "flex");
            $(".overlay-popup").css("display", "block");
            if ($("#recommended_detail .switches-container").length > 0) {
                $(".overlay-popup").css("z-index", "-1");
            }

        });
        $(document).on('click', '.recommended_close_link', function (e) {
            $("#recommended_detail").css("display", "none");
            $(".overlay-popup").css("display", "none");
            if ($("#recommended_detail .switches-container").length > 0) {
                $(".overlay-popup").css("z-index", "");
            }

        });
        

        window.conditional_rules = function (prod_id, hulkapps_parents="") {
            var hulkapps_parents = hulkapps_parents;
            if(hulkapps_parents == ""){
                hulkapps_parents = "hulkapps_product_options"
            }
            if( window.dynamic_checkout_button_integration && hulkapps_parents == "hulkapps_product_options") {
                var i;
                var total = 0;
                var is_variant_id_present = false
                var format = window.hulkapps.money_format;
                checked_variant = $("."+hulkapps_parents+" #hulkapps_option_list_" + window.hulkapps.product_id
                    + ":visible .price-change:checked, ."+hulkapps_parents+" #hulkapps_option_list_" + window.hulkapps.product_id + ":visible .price-change:selected, ."+hulkapps_parents+" .hulkapps_swatch_option .swatch_selected,."+hulkapps_parents+" .textarea_selected,."+hulkapps_parents+" .textbox_selected,."+hulkapps_parents+" .emailbox_selected,."+hulkapps_parents+" .datepicker_selected,."+hulkapps_parents+" .numberfield_selected,."+hulkapps_parents+" .colorpicker_selected,."+hulkapps_parents+" .button_selected,."+hulkapps_parents+" .googlefont_selected, ."+hulkapps_parents+" .ci_render .hulkapps_option_value .hulkapps_option_child .dropdown_selected, ."+hulkapps_parents+" .formula_selected,."+hulkapps_parents+" .stg_selected, ."+hulkapps_parents+" .mqty_selected");
                for (i = 0; i < checked_variant.length; i++) {
                    if (!$(checked_variant[i]).parents(".hulkapps_option").hasClass('conditional')) {
                        total = Number($(checked_variant[i]).attr("data-price")) + Number(total);
                        var checkedVariantId = $(checked_variant[i]).attr("data-variant-id");
                        if (checkedVariantId !== undefined && checkedVariantId !== null && checkedVariantId !== "null") {
                            is_variant_id_present = true;
                        }
                    }
                }

                function wrapShopifyPaymentButton(){
                    var is_hulk_payment_set = false
                    var checkoutElement = document.querySelector('shopify-accelerated-checkout');
                    var recommendedName = '';
                    if (checkoutElement) {
                        try {
                            const recommended = checkoutElement.getAttribute('recommended');
                            recommendedName = recommended ? JSON.parse(recommended).name || '' : '';
                        } catch(e) {
                            recommendedName = '';
                        }
                    }
                    const hulk_shopify_button = setInterval(function () {
                        if($('.shopify-payment-button').length > 0){
                            if(($('.shopify-payment-button').html().includes("ShopifyPay-button") || $('.shopify-payment-button').html().includes("Checkout-button") || $('.shopify-payment-button').html().includes("payment-button")) ){
                                if($(".hulk_buy_now_handle").length <= 0){
                                    if($('.shopify-payment-button').html().includes("ShopifyPay-button") || recommendedName == 'shop_pay'){
                                        $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='ShopifyPay-button'></div>" );
                                    }else if ($('.shopify-payment-button').html().includes("payment-button")) {
                                        $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='payment-button'></div>");
                                    }else{
                                        $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='Checkout-button'></div>" );
                                    }
                                    $('.shopify-payment-button').css({'pointer-events':'none'});
                                }else {
                                    $(".hulk_buy_now_handle").addClass("hulk-buy_now");
                                    $('.shopify-payment-button').css({'pointer-events':'none'});
                                }
                                is_hulk_payment_set = true
                            }else{
                                is_hulk_payment_set = true
                            }
                        }else{
                            is_hulk_payment_set = true
                        }
                        if (is_hulk_payment_set) {
                            clearInterval(hulk_shopify_button);
                        }
                        
                    }, 1000);

                    if($('.shopify-payment-button').length > 0 && ($('.shopify-payment-button').html().includes("ShopifyPay-button") || $('.shopify-payment-button').html().includes("Checkout-button") || $('.shopify-payment-button').html().includes("payment-button") ) ){
                        if($(".hulk_buy_now_handle").length <= 0){
                            if($('.shopify-payment-button').html().includes("ShopifyPay-button") || recommendedName == 'shop_pay'){
                                $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='ShopifyPay-button'></div>" );
                            }else if ($('.shopify-payment-button').html().includes("payment-button")) {
                                $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='payment-button'></div>");
                            }else{
                                $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='Checkout-button'></div>" );
                            }
                            $('.shopify-payment-button').css({'pointer-events':'none'});
                        }else {
                            $(".hulk_buy_now_handle").addClass("hulk-buy_now");
                            $('.shopify-payment-button').css({'pointer-events':'none'});
                        }
                    }
                }

                if (total > 0 || (total <= 0 && (is_variant_id_present || window.is_hulk_required_options || $('.file-upload.hulk-active').length > 0))) {
                    wrapShopifyPaymentButton();
                } else {
                    $('.shopify-payment-button').unwrap('.hulk_buy_now_handle');
                    $(".hulk_buy_now_handle").removeClass("hulk-buy_now");
                    $('.shopify-payment-button').css({'pointer-events': 'inherit'});
                }
            }
            pass = false;
            verify_all = Array();
            verify_any = Array();
            verified_condition = Array();
            pass_array = Array();
            $("."+hulkapps_parents).find(".condition_hide").removeClass("conditional");
            $("."+hulkapps_parents).find(".condition_show").addClass("conditional");
            $("."+hulkapps_parents+"  #conditional_rules").children().each(function () {
                pass_array = Array();
                pass = false;
                var conditional_count = $(this).children().length;
                $(this).children().each(function () {
                    pass = false;
                    var condition_rule = $(this).data('conchildren-value');
                    var field_value;
                    if ($(this).attr("data-variant-rule") == "true") {
                        // Evaluate against the cart line's variant when this run is for
                        // the edit-in-cart popup; fall back to the product page's
                        // selected variant for normal product-page evaluation. This
                        // avoids cross-pollution when the cart drawer is open on a
                        // product page.
                        if (hulkapps_parents === 'hulkapps_edit_product_options' && typeof window.hulkEditCartSelectedVariant !== 'undefined') {
                            field_value = window.hulkEditCartSelectedVariant;
                        } else {
                            field_value = window.hulkapps && window.hulkapps.product ? window.hulkapps.product.selected_variant : '';
                        }
                        field_value = (field_value || '').toString().replace('gid://shopify/ProductVariant/', '');
                        condition_rule = condition_rule.replace("**value11**", field_value);
                        if (condition_rule.indexOf("==") >= 0) {
                            var condition_rule = condition_rule.split("==");
                            pass = (condition_rule[0] == condition_rule[1]);
                        } else {
                            var condition_rule = condition_rule.split("!=");
                            pass = (condition_rule[0] != condition_rule[1]);
                        }
                        pass_array.push(pass);
                    } else if ( $("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("dd_multi_render") == true) {
                        var aa = condition_rule;
                        if (aa.indexOf("!=") >= 0) {
                            pass = true;
                        }
                        var count = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible :selected").length;
                        var ct = 1;
                        var selected_array = Array();
                        if ($("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible :selected").length > 0) {
                            $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + "_visible:visible :selected").each(function () {
                                var condition_rule = aa;
                                field_value = $(this).data("conditional-value");
                                condition_rule = condition_rule.replace("**value11**", field_value);
                                if (condition_rule.indexOf("==") >= 0) {
                                    var condition_rule = condition_rule.split("==");
                                    if (condition_rule[0] == condition_rule[1]) {
                                        pass = true;
                                    } else {
                                        pass = false;
                                    }
                                } else {
                                    var condition_rule = condition_rule.split("!=");
                                    if (condition_rule[0] != condition_rule[1]) {
                                        pass = true;
                                    } else {
                                        pass = false;
                                    }
                                }
                                selected_array.push(pass);
                                if (ct == count && count > 1) {
                                    var result = selected_array.join(' || ');
                                    result = eval(result);
                                    pass_array.push(result);
                                } else if (count == 1) {
                                    pass_array.push(pass);
                                }
                                ct = ct + 1;
                            });
                        } else {
                            pass_array.push(false);
                        }
                    } else if ($(".option_type_id_" + $(this).attr("data-field-num")).hasClass("cb_render") == true) {
                        var aa = condition_rule;
                        if (aa.indexOf("!=") >= 0) {
                            pass = true;
                        }
                        var ctt = 1;
                        var checked_array = Array();
                        var countt = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + "_visible:checked").length;
                        $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + "_visible:checked").each(function () {
                            var condition_rule = aa;
                            field_value = $(this).data("conditional-value");
                            condition_rule = condition_rule.replace("**value11**", field_value);
                            if (condition_rule.indexOf("==") >= 0) {
                                var condition_rule = condition_rule.split("==");
                                if (condition_rule[0] == condition_rule[1]) {
                                    pass = true;
                                } else {
                                    pass = false;
                                }
                            } else {
                                var condition_rule = condition_rule.split("!=");
                                if (condition_rule[0] != condition_rule[1]) {
                                    pass = true;
                                } else {
                                    pass = false;
                                }
                            }
                            checked_array.push(pass);
                            if (ctt == countt && countt > 1) {
                                var result = checked_array.join(' || ');
                                result = eval(result);
                                pass_array.push(result);
                            } else if (countt == 1) {
                                pass_array.push(pass);
                            }
                            ctt = ctt + 1;
                        });
                        // The loop above only evaluates checked boxes. For the image
                        // customizer's single-value checkbox, also pass "not equal" when
                        // unchecked. Scoped to the customizer to leave other checkboxes unchanged.
                        if (countt == 0 && aa.indexOf("!=") >= 0 &&
                            $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + "_visible").hasClass("hulk_product_image_ccheckbox")) {
                            pass_array.push(true);
                        }
                    } else if ($("."+hulkapps_parents).find("#hulkapps_option_list_" + prod_id + " .option_type_id_" + $(this).attr("data-field-num")).hasClass("multiswatch_render") == true) {
                        var aa = condition_rule;
                        if (aa.indexOf("!=") >= 0) {
                            pass = true;
                        }
                        var ctt = 1;
                        var checked_array = Array();
                        var countt = $("."+hulkapps_parents).find("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:checked").length;
                        $("."+hulkapps_parents).find("#hulkapps_option_list_" + prod_id + " .hulkapps_option_" + $(this).attr("data-field-num") + "_visible:checked").each(function () {
                            var condition_rule = aa;
                            field_value = $(this).data("conditional-value");
                            condition_rule = condition_rule.replace("**value11**", field_value);
                            if (condition_rule.indexOf("==") >= 0) {
                                var condition_rule = condition_rule.split("==");
                                if (condition_rule[0] == condition_rule[1]) {
                                    pass = true;
                                } else {
                                    pass = false;
                                }
                            } else {
                                var condition_rule = condition_rule.split("!=");
                                if (condition_rule[0] != condition_rule[1]) {
                                    pass = true;
                                } else {
                                    pass = false;
                                }
                            }
                            checked_array.push(pass);
                            if (ctt == countt && countt > 1) {
                                var result = checked_array.join(' || ');
                                result = eval(result);
                                pass_array.push(result);
                            } else if (countt == 1) {
                                pass_array.push(pass);
                            }
                            ctt = ctt + 1;
                        });
                    } else {
                        pass = false;
                        if($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("ci_render") == true) {
                            field_value = $("."+hulkapps_parents).find("#" + $(this).attr("data-field-num")).find('.dropdown_selected').attr("data-conditional-value");

                        }
                        else if ($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("dd_render") == true ) {
                            field_value = $("."+hulkapps_parents).find("#" + $(this).attr("data-field-num") + " option:selected").attr("data-conditional-value");
                        } else if ($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("rb_render") == true) {
                            field_value = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + ":checked").data("conditional-value");
                        } else if ($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("swatch_render") == true) {
                            field_value = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + ".swatch_selected").data("conditional-value");
                        } else if ($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("button_render") == true) {
                            field_value = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + ".button_selected").data("conditional-value");
                        } else if ($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("dp_render") == true) {
                            field_value = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + ".datepicker_selected").val();
                            if(field_value != undefined){
                                var splitedValues = field_value.split("-");
                                field_value = splitedValues[1]+"/"+splitedValues[2]+"/"+splitedValues[0];
                            }
                        }else if ($("."+hulkapps_parents).find(".option_type_id_" + $(this).attr("data-field-num")).hasClass("dt_render") == true) {
                            field_value = $("."+hulkapps_parents).find(".hulkapps_option_" + $(this).attr("data-field-num") + ".datetimepicker_selected").val();
                            // if(field_value != undefined){
                            //     var splitedValues = field_value.split("-");
                            //     field_value = splitedValues[1]+"/"+splitedValues[2]+"/"+splitedValues[0];
                            // }
                        }else {
                            field_value = $("."+hulkapps_parents).find("#" + $(this).attr("data-field-num") + "").val();
                        }
                        condition_rule = condition_rule.replace("**value11**", field_value);
                        if (condition_rule.indexOf("==") >= 0) {
                            var condition_rule = condition_rule.split("==");
                            if (condition_rule[0] == condition_rule[1]) {
                                pass = true;
                            } else {
                                pass = false;
                            }
                        } else {
                            var condition_rule = condition_rule.split("!=");
                            if (condition_rule[0] != condition_rule[1]) {
                                pass = true;
                            } else {
                                pass = false;
                            }
                        }
                        pass_array.push(pass);
                    }
                });
                var type_rule = $(this).attr("data-verify-all");
                var condition_id = $(this).attr("name");
                if (type_rule == "0") {
                    var res = pass_array.join(' || ');
                } else {
                    if(pass_array.length == conditional_count){
                        var res = pass_array.join(' && ')
                    }
                }
                res = eval(res);
                if (res) {
                    var updated_is = true
                    $("."+hulkapps_parents).find("." + condition_id + "_show").removeClass("conditional");
                    $("."+hulkapps_parents).find("." + condition_id + "_show .formula_selected").removeAttr("disabled");
                    $("."+hulkapps_parents).find("." + condition_id + "_hide").addClass("conditional");
                    ;
                    $("."+hulkapps_parents).find(".conditional").removeClass("validation_error");
                }
            });
            $("."+hulkapps_parents+" #conditional_rules").children().each(function () {
                var condition_id = $(this).attr("name");
                var get_target_hide_in_parent = $("."+hulkapps_parents).find("." + condition_id + "_hide.conditional")
                var get_target_show_in_parent = $("."+hulkapps_parents).find("." + condition_id + "_show.conditional")
                get_target_hide_in_parent.each(function () {
                    var check_target_hide_in_parent =  $(this).hasClass("price-change")
                    var this_ele = $(this);
                    if(check_target_hide_in_parent){
                        $(this).parent('.hulkapps_option_child').each(function () {
                            if($(this).prop("tagName") == "UL"){
                                if($(this).children('.dropdown_selected').data('value') == this_ele.data('value')){
                                    conditional_change($(this),hulkapps_parents,prod_id);
                                }
                            }else if($(this).prop("tagName") == "SELECT"){
                                if($(this).val() == this_ele.val() ){
                                    conditional_change($(this),hulkapps_parents,prod_id);
                                }
                            }else{
                                if(($(this).val().includes(this_ele.val()) )){
                                    conditional_change($(this),hulkapps_parents,prod_id);

                                }
                            }

                        });
                    }else{
                        $(this).find('.hulkapps_option_child').each(function () {
                            conditional_change($(this),hulkapps_parents,prod_id);
                        });
                    }

                });
                get_target_show_in_parent.each(function () {
                    var check_target_show_in_parent =  $(this).hasClass("price-change")
                    var this_ele = $(this);
                    if(check_target_show_in_parent){
                        $(this).parent('.hulkapps_option_child').each(function () {
                            // select not work like option have white and E-white then include check E-white as white so selection is not working
                            if($(this).prop("tagName") == "UL"){
                                if($(this).children('.dropdown_selected').data('value') == this_ele.data('value')){
                                    conditional_change($(this),hulkapps_parents,prod_id);
                                }
                            }
                            else if($(this).prop("tagName") == "SELECT"){
                                let currentVal = $(this).val();
                                let compareVal = this_ele.val();
                                if (Array.isArray(currentVal) ? currentVal.includes(compareVal) : currentVal == compareVal) {
                                    conditional_change($(this), hulkapps_parents, prod_id);
                                }
                            }else{
                                if(($(this).val().includes(this_ele.val()) )){
                                    conditional_change($(this),hulkapps_parents,prod_id);

                                }
                            }
                            

                        });
                    }else{
                        $(this).find('.hulkapps_option_child').each(function () {
                            conditional_change($(this),hulkapps_parents,prod_id);
                        });
                    }

                });
            });
            $("option.condition_hide").each(function() {
                if($(this).hasClass("conditional") ){
                    $(this).prop("disabled", true);

                }else{
                    $(this).removeAttr("disabled");
                }
            });
            $("option.condition_show").each(function() {
                if($(this).hasClass("conditional") ){
                    $(this).prop("disabled", true);

                }else{
                    $(this).removeAttr("disabled");
                }
            });

            $("."+hulkapps_parents).find(".hulkapps_option").each(function () {
                var $opt = $(this);
                if ($opt.hasClass('conditional')) {
                    return;
                }
                var value_selector = '';
                if ($opt.hasClass('ci_render')) {
                    value_selector = "li[value!='']";
                } else if ($opt.hasClass('dd_render') || $opt.hasClass('dd_multi_render')) {
                    value_selector = "option[value!='']";
                } else if ($opt.hasClass('swatch_render')) {
                    value_selector = '.hulkapps_swatch_option';
                } else if ($opt.hasClass('multiswatch_render')) {
                    value_selector = '.hulkapps_mswatch_option';
                } else if ($opt.hasClass('rb_render')) {
                    value_selector = '.hulkapps_radio_option';
                } else if ($opt.hasClass('cb_render')) {
                    value_selector = '.hulkapps_check_option';
                } else if ($opt.hasClass('button_render')) {
                    value_selector = '.hulkapps_buton_option';
                }

                if (!value_selector) {
                    return;
                }
                var $values = $opt.find(value_selector);
                var total_values = $values.length;
                if (total_values === 0) {
                    return;
                }

                var hidden_values = 0;
                $values.each(function () {
                    var $value = $(this);
                    if ($value.is('.conditional, .is_hulk_hide') || $value.find('.conditional, .is_hulk_hide').length > 0) {
                        hidden_values++;
                    }
                });
                if (hidden_values >= total_values) {
                    $opt.addClass('hulk_all_values_hidden');
                } else {
                    $opt.removeClass('hulk_all_values_hidden');
                }
            });
            calc_options_total(prod_id,hulkapps_parents);
            debouncedEnforceDefaultSelection(hulkapps_parents);
            // border_bottom = $(".hulkapps_option:visible").css("border-bottom");
            // $(".hulkapps_option:visible").css("border-bottom",border_bottom);
            // $(".hulkapps_option:visible:last").css("border-bottom","none");
        }

        let isEnforcingDefaults = false;

        function debounce(fn, delay, immediate = false) {
            let timer;
            return function(...args) {
                const callNow = immediate && !timer;
                clearTimeout(timer);
                timer = setTimeout(() => {
                    timer = null;
                    if (!immediate) fn.apply(this, args);
                }, delay);
                if (callNow) fn.apply(this, args);
            };
        }

        function enforceDefaultSelection(hulkapps_parents) {
            if (isEnforcingDefaults) return;
            isEnforcingDefaults = true;
        
            const $container = $("." + hulkapps_parents);
            const $defaults = $container.find('[data-default="true"]');
        
            // Group defaults by their parent group (only one DOM traversal per default)
            const groupMap = new Map();
            $defaults.each(function () {
                const $def = $(this);
                const $group = $def.closest('.hulkapps_option');
                const optionKey = $group.data("parent-id");
        
                if (!groupMap.has(optionKey)) {
                    groupMap.set(optionKey, { $group, $defaults: [] });
                }
                groupMap.get(optionKey).$defaults.push($def);
            });
        
            // Convert Map to array for batching
            const groups = Array.from(groupMap.entries());
        
            let i = 0;
            function processBatch() {
                const chunkSize = 4;
                const end = Math.min(i + chunkSize, groups.length);
        
                for (; i < end; i++) {
                    const [optionKey, { $group, $defaults }] = groups[i];

                    if (isGroupUnselected($group) && !userModifiedGroups[optionKey] && $group.is(':visible')) {
                        for (let j = 0; j < $defaults.length; j++) {
                            triggerHulkEvents($defaults[j]);
                        }
                    }
                }
        
                if (i < groups.length) {
                    // Schedule next batch during idle time or next frame
                    if (window.requestIdleCallback) {
                        requestIdleCallback(processBatch);
                    } else {
                        requestAnimationFrame(processBatch);
                    }
                } else {
                    isEnforcingDefaults = false;
                }
            }
        
            processBatch();
        }

        const debouncedEnforceDefaultSelection = debounce(enforceDefaultSelection, 150, true);
        
        function isGroupUnselected($group) {
            const optionType = $group.prop('classList')[1] || '';
            switch (optionType) {
                case 'rb_render':
                    return $group.find('input[type="radio"]:checked').length === 0;
                case 'dd_render':
                    return $group.find('option:selected').val() === '';
                case 'swatch_render':
                    return $group.find('.swatch_selected').length === 0;
                case 'multiswatch_render':
                case 'dd_multi_render':
                    return $group.find('[data-default="true"]').length > 0;
                case 'button_render':
                    return $group.find('.button_selected').length === 0;
                case 'ci_render':
                    return $group.find('.dropdown_selected').length === 0;
                case 'cb_render':
                    return $group.find('input[type="checkbox"]:checked').length > 0;
                case 'gf_render':
                    return $group.find('[data-default="true"]').length === 0;
                default:
                    return false;
            }
        }
        
        
        function triggerHulkEvents($wrapper) {
            if (!$wrapper.length) return;
        
            const $input = $wrapper.first();
            const type = $input.attr('type');
            const tag = $wrapper.prop('tagName').toLowerCase();

            if (tag === 'div' || tag === 'label') {
                $input.prop('checked', true).trigger('change', { isProgrammatic: true });
            } else if (type === 'radio') {
                $input.prop('checked', true).trigger('change', { isProgrammatic: true });
            }else if (type === 'checkbox') {
                $input.prop('checked', true).trigger('change', { isProgrammatic: true });
            } else if (tag === 'select' || $input.is('option')) {
                if($input.closest('select').hasClass("hulk_po_dropdown_multiple")){
                    // for multi dropdown
                    if (!$input.is(':disabled')) {
                        const $select = $input.closest('select');
                        const chkMulti = $select.find('option:selected:not([disabled])').map(function () {
                            return $(this).val();
                        }).get();
                        chkMulti.push($input.val())

                        $input.closest('select').val(chkMulti).trigger('change', { isProgrammatic: true });
                    }
                }else{
                    if (!$input.is(':disabled')) {
                        $input.closest('select').val($input.val()).trigger('change', { isProgrammatic: true });
                    }
                }
                
            }else if (tag === 'li') {
                $input.first().trigger('click', { isProgrammatic: true });
            } else {
                $input.trigger('change', { isProgrammatic: true });
            }
            
            
        }
        
        window.conditional_change = function (obj,hulkapps_parents,prod_id) {
            if (obj.prop("type") == "select-one") {
                if (obj.val()) {
                    obj.val('').trigger('change', [true]);
                    obj.parent().find('.hulk_unique_sku').prop("disabled","true");
                    obj.parent().removeClass("selected");
                }
            } else if (obj.prop("type") == "select-multiple") {
                if (obj.val()) {
                    obj.parent().find('.hulk_unique_sku').prop("disabled","true");
                    obj.val('')
                    obj.parent('.hulkapps_option_value').find('input[type=hidden]').val('');
                    obj.parent().removeClass("selected");
                }

            }else if (obj.prop("type") == "radio") {
                if (obj.prop("checked")) {
                    obj.parents('.hulkapps_option_value').find('.hulk_radiobutton_hidden_prop').val("");
                    obj.parents('.hulkapps_option_value').find('.hulk_unique_prop').val("");
                    obj.prop("checked", false)
                    obj.parent().find('.radio_selected').removeClass("radio_selected");
                    obj.parent('label').find('.hulk_unique_sku').prop("disabled","true");
                    obj.trigger('change', [true]);
                }
            }else if (obj.prop("type") == "file") {
                obj.val("");
                obj.parent(".hulkapps_option_value").find(".upload_h_cls").val("");
            }else if(obj.prop("type") == "text" &&  obj.parents('.hulkapps_option').hasClass( "gf_render" )){
                if (obj.val()) {
                    obj.parents('.hulkapps_option_value').find('.gf_property_val').val('');
                    obj.parents('.hulkapps_option_value').find('#valid-msg').remove();
                }
            }else if(obj.prop("type") == "hidden" &&  obj.parents('.hulkapps_option').hasClass( "fm_render" )){
                if(obj.parents('.hulkapps_option').hasClass("conditional")){
                    obj.attr('disabled', 'disabled');
                }else{
                    obj.removeAttr('disabled');
                }

            }else if (obj.prop("type") == "textarea" || obj.prop("type") == "number" || obj.prop("type") == "text" || obj.prop("type") == "hidden" || obj.prop("type") == "file" || obj.prop("type") == "email" ) {
                if (obj.val()) {
                    obj.val('').change();
                    obj.parents('.hulkapps_option_value').find('.tb_property_val').val('');
                    obj.parents('.hulkapps_option_value').find('#valid-msg').remove();
                }
            }else if (obj.prop("type") == "color" || obj.prop("type") == "color_picker") {
                if (obj.val()) {
                    obj.parents('.hulkapps_option_value').find('.cp_property_val').val('');
                    obj.parents('.hulkapps_option_value').find('#valid-msg').remove();
                }
            } else if (obj.prop("type") == "date" || obj.prop("type") == "date_picker") {
                if (obj.val()) {
                    obj.val('').change();
                    obj.parents('.hulkapps_option_value').find('.dp_property_val').val('');
                    obj.parents('.hulkapps_option_value').find('#valid-msg').remove();
                }

            } else if (obj.prop("type") == "time" || obj.prop("type") == "date_picker") {
                if (obj.val()) {
                    obj.val('').change();
                    obj.parents('.hulkapps_option_value').find('.dp_property_val').val('');
                    obj.parents('.hulkapps_option_value').find('#valid-msg').remove();
                }

            } else if (obj.prop("type") == "checkbox") {
                if (obj.prop("checked")) {
                    obj.prop("checked", false).trigger('change', [true]);
                    obj.parent().removeClass("swatch_selected");
                }
            } else if (obj.prop("tagName") == "DIV") {
                if (obj.find('.swatch_radio').prop("checked")) {
                    obj.find('.swatch_radio').prop("checked", false);
                    obj.find('.swatch_radio').removeAttr("checked");
                    obj.parents('.hulkapps_option_value').find('.hulk_swatch_hidden_prop').val("")
                    obj.parents('.hulkapps_option_value').find('.hulk_unique_prop').val("")
                    obj.removeClass("swatch_selected");
                    obj.parents('label').find('.hulk_unique_sku').prop("disabled","true");
                    conditional_rules(prod_id,hulkapps_parents);

                }
                if (obj.find('.button_radio').prop("checked")) {
                    obj.parents('.hulkapps_option_value').find('.hulk_button_hidden_prop').val("");
                    obj.parents('.hulkapps_option_value').find('.hulk_unique_prop').val("");

                    obj.find('.button_radio').removeAttr("checked");
                    obj.removeClass("button_selected");
                    obj.parents('label').find('.hulk_unique_sku').prop("disabled","true");

                }
                if (obj.find('.swatch_checkbox').prop("checked")) {
                    obj.find('.swatch_checkbox').prop("checked",false)
                    conditional_rules(prod_id,hulkapps_parents);
                    var hulkapps_options_value = obj.parent().parent().parent().parent(".hulkapps_option_value");
                    var mswatch_selected = [];
                    hulkapps_options_value.find( "input[type=checkbox]:checked" ).each(function() {
                        mswatch_selected.push($(this).val());
                    });
                    //hulkapps_options_value.find("input[type=hidden]" ).val(mswatch_selected.join(","))
                    hulkapps_options_value.find("input[type=hidden]" ).not(".hulk_unique_sku").val(mswatch_selected.join(","));
                    obj.removeClass("swatch_selected");
                    obj.parents('label').find('.hulk_unique_sku').prop("disabled","true");
                }
            } else if (obj.prop("tagName") == "UL") {
                obj.find('.hulk_unique_sku').prop("disabled","true");
                if (obj.find('.dropdown_selected').length > 0) {
                    var opt_text = obj.parents('.ci_render').find(".hulkapps_option_name").attr("data-option-name");
                    obj.find('.init').html("").html("Choose " + opt_text);
                    obj.find('.dropdown_selected').removeClass("dropdown_selected");
                    obj.parent('.hulkapps_option_value').find('.hulk_opt_prop') .val('')
                    obj.parent('.hulkapps_option_value').find('.hulk_unique_prop') .val('')
                    obj.find('.hulk_unique_sku').prop("disabled","false");
                    conditional_rules(obj.attr('data-pid'),obj.attr('data-parent'));
                }

            } else if (obj.prop("tagName") == "LABEL") {
                if (obj.find('.swatch_radio').prop("checked")) {
                    obj.find('.swatch_radio').prop("checked", false).change();
                    obj.find('.swatch_radio').removeAttr("checked");
                    obj.removeClass("swatch_selected");
                    obj.parents('label').find('.hulk_unique_sku').prop("disabled","true");
                }
                if (obj.find('.button_radio').prop("checked")) {
                    obj.find('.button_radio').prop("checked", false).change();
                    obj.find('.button_radio').removeAttr("checked");
                    obj.removeClass("button_selected");
                    obj.parents('label').find('.hulk_unique_sku').prop("disabled","true");
                }
                if (obj.find('.swatch_checkbox').prop("checked")) {
                    obj.find('.swatch_checkbox').prop("checked",false)
                    var hulkapps_options_value = obj.parent(".hulkapps_option_value");
                    var mswatch_selected = [];
                    hulkapps_options_value.find( "input[type=checkbox]:checked" ).each(function() {
                        mswatch_selected.push($(this).val());
                    });
                    hulkapps_options_value.find( "input[type=hidden]" ).val(mswatch_selected.join(","))
                    obj.removeClass("swatch_selected");
                }
            }else if (obj.prop("type") == "button") {
                if (obj.parent().find('.hulk_quantity_amount').attr('data-qval')) {
                    obj.parent().find('.hulk_quantity_amount').attr('data-qval','0')
                    obj.parent().find('.hulk_quantity_amount').text('0')
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').removeClass('mqty_selected');
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').val('');
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').removeAttr('data-inventory-record');
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').removeAttr('data-price');
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_mutli_qty').val('');
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').parents('.mq_render').find('.inventory_error').remove();
                    obj.parents('.muti-qty-div').parent('.hulk_multi_qty_main').parents('.mq_render').removeClass('validation_error')
                }

            }


        }

        window.calc_options_total = function (product_id, hulkapps_parents = "") {
            price_setting = display_price_setting['price_setting']
            if(price_setting == "price_addtional_charge" || price_setting == "price_total_charge" || price_setting == "price_append" || price_setting == "price_addtional_charge_beside_price"|| (display_price_setting["amount_note_display"] == 1 && price_setting == undefined)){
                var hulkapps_parents = hulkapps_parents;
                if(hulkapps_parents == ""){
                    hulkapps_parents = "hulkapps_product_options"
                }
                var i;
                var total = 0;
                var format = window.hulkapps.money_format;
                checked_variant = $("."+hulkapps_parents+" #hulkapps_option_list_" + product_id + ":visible .price-change:checked, ."+hulkapps_parents+" #hulkapps_option_list_" + product_id + ":visible .price-change:selected, ."+hulkapps_parents+" .hulkapps_swatch_option .swatch_selected,."+hulkapps_parents+" .textarea_selected,."+hulkapps_parents+" .textbox_selected,."+hulkapps_parents+" .emailbox_selected,."+hulkapps_parents+" .datepicker_selected,."+hulkapps_parents+" .numberfield_selected,."+hulkapps_parents+" .colorpicker_selected,."+hulkapps_parents+" .button_selected,."+hulkapps_parents+" .googlefont_selected, ."+hulkapps_parents+" .datetimepicker_selected,."+hulkapps_parents+" .ci_render .hulkapps_option_value .hulkapps_option_child .dropdown_selected, ."+hulkapps_parents+" .formula_selected,."+hulkapps_parents+" .stg_selected, ."+hulkapps_parents+" .mqty_selected");

                for (i = 0; i < checked_variant.length; i++) {
                    if (!$(checked_variant[i]).parents(".hulkapps_option").hasClass('conditional')) {
                        var quantity = 1
                        if($(checked_variant[i]).parents(".hulkapps_option_value").find(".hulk_options_quantity").length > 0){
                            var quantity = parseInt($(checked_variant[i]).parents(".hulkapps_option").find(".hulk_options_quantity").val());

                        }
                        total = Number($(checked_variant[i]).attr("data-price") * quantity) + Number(total);
                    }
                }
                try {
                    $('body').trigger('hulkOptionsTotalCalculated', [total]);
                } catch (error) {
                    // Handle the error if the triggering fails
                }
                if(window.is_enabled_shopify_default_currency){
                    formula_total = 0.0
                    if($(`.${hulkapps_parents} .formula_selected`).length > 0){
                        formula_total = Number($(`.${hulkapps_parents} .formula_selected`).attr("data-price") * quantity)
                    }
                    total = Number(total) - formula_total
                    total = Number(total) * Number(window.hulkapps_shopify_rate)
                    total = Number(total) + formula_total
                    if(window.rounding_price){
                        total = Math.round(total);
                    }else{
                        total = total.toFixed(2); 
                    }
                    
                }
                if(price_setting == "price_total_charge"){
                    total = Number(product_price / 100) + Number(total);
                    total = total.toFixed(2)
                }
                if (price_setting == "price_append") {
                    const priceClass = display_price_setting.price_class || '';
                    const comparePriceClass = display_price_setting.compare_price_class || '';
                  
                    const finalPrice = currency_conversion(
                      Number(product_price / 100) + Number(total)
                    );
                  
                    const finalComparePrice = currency_conversion(
                      Number(compare_product_price / 100) + Number(total)
                    );
                  
                    function updatePrice(selectorList, value) {
                      if (!selectorList) return;
                  
                      selectorList.split(',').forEach((selector) => {
                        selector = $.trim(selector);
                        if (!selector) return;
                  
                        const elById = $("#" + selector);
                        const elByClass = $("." + selector);
                  
                        if (elById.length) {
                          elById.html(`<span class="money">${value}</span>`);
                        } else if (elByClass.length) {
                          elByClass.html(`<span class="money">${value}</span>`);
                        }
                      });
                    }
                  
                    updatePrice(priceClass, finalPrice);
                    updatePrice(comparePriceClass, finalComparePrice);
                  
                    total = 0;
                }
                if(price_setting == "price_addtional_charge_beside_price"){
                    if (total > 0 && 1){
                        total = currency_conversion(Number(total));
                        var price_class =  display_price_setting['price_class']
                        var is_brackets_start = display_price_setting['price_display_brackets'] == "1" ? "" : "("
                        var is_plus_sign = display_price_setting['price_plus_sign'] == "1" ? "" : "+"
                        var is_brackets_close = display_price_setting['price_display_brackets'] == "1" ? "" : ")"
                        var option_add_style = ".hulk_price_addtional_charge_beside_price{"

                        option_add_style +=  (display_price_setting['addition_price_font_color'] != undefined) ? "color: " + display_price_setting['addition_price_font_color'] + ";" : "";
                        option_add_style +=  (display_price_setting['addition_price_font_size'] != undefined) ? "font-size: " + display_price_setting['addition_price_font_size'] + "px;" : "" ;
                        option_add_style += "}"
                        var addtional_price_style = "<style>"+option_add_style+"</style>"
                        $("."+hulkapps_parents).append(addtional_price_style)
                        if(price_class.length > 0) {
                            let price_classes = price_class.split(',');
                            price_classes.forEach((price_class) => {
                                price_class = $.trim(price_class)
                                if($("#"+price_class).length > 0 ){
                                    $("#"+price_class).html("<span class='money hulk_price_addtional_charge_beside_price'>"+is_brackets_start+is_plus_sign+""+total+is_brackets_close+"</span>");

                                }else if($("."+price_class).length > 0 ){
                                    $("."+price_class).html("<span class='money hulk_price_addtional_charge_beside_price'>"+is_brackets_start+is_plus_sign+""+total+is_brackets_close+"</span>");
                                }
                            });
                        }

                    }else{
                        var price_class =  display_price_setting['price_class']
                        if(price_class.length > 0) {
                            let price_classes = price_class.split(',');
                            price_classes.forEach((price_class) => {
                                price_class = $.trim(price_class)
                                $("#"+price_class).html("")
                                $("."+price_class).html("")
                            });
                        }

                    }
                    total = 0
                }
                $("."+hulkapps_parents+" #raw_option_total").val(total);
                var total_ammont = total
                if(window.is_enabled_shopify_default_currency){
                    total = currency_conversion(Number(total));
                    $("."+hulkapps_parents+" #formatted_option_total").html( total);
                }else{
                    $("."+hulkapps_parents+" #calculated_option_total").html(Number(total).toFixed(2));
                }
                $("."+hulkapps_parents+" #option_display_total_format").attr('aria-label', $("."+hulkapps_parents+" #option_display_total_format").text());
                if (total_ammont > 0 && 1) {
                    $('.'+hulkapps_parents+' #option_total').slideDown();
                } else {
                    $('.'+hulkapps_parents+' #option_total').slideUp();
                }
                
        
            }
        }
        window.currency_conversion =  function (price){
            let money_format = window.hulkapps.money_format
            //price = window.hulk_currency.rate * price
            if(money_format.includes("{{ amount }}") || money_format.includes("{{amount}}")){
                price =  price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if(money_format.includes("{{ amount }}")){
                    return money_format.replace('{{ amount }}',price)

                }else{
                    return money_format.replace('{{amount}}',price)
                }
            }
            else if(money_format.includes("{{ amount_no_decimals }}") || money_format.includes("{{amount_no_decimals}}")){
                price = Math.round(Number(price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if(money_format.includes("{{ amount_no_decimals }}")){
                    return money_format.replace('{{ amount_no_decimals }}',price)

                }else{
                    return money_format.replace('{{amount_no_decimals}}',price)
                }
            }
            else if(money_format.includes("{{ amount_with_comma_separator }}") || money_format.includes("{{amount_with_comma_separator}}")){
                price = price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (price.includes(".")){
                    price = price.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    let n = price.lastIndexOf(".");
                    price = price.slice(0, n) + price.slice(n).replace(".",",")
                }else{
                    price =  price.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
                if(money_format.includes("{{ amount_with_comma_separator }}")){
                    return money_format.replace('{{ amount_with_comma_separator }}',price)

                }else{
                    return money_format.replace('{{amount_with_comma_separator}}',price)
                }
            }
            else if(money_format.includes("{{ amount_no_decimals_with_comma_separator }}") || money_format.includes("{{amount_no_decimals_with_comma_separator}}")){
                price =  Math.round(Number(price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                if(money_format.includes("{{ amount_no_decimals_with_comma_separator }}")){
                    return money_format.replace('{{ amount_no_decimals_with_comma_separator }}',price)

                }else{
                    return money_format.replace('{{amount_no_decimals_with_comma_separator}}',price)
                }
            }
            else if(money_format.includes("{{ amount_with_apostrophe_separator }}") || money_format.includes("{{amount_with_apostrophe_separator}}")){
                price = price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
                if(money_format.includes("{{ amount_with_apostrophe_separator }}")){
                    return money_format.replace('{{ amount_with_apostrophe_separator }}',price)

                }else{
                    return money_format.replace('{{amount_with_apostrophe_separator}}',price)
                }
            }
            else{
                return price
            }
        }
        window.checkPlan = function (slug, type) {
            var is_allowed = true
            var current_plan_id = window.hulk_po_plan_id
            var plans_features = window.hulk_po_plans_features
            var is_on_trial_period = window.hulk_po_is_on_trial_period
            if (slug && type && plans_features && current_plan_id && plans_features[current_plan_id]) {
                if ($.type(plans_features) == "string") {
                    plans_features = JSON.parse(plans_features)
                }
                if (plans_features[current_plan_id][slug] == false && type == "boolean") {
                    is_allowed = false
                }
                if (is_on_trial_period == true &&  plans_features[current_plan_id][slug] == true){
                    is_allowed = true
                }
            } else {
                is_allowed = false
            }


            return is_allowed
        }
        window.oldStore = function() {
            var is_old_store = false;
            var store_created_date = Date.parse(window.store_created_date);
            if (store_created_date < Date.parse("08/27/2023")) {
                is_old_store = true;
            }
            return is_old_store;
        };
        window.is_on_click = false;
        $(document).on('click', '.hulkappsGetOptions', function (e) {
            window.hulkapps.product_id = $(this).attr('data-product-id');
            if(window.is_on_click &&  $(`.hulk_po_${window.hulkapps.product_id}`).length > 0){
                $(`.hulk_po_${window.hulkapps.product_id}`).show();
            }else{
                if (window.hulkapps.store_id ) { 
                    window.hulkapps.product = {}
                    if($(this).attr('data-product-tags')){
                        window.hulkapps.product.tags = $(this).attr('data-product-tags').split(",");
                    }
                    window.hulkapps.product.vendor = $(this).attr('data-product-vendor');
                    window.hulkapps.product.type = $(this).attr('data-product-type');
                    window.hulkapps.product_collections = $(this).attr('data-product-collections');
                    window.cproduct_price = $(this).attr('data-product-price');
                    productPageAjax($,"is_collection_page");
                }
                $(`.hulk_po_${window.hulkapps.product_id}`).hide();
            }

        });
        window.check_character_limit = function (chartotal, product_id, remain_char_msg,hulkapps_parents="") {
            var hulkapps_parents = hulkapps_parents;
            if(hulkapps_parents == ""){
                hulkapps_parents = "hulkapps_product_options"
            }
            var text_length = $.trim($('.'+hulkapps_parents+' .hulkapps_option_value .hulkapps_option_' + product_id + '').val()).length;
            var text_remaining = chartotal - text_length;
            $('.'+hulkapps_parents+' #char_count_' + product_id + '').html(text_remaining + ' ' + remain_char_msg);
        }
        window.requireInventory = async function (product_id,hulkapps_parents)
        {
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + ":visible .dd_render.required:visible,.dd_multi_render.required:visible,.swatch_render.required:visible,.cb_render.required:visible,.multiswatch_render.required:visible,.ci_render.required:visible,.rb_render.required:visible,.button_render.required:visible").each(function () {
                if($(this).hasClass('ci_render')){
                    var total_option = $(this).find("li[value !='']").length
                    var hide_option = $(this).find("li[value !=''].is_hulk_disabled").length

                    if(total_option == hide_option){
                        $(this).removeClass('required')
                        $(this).find(".hulkapps-required").remove();
                    }
                }else if(($(this).hasClass('dd_render') || $(this).hasClass('dd_multi_render')) && !$(this).hasClass('ci_render')){
                    var total_option = $(this).find("option[value !='']").length
                    var hide_option = $(this).find("option[value !='']:disabled").length
                    if(total_option == hide_option){
                        $(this).removeClass('required')
                        $(this).find(".hulkapps-required").remove();
                    }
                }else if($(this).hasClass('multiswatch_render')){
                    var total_option = $(this).find(".hulkapps_mswatch_option").length
                    var hide_option = $(this).find(".hulkapps_mswatch_option input[type='checkbox']:disabled").length
                    if(total_option == hide_option){
                        $(this).removeClass('required')
                        $(this).find(".hulkapps-required").remove();
                    }
                }else if($(this).hasClass('swatch_render')){
                    var total_option = $(this).find(".hulkapps_swatch_option").length
                    var hide_option = $(this).find(".hulkapps_swatch_option input[type='radio']:disabled").length
                    if(total_option == hide_option){
                        $(this).removeClass('required')
                        $(this).find(".hulkapps-required").remove();
                    }
                }else if($(this).hasClass('rb_render')){
                    var total_option = $(this).find(".hulkapps_radio_option").length
                    var hide_option = $(this).find(".hulkapps_radio_option input[type='radio']:disabled").length
                    if(total_option == hide_option){
                        $(this).removeClass('required');
                        $(this).find(".hulkapps-required").remove();
                    }
                }else if($(this).hasClass('cb_render')){
                    var total_option = $(this).find(".hulkapps_check_option").length
                    var hide_option = $(this).find(".hulkapps_check_option input[type='checkbox']:disabled").length
                    if(total_option == hide_option){
                        $(this).removeClass('required')
                        $(this).find(".hulkapps-required").remove();
                    }
                }else if($(this).hasClass('button_render')){
                    var total_option = $(this).find(".hulkapps_buton_option").length
                    var hide_option = $(this).find(".hulkapps_buton_option input[type='radio']:disabled").length
                    if(total_option == hide_option){
                        $(this).removeClass('required')
                        $(this).find(".hulkapps-required").remove();
                    }
                }

            });
        }
        window.validate_options =  async function (product_id,hulkapps_parents,data_quantity="") {
            var data_quantity = data_quantity;
            var hulkapps_parents = hulkapps_parents;

            if(hulkapps_parents == "" || hulkapps_parents == undefined){
                hulkapps_parents = "hulkapps_product_options"
            }
            var good = true;

            $('.'+hulkapps_parents+ ' #error_text').html('');
            var hulkapps_req = $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + ":visible .required:visible");
            var i;
            for (i = 0; i < hulkapps_req.length; i++) {
                if ($(hulkapps_req[i]).hasClass("ci_render") && $(hulkapps_req[i]).find(".hulk_opt_prop").length && !$(hulkapps_req[i]).find(".hulk_opt_prop").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                }else if ($(hulkapps_req[i]).hasClass("dd_render") && $(hulkapps_req[i]).find(".hulk_dropdown_hidden_prop").length && !$(hulkapps_req[i]).find(".hulk_dropdown_hidden_prop").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                }else if (hulkapps_jQuery(hulkapps_req[i]).find("select[name^='properties']").length == 1 && !hulkapps_jQuery(hulkapps_req[i]).find("select[name^='properties']").val()) {
                    hulkapps_jQuery(hulkapps_req[i]).addClass("validation_error");
                    good = false;

                } else if (hulkapps_jQuery(hulkapps_req[i]).find('.hulkapps_option_value').find("input[name^='properties']").length >= 1 && !hulkapps_jQuery(hulkapps_req[i]).find('.hulkapps_option_value').find("input[name^='properties']:not(.hulk_unique_prop)").val()) {
                    hulkapps_jQuery(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                }else if ($(hulkapps_req[i]).find(".hulkapps_radio_option").length && !$(hulkapps_req[i]).find(".hulk_radiobutton_hidden_prop").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find(".hulkapps_buton_option").length && !$(hulkapps_req[i]).find(".hulk_button_hidden_prop").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find(".hulkapps_swatch_option").length && !$(hulkapps_req[i]).find(".hulk_swatch_hidden_prop").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find(".hulkapps_short_option_value").length) {
                    $(hulkapps_req[i]).find("input[type='text']").each(function () {
                        if($.trim($(this).val()) == "" && !$(this).parents(".hulkapps_short_option_value").hasClass("conditional")){
                            $(hulkapps_req[i]).addClass("validation_error");
                            good = false;
                        }
                    });
                }else if (!$(hulkapps_req[i]).hasClass("pn_render") && $(hulkapps_req[i]).find("input[type='text']").length > 1) {
                    $(hulkapps_req[i]).find("input[type='text']").each(function () {
                        if ($.trim($(this).val()) == '') {
                            $(hulkapps_req[i]).addClass("validation_error");
                            good = false;
                        }
                    });
                } else if ($(hulkapps_req[i]).find("input[type='text']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find("input[type='email']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find("input[type='color']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find(".hulkapps_check_option").length && !$(hulkapps_req[i]).find("input[name^='properties']:not(.hulk_unique_sku)").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find("input[type='file']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).hasClass("cb_render") && $(hulkapps_req[i]).find("input[type='checkbox']:checked").length && !$(hulkapps_req[i]).find("input[name^='properties']:not(.hulk_unique_sku,.hulk_unique_prop)").length) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).hasClass("multiswatch_render") && $(hulkapps_req[i]).find("input[type='checkbox']:checked").length && !$(hulkapps_req[i]).find("input[name^='properties']:not(.hulk_unique_sku, .hulk_unique_prop)").length) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find("textarea").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find("select[multiple]").length >= 1 && !$(hulkapps_req[i]).find("input[name^='properties']:not(.hulk_unique_sku)").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                } else if ($(hulkapps_req[i]).find("input[type='number']:not(.hulk_options_quantity)").length && !$(hulkapps_req[i]).find("input[name^='properties']").val() && !$(hulkapps_req[i]).hasClass("mq_render")) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;

                } else if ($(hulkapps_req[i]).hasClass("dp_render") && $(hulkapps_req[i]).find("input[type='date']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;

                }else if ($(hulkapps_req[i]).hasClass("dt_render") && $(hulkapps_req[i]).find("input[type='time']").length && !$(hulkapps_req[i]).find("input[name^='properties']").val()) {
                    $(hulkapps_req[i]).addClass("validation_error");
                    good = false;

                } else if (hulkapps_jQuery(hulkapps_req[i]).find('.hulkapps_option_value').find("input[name^='properties']").length >= 1 && !hulkapps_jQuery(hulkapps_req[i]).find('.hulkapps_option_value').find("input[name^='properties']:not(.hulk_unique_prop)").val()) {
                    hulkapps_jQuery(hulkapps_req[i]).addClass("validation_error");
                    good = false;
                }else {
                    $(hulkapps_req[i]).removeClass("validation_error");
                    $(hulkapps_req[i]).find('.validation_error.error_span').remove();
                    $(hulkapps_req[i]).removeAttr('aria-label tabindex');
                }

            }

            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .cb_render:visible").each(function () {
                var min_selection = parseInt($(this).attr('data-min'));
                var max_selection = parseInt($(this).attr('data-max'));
                var selectedCheckboxLength = $(this).find("input[type='checkbox']:checked").length
                var validation_error = '<span class="validation_error error_span" tabindex="0" >'

                if($(this).hasClass('required') && selectedCheckboxLength == 0){
                    $(this).append(validation_error);
                }
                
                if(checkPlan('validation_for_min_max_option_selection', 'boolean')){
                    if ((min_selection != 0) && (max_selection != 0)) {
                        if (selectedCheckboxLength < min_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                            if (selectedCheckboxLength == 0 && $(this).hasClass('required')) {
                                $(this).addClass('validation_error');
                            }else if(selectedCheckboxLength == 0){
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            }
                        } else if (selectedCheckboxLength > max_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (min_selection != 0) {
                        if (selectedCheckboxLength < min_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (max_selection != 0) {
                        if (max_selection >= selectedCheckboxLength) {
                            if (max_selection == selectedCheckboxLength) {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            } else {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                                $(this).append(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`);
                                $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
                            }
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    }
                }

                if ($(this).find('.error_span').length > 0) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                    good = true;
                }

                if(!$(this).hasClass('required') && selectedCheckboxLength == 0){
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                    $(this).find('.validation_error.error_span').remove()
                    good = true;
                }
            });

            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .multiswatch_render:visible").each(function () {
                var min_selection = parseInt($(this).attr("data-min"));
                var max_selection = parseInt($(this).attr("data-max"));
                var selected_qty_count = $(this).find("input[type='checkbox']:checked").length;
                var validation_error = '<span class="validation_error error_span" tabindex="0" >'

                if($(this).hasClass('required') && selected_qty_count == 0){
                    $(this).append(validation_error);
                }
                if(checkPlan('validation_for_min_max_option_selection', 'boolean')){
                    if ((min_selection != 0) && (max_selection != 0)) {
                        if (selected_qty_count < min_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                            if (selected_qty_count == 0 && $(this).hasClass('required')) {
                                $(this).addClass('validation_error');
                            }else if(selected_qty_count == 0){
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            }
                        } else if (selected_qty_count > max_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (min_selection != 0) {
                        if (selected_qty_count < min_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (max_selection != 0) {
                        if (selected_qty_count > max_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    }                    
                }
                if ($(this).find('.error_span').length > 0) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                }

                if(!$(this).hasClass('required') && selected_qty_count == 0){
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                    $(this).find('.validation_error.error_span').remove()
                    good = true;
                }
            });

            $("#hulkapps_option_list_" + product_id + " .dd_multi_render:visible").each(function () {
                var min_selection = parseInt($(this).find('.hulk_po_dropdown_multiple').attr('data-min'));
                var max_selection = parseInt($(this).find('.hulk_po_dropdown_multiple').attr('data-max'));
                var selectedDropDownMultiLength = $(this).find("select[multiple] option:selected").length
                var validation_error = '<span class="validation_error error_span" tabindex="0" >'

                if($(this).hasClass('required') && (selectedDropDownMultiLength == 0 || ($(this).find("input[name^='properties']:not(.hulk_unique_sku)").val() == 0))){
                    $(this).append(validation_error);
                }

                if(checkPlan('validation_for_min_max_option_selection', 'boolean')){
                    if ((min_selection != 0) && (max_selection != 0)) {
                        if (selectedDropDownMultiLength < min_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                            if (selectedDropDownMultiLength == 0 && $(this).hasClass('required')) {
                                $(this).addClass('validation_error');
                            }else if(selectedDropDownMultiLength == 0){
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            }
                        } else if (selectedDropDownMultiLength > max_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (min_selection != 0) {
                        if (selectedDropDownMultiLength < min_selection) {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                            $(this).append(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                            $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (max_selection != 0) {
                        if (max_selection >= selectedDropDownMultiLength) {
                            if (max_selection == selectedDropDownMultiLength) {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            } else {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                                $(this).append(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`);
                                $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
                            }
                        } else {
                            $(this).removeClass('validation_error').find('.error_span').remove();
                        }
                    }
                }

                if ($(this).find('.error_span').length > 0) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                }

                if(!$(this).hasClass('required') && selectedDropDownMultiLength == 0){
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                    $(this).find('.validation_error.error_span').remove()
                    good = true;
                }
            });
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .et_render.required:visible").each(function () {
                if ($(this).find("input[type='email']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')) || (($(this).find("input[type='email']").val()) != ''))) {
                    var userEmail = $(this).find("input[type='email']").val();
                    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,5}|[0-9]{1,3})(\]?)$/;
                    if (!filter.test(userEmail)) {
                        $(this).addClass("validation_error");
                        if($(this).find("input[type='email']").val() != '' && !$(this).find('.error_span').length > 0){
                            $(this).find("input[type='email']").after('<span class="validation_error error_span" tabindex="0" aria-label="' + window.invalid_email_validation_message + '">' +window.invalid_email_validation_message +'</span>');
                            $(this).attr('aria-label', window.invalid_email_validation_message);
                        }
                        good = false;
                    } else {
                        $(this).removeClass("validation_error");
                        $(this).removeAttr('aria-label tabindex');
                        $(this).find('.error_span').remove();
                    }
                }
            });
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .pn_render.required:visible").each(function () {
                if ($(this).find("input[type='text']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')))) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    if ($(this).find(".phone_number").hasClass('error')) {
                        $(this).addClass("validation_error");
                        good = false;
                    } else {
                        $(this).removeClass("validation_error");
                        $(this).removeAttr('aria-label tabindex');
                    }
                }
            });
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .dp_render:visible").each(function () {
                if ($(this).find('.error_span').length > 0) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                }
            });
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .dt_render:visible").each(function () {
                if ($(this).find('.error_span').length > 0) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                }
            });
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .dp_render.required:visible").each(function () {
                if ($(this).find("input[type='date']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')))) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    if ($(this).find('.error_span').length > 0) {
                        $(this).addClass("validation_error");
                        good = false;
                    } else {
                        $(this).removeClass("validation_error");
                        $(this).removeAttr('aria-label tabindex');
                    }
                }
            });
            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .dt_render.required:visible").each(function () {
                if ($(this).find("input[type='time']").length && ((!$(this).find("input[name^='properties']").val() && $(this).hasClass('required')))) {
                    $(this).addClass("validation_error");
                    good = false;
                } else {
                    if ($(this).find('.error_span').length > 0) {
                        $(this).addClass("validation_error");
                        good = false;
                    } else {
                        $(this).removeClass("validation_error");
                        $(this).removeAttr('aria-label tabindex');
                    }
                }
            });

            if ($("." + hulkapps_parents).find(".fm_option_val").length > 0) {
                if ($("." + hulkapps_parents).find(".fm_option_val").hasClass("validation_error")) {
                    good = false;
                } else {
                    good = true;
                }
            }

            $("."+hulkapps_parents).find("#hulkapps_option_list_" + product_id + " .mq_render:visible").each(function () {
                var min_selection = parseInt($(this).attr("data-min"));
                var max_selection = parseInt($(this).attr("data-max"));
                var largest_selection_value = Math.max(min_selection, max_selection)
                var selected_qty_count = 0;
                var multi_qty_name = $(this).find('.hulkapps_option_name').attr('aria-label');
                var input_tag = document.querySelector(`input[name*="properties[${multi_qty_name}]"]`);
                var validation_error = '<span class="validation_error error_span" tabindex="0" >'
                var multi_qty_count = $(this).find('.hulk_multi_qty_main .muti-qty-div').length

                $(this).find('.hulk_quantity_amount').each(function() {
                    var qty = parseInt($(this).attr('data-qval'));
        
                    if (qty > 0) {
                        selected_qty_count += qty;
                    }
                });
                
                if($(this).hasClass('required') && selected_qty_count == 0){
                    $(this).append(validation_error);
                }

                if(checkPlan('validation_for_min_max_option_selection', 'boolean')){
                    if ((multi_qty_count >= largest_selection_value && !window.ignore_min_max_validation) || (multi_qty_count >= largest_selection_value && window.ignore_min_max_validation) || (multi_qty_count <= largest_selection_value && !window.ignore_min_max_validation)) {
                        if ((min_selection != 0) && (max_selection != 0)) {
                            if (selected_qty_count < min_selection) {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                                $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                                $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                                if (selected_qty_count == 0 && $(this).hasClass('required')) {
                                    $(this).addClass('validation_error');
                                }else if(selected_qty_count == 0){
                                    $(this).removeClass('validation_error').find('.error_span').remove();
                                }
                            } else if (selected_qty_count > max_selection) {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                                $(this).append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                                $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                            } else {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            }
                        } else if (min_selection != 0) {
                            if (selected_qty_count < min_selection) {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                                $(this).append(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                                $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);
                            } else {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            }
                        } else if (max_selection != 0) {
                            if (max_selection >= selected_qty_count) {
                                if (max_selection == selected_qty_count) {
                                    $(this).removeClass('validation_error').find('.error_span').remove();
                                } else {
                                    $(this).removeClass('validation_error').find('.error_span').remove();
                                    $(this).append(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`);
                                    $(this).find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
                                }
                            } else {
                                $(this).removeClass('validation_error').find('.error_span').remove();
                            }
                        }
                        if ($(this).find('.error_span').length > 0) {
                            $(this).addClass("validation_error");
                            good = false;
                        } else {
                            $(this).removeClass("validation_error");
                            $(this).removeAttr('aria-label tabindex');
                        }
    
                    }
                }
                if(!$(this).hasClass('required') && selected_qty_count == 0){
                    $(this).removeClass("validation_error");
                    $(this).removeAttr('aria-label tabindex');
                    $(this).find('.validation_error.error_span').remove()
                    good = true;
                }
            });

            // if(good == true){
            good = await resolveInventory(hulkapps_parents,good,data_quantity);
            // }

            $("."+hulkapps_parents).find(".hulkapps_option:visible").each(function () {
                if ($(this).hasClass("validation_error")) {
                    good = false;
                    var opt_name = $(this).find('.hulkapps_option_name').attr('aria-label');
                    if($(this).attr('aria-label') == undefined){
                        $(this).attr({'aria-label': `${opt_name} is required`,'tabindex': 0});
                    }
                    $('.validation_error:first').focus();
                }
            });
            if(good == false){
                $('.inventory_error,.validation_error').first().focus();
            }
            return good;
        }
        function resolveInventory(hulkapps_parents,good,data_quantity=""){
            var data_quantity = data_quantity;
            var prop_json = {}
            var is_inventory_validation_error = false
            if(good == false){
                is_inventory_validation_error = true
            }
            return new Promise((resolve, reject) => {
                $.getJSON('/cart.js', {_: new Date().getTime()}, function (cart) {
                    if (cart && cart.item_count > 0) {
                        cart.items.forEach(function (selector) {
                            var quantity = selector.quantity
                            if (selector['properties'] != null && selector['properties'] != {})
                                $.each(selector['properties'], function (key, value) {
                                    if (key.startsWith("_hin") && value) {
                                        if(window.opt_with_otc[key] == true || window.opt_with_otc[key] == 'true'){
                                            quantity = 1
                                        }
                                        if(value.includes(",")){
                                            let values = value.split(",")
                                            values.forEach(function (value) {
                                                let json_key = value.split("_hin_")[0]
                                                var options_qty = $.trim(value.split('_hin_')[1].split('|')[1])
                                                if(options_qty.includes(")")){
                                                    options_qty = parseInt(options_qty.split(")"))
                                                }else{
                                                    options_qty = options_qty
                                                }
                                                if(options_qty <= 0 ) {
                                                    options_qty = 1
                                                }
                                                json_key = key + $.trim(json_key.split('[')[0])
                                                if(prop_json[json_key])  {
                                                    prop_json[json_key] = prop_json[json_key] + (quantity * options_qty)
                                                }else{
                                                    prop_json[json_key] = quantity * options_qty
                                                }
                                            });

                                        }else{
                                            var options_qty = $.trim(value.split('_hin_')[1].split('|')[1])
                                            if(options_qty.includes(")")){
                                                options_qty = parseInt(options_qty.split(")"))
                                            }else{
                                                options_qty = options_qty
                                            }
                                            if(options_qty <= 0 ) {
                                                options_qty = 1
                                            }
                                            let json_key = key +  $.trim(value.split('_hin_')[0].split('[')[0])

                                            if(prop_json[json_key])  {
                                                prop_json[json_key] = prop_json[json_key]  + (quantity * options_qty)
                                            }else{
                                                prop_json[json_key] = quantity * options_qty
                                            }
                                        }
                                    }
                                });
                        });
                    }
                    resolve(prop_json);
                })
            }).then(function (prop_json) {
                $("."+hulkapps_parents).find(".inventory_error").remove();
                $("."+hulkapps_parents).find(".hulk_unique_prop").each(function () {
                    var malti_attr  = $(this).data("selection-multi")
                    var inventory_record = $(this).attr('data-inventory-record');
                    if(inventory_record) {
                        inventory_record = inventory_record.split(',')
                    }

                    if(malti_attr != undefined && malti_attr == true){
                        var element = $(this);
                        var inventory_proprties = $(this).val().split(", ");
                        var is_valid = good;
                        $.each(inventory_proprties, function(key, value) {
                            if(value != '' ){
                                var available_inventory = value.split("_hin_")[1]
                                available_inventory = parseInt(available_inventory)
                                var pqty = 1
                                if($("input[name=quantity]").val()){
                                    pqty = parseInt($("input[name=quantity]").val())
                                }

                                if((window.opt_with_otc[element.data("unique_prop_name")] == true) || (window.opt_with_otc[element.data("unique_prop_name")] == 'true')){
                                    var usebeled_inventory = 1

                                }else{
                                    if(data_quantity != ''){
                                        var usebeled_inventory = parseInt(data_quantity);
                                    }else{
                                        var usebeled_inventory = pqty
                                    }
                                }
                                var options_quantity = 1
                                if(inventory_record){
                                    usebeled_inventory = 1
                                    $.each(inventory_record, function(key, ivalue) {
                                        ivalue =  ivalue.split("_hin_")
                                        if(ivalue[0] == value.split("_hin_")[0]){
                                            options_quantity =  parseInt(ivalue[1])
                                        }

                                    });
                                }
                                if (options_quantity <= 0) {
                                    options_quantity = 1
                                }
                                usebeled_inventory = usebeled_inventory * options_quantity
                                let json_key = value.split("_hin_")[0]
                                json_key = element.attr("data-unique_prop_name") + $.trim(json_key.split('[')[0])
                                if(prop_json[json_key]) {
                                    var cart_inventory = prop_json[json_key]
                                    usebeled_inventory = usebeled_inventory + parseInt(cart_inventory)
                                }
                                if(cart_inventory){
                                    var remaining_inventory =  parseInt(available_inventory) - parseInt(cart_inventory)
                                }else{
                                    var remaining_inventory =  parseInt(available_inventory)
                                }
                                let edit_cart_inventory = $(".hulkapps_product_options").find(`[data-uid='${json_key}']`);
                                if(edit_cart_inventory.length > 0){
                                    let used_hinventory = edit_cart_inventory.attr('data-used_hinventory')
                                    available_inventory = available_inventory + parseInt(used_hinventory);
                                }
                                if(available_inventory < usebeled_inventory){
                                    is_valid = false;
                                    $(element).parents(".hulkapps_option").addClass("validation_error");

                                    if(remaining_inventory > 0){

                                        $(element).parents(".hulkapps_option").append(`<p class="inventory_error" tabindex="0" aria-label="Only ${remaining_inventory} inventory available for this ${value.split("_hin_")[0]} option. </p>">Only ${remaining_inventory} inventory available for this ${value.split("_hin_")[0]} option. </p>`)
                                    }else{
                                        $(element).parents(".hulkapps_option").append(`<p class="inventory_error" tabindex="0" aria-label="Not enough items in the inventory for ${value.split("_hin_")[0]}.">Not enough items in the inventory for ${value.split("_hin_")[0]}. </p>`)
                                    }
                                    is_inventory_validation_error = true;
                                    good = false;
                                    // return false;
                                }else if (is_valid){
                                    $(element).parents(".hulkapps_option").removeClass("validation_error");
                                    $(element).parents(".hulkapps_option").find(".inventory_error").remove();
                                    is_inventory_validation_error = false;
                                    good = true;
                                }

                            }
                        });

                    }else{
                        if($(this).val() != ""){
                            var available_inventory = $(this).val().split("_hin_")[1]
                            available_inventory = parseInt(available_inventory)
                            var pqty = 1
                            if($("input[name=quantity]").val()){
                                pqty = parseInt($("input[name=quantity]").val())
                            }
                            if((window.opt_with_otc[$(this).data("unique_prop_name")] == true) || (window.opt_with_otc[$(this).data("unique_prop_name")] == 'true')){
                                var usebeled_inventory = 1
                            }else {
                                if (data_quantity != '') {
                                    var usebeled_inventory = parseInt(data_quantity);
                                } else {
                                    var usebeled_inventory = pqty
                                }
                            }
                            var options_quantity = 1
                            if($(this).parents(".hulkapps_option_value").find(".hulk_options_quantity").length > 0) {
                                options_quantity = parseInt($(this).parents(".hulkapps_option_value").find(".hulk_options_quantity").val())
                                if (options_quantity <= 0) {
                                    options_quantity = 1
                                }
                            }
                            usebeled_inventory = usebeled_inventory * options_quantity
                            let json_key = $(this).val().split("_hin_")[0]
                            json_key = $(this).attr("data-unique_prop_name") + $.trim(json_key.split('[')[0])
                            if(prop_json[json_key] && data_quantity == '') {
                                var cart_inventory = prop_json[json_key]
                                usebeled_inventory = usebeled_inventory + parseInt(cart_inventory)
                            }
                            if(cart_inventory){
                                var remaining_inventory =  parseInt(available_inventory) - parseInt(cart_inventory)
                            }else{
                                var remaining_inventory =  parseInt(available_inventory)
                            }
                            if(available_inventory < usebeled_inventory){
                                $(this).parents(".hulkapps_option").addClass("validation_error");
                                $(this).parents(".hulkapps_option").find(".inventory_error").remove();
                                if(remaining_inventory > 0){
                                    $(this).parents(".hulkapps_option").append(`<p class="inventory_error" tabindex="0" aria-label="Only ${remaining_inventory} inventory available for this ${$(this).val().split("_hin_")[0]} option.">Only ${remaining_inventory} inventory available for this ${$(this).val().split("_hin_")[0]} option. </p>`)
                                }else{
                                    $(this).parents(".hulkapps_option").append(`<p class="inventory_error" tabindex="0" aria-label="Not enough items in the inventory for ${$(this).val().split("_hin_")[0]}">Not enough items in the inventory for ${$(this).val().split("_hin_")[0]}. </p>`)
                                }
                                is_inventory_validation_error = true
                                good = false;
                                //return false;
                            }else if(good == false){
                                is_inventory_validation_error = true
                            }else{
                                $(this).parents(".hulkapps_option").find(".inventory_error").remove();
                                $(this).parents(".hulkapps_option").removeClass("validation_error");
                                good = true;
                                is_inventory_validation_error = false;
                            }
                        }
                    }
                });
                if(is_inventory_validation_error == true){
                    return false
                }
                else{
                    return good;
                }

            }).catch(function (error) {
                return true;
            })
        }
        window.validate_single_option = function (option_type_id, option_type,hulkapps_parents="") {
            var hulkapps_parents = hulkapps_parents;
            if(hulkapps_parents == ""){
                hulkapps_parents = "hulkapps_product_options"
            }
            if (option_type == 'dd_render' ) {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("select[name^='properties']").length == 1 && !$('.'+hulkapps_parents).find('.' + option_type_id).find("select[name^='properties']:not(.hulk_unique_sku)").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                }
            } else if (option_type == 'ci_render' ){
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").length == 1 && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']:not(.hulk_unique_sku)").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                }
            }else if (option_type == 'dd_multi_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("select[multiple]").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']:not(.hulk_unique_sku)").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                }
            } else if (option_type == 'swatch_render') {
                // if ($('.'+option_type_id).find(".hulkapps_swatch_option").length && !$('.'+option_type_id).find("input[name^='properties']:checked").length && $('.'+option_type_id).hasClass('required')) {
                //   $('.'+option_type_id).addClass("validation_error");
                // }else {
                $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                // }
            } else if (option_type == 'multiswatch_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find(".hulkapps_swatch_option").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']:not(.hulk_unique_sku)").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'button_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find(".hulkapps_buton_option").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']:not(.hulk_unique_sku,.hulk_unique_prop)").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'cp_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='text']").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'cb_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find(".hulkapps_check_option").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']:not(.hulk_unique_sku,.hulk_unique_prop)").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'tb_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='text']").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'dt_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='time']").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'stg_render') {
                $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                if($('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')){

                    $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='text']").each(function () {
                        if($(this).val() == "" && !$(this).parents(".hulkapps_short_option_value").hasClass("conditional")){
                            $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                        }
                    });
                }

            } else if (option_type == 'gf_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='text']").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='text']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            }else if (option_type == 'nf_render') {
                var $wrapper = $('.' + hulkapps_parents).find('.' + option_type_id);
                var $input   = $wrapper.find("input[type='number']");
                var isRequired = $wrapper.hasClass('required');

                if (!$input.length) {
                    return;
                }

                var min = parseFloat($input.attr('data-min') || $input.attr('min'));
                var max = parseFloat($input.attr('data-max') || $input.attr('max'));
                var val = parseFloat($input.val());

                var hasMin = Number.isFinite(min) && min !== 0;
                var hasMax = Number.isFinite(max) && max !== 0;
                var hasVal = Number.isFinite(val);

                // Clear previous errors
                $wrapper.removeClass("validation_error");
                $wrapper.find('.error_span').remove();
                $wrapper.removeAttr('aria-label tabindex');

                // Required but empty / invalid
                if (isRequired && !hasVal) {
                    $wrapper.addClass("validation_error");
                    return;
                }

                // Plan-based validation
                if (!checkPlan('validation_for_min_max_option_selection', 'boolean') || !hasVal) {
                    return;
                }

                var errorMsg = '';

                if (hasMin && hasMax) {
                    if (val < min || val > max) {
                        errorMsg = `Enter a number between ${min} and ${max}`;
                    }
                } else if (hasMin) {
                    if (val < min) {
                        errorMsg = `Enter a number greater than or equal to ${min}`;
                    }
                } else if (hasMax) {
                    if (val > max) {
                        errorMsg = `Enter a number less than or equal to ${max}`;
                    }
                }

                if (errorMsg) {
                    $wrapper.addClass("validation_error");
                    $wrapper.append(
                        `<span class="validation_error error_span" tabindex="0">${errorMsg}</span>`
                    );
                    $wrapper.attr('aria-label', errorMsg);
                }
            }else if (option_type == 'dp_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").length && $('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val()) {
                    var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/; //Declare Regex
                    var option_date = $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").val()
                    if (option_date.includes("-")) {
                        var dateParts = option_date.split("-");
                        option_date = dateParts[1] + "/" + dateParts[2] + "/" + dateParts[0]
                    }
                    var dtArray = option_date.match(rxDatePattern);    // is format OK?
                    // month is 0-based, that's why we need dataParts[1] - 1
                    if (dtArray == null) {
                        $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                        $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                        $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").after('<span class="validation_error error_span">'+ window.invalid_date_validation_message +'</span>');
                    } else {
                        //Checks for dd/mm/yyyy format.
                        dtMonth = dtArray[1];
                        dtDay = dtArray[3];
                        dtYear = dtArray[5];
                        if (dtMonth < 1 || dtMonth > 12) {
                            $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                            $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                            $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").after('<span class="validation_error error_span">'+ window.invalid_date_validation_message +'</span>')
                        } else if (dtDay < 1 || dtDay > 31) {
                            $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                            $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                            $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").after('<span class="validation_error error_span">'+ window.invalid_date_validation_message +'</span>')
                        } else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31) {
                            $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                            $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                            $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").after('<span class="validation_error error_span">'+ window.invalid_date_validation_message +'</span>')
                        } else if (dtMonth == 2) {
                            var isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
                            if (dtDay > 29 || (dtDay == 29 && !isleap)) {
                                $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                                $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                                $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").after('<span class="validation_error error_span">'+ window.invalid_date_validation_message +'</span>')
                            } else {
                                $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                                $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                                $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                            }
                        } else if (dtArray[2] !== "/" || dtArray[4] !== "/") {
                            $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                            $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                            $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").after('<span class="validation_error error_span" tabindex="0" aria-labe='+ window.invalid_date_validation_message +'>'+ window.invalid_date_validation_message +'</span>')
                        } else {
                            $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                            $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                            $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                        }
                    }
                } else {
                    if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='date']").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                        $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                        // $('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                    } else {
                        //$('.'+hulkapps_parents).find('.' + option_type_id).find('.validation_error').remove();
                        $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                        $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    }
                }
            } else if (option_type == 'ta_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("textarea").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }

            } else if (option_type == 'rb_render') {
                // if ($('.'+option_type_id).find(".hulkapps_radio_option").length && !$('.'+option_type_id).find("input[name^='properties']:checked").length && $('.'+option_type_id).hasClass('required')) {
                //   $('.'+option_type_id).addClass("validation_error");
                // }else {
                $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                // }
            } else if (option_type == 'fu_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='file']").length && !$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            } else if (option_type == 'pn_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='text']").length && ((!$('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')))) {
                    $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                    good = false;
                } else {
                    if ($('.'+hulkapps_parents).find('.' + option_type_id).find(".phone_number").hasClass('error')) {
                        $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                        good = false;
                    } else {
                        $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                        $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    }
                }
            } else if (option_type == 'et_render') {
                if ($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='email']").length && (($('.'+hulkapps_parents).find('.' + option_type_id).find("input[name^='properties']").val() && $('.'+hulkapps_parents).find('.' + option_type_id).hasClass('required')) || (($('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='email']").val().length) != ''))) {
                    var userEmail = $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='email']").val();
                    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,5}|[0-9]{1,3})(\]?)$/;
                    if (!filter.test(userEmail)) {
                        $('.'+hulkapps_parents).find('.' + option_type_id).addClass("validation_error");
                        if(!$('.'+hulkapps_parents).find('.' + option_type_id).find('.error_span').length > 0){
                            $('.'+hulkapps_parents).find('.' + option_type_id).attr('aria-label', window.invalid_email_validation_message)
                            $('.'+hulkapps_parents).find('.' + option_type_id).find("input[type='email']").after('<span class="validation_error error_span" tabindex="0" aria-label="'+ window.invalid_email_validation_message +'">'+ window.invalid_email_validation_message +'</span>');
                        }

                    } else {
                        $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                        $('.'+hulkapps_parents).find('.' + option_type_id).find(".error_span").remove();
                        $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                    }
                } else {
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeClass("validation_error");
                    $('.'+hulkapps_parents).find('.' + option_type_id).find(".error_span").remove();
                    $('.'+hulkapps_parents).find('.' + option_type_id).removeAttr('aria-label tabindex');
                }
            }
        }




        // Start file uploading js
        $(document).on("change", ".hulk_file_upload", function(){
            var filename = $(this).val();
            var number_of_files = $(this)[0].files;
            if (/^\s*$/.test(filename)) {
                $(this).parents(".file-upload").removeClass('hulk-active');
                $(this).parents(".file-upload").find(".noFile").text("No file chosen...");
            }
            else {
                $(this).parents(".file-upload").addClass('hulk-active');
                conditional_rules(window.hulkapps.product_id,'hulkapps_product_options');
                if(number_of_files.length > 1){
                    $(this).parents(".file-upload").find(".noFile").text(`${number_of_files.length } Files selected`);
                }else{
                    $(this).parents(".file-upload").find(".noFile").text(filename.replace("C:\\fakepath\\", ""));
                }
              
            }
        });
        // End file uploading js

        // Start color image dropdown js
        var allOptions = ''
        $(document).on("click", "ul.hulkapps_product_options_ul .init", function () {
            $(this).parent(".hulkapps_option_child").children('li:not(.init)').toggleClass("hulk-flex");
        });

        $(document).on("click", "ul.hulkapps_product_options_ul li:not(.init)", function (event, params) {
            const isProgrammatic = params && params.isProgrammatic || params;
            let groupId = $(this).closest('.hulkapps_option').attr("data-parent-id");
            if(!isProgrammatic){
                userModifiedGroups[groupId] = true;
            }

            var hulk_parent_div = $(this).parent('ul').attr('data-parent');
            var hulk_pid = $(this).parent('ul').attr('data-pid');
            
            var uniq_val_identifier = $(this).attr('data-uid');
            var data_display_value = $(this).attr('data-display-val');
            var data_hinventory = $(this).attr('data-hinventory')

            // Check if placeholder option is clicked (for unselecting)
            var isPlaceholderOption = $(this).hasClass('placeholder-option');

            if(isPlaceholderOption){
                // Hide quantity picker when placeholder is selected
                $(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').hide();
            } else {
                $(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').show();
            }

            $(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').show();
            $(this).parents('.ci_render').find('.inventory_error').html('')
            $(this).parents('.ci_render').find('.hulk_unique_sku').prop('disabled', true);
            var id = $(this).closest('ul').attr('id');
            allOptions = $("#"+id+"").children('li:not(.init)');
            allOptions.removeClass('dropdown_selected');
            $(this).addClass('dropdown_selected');
            $(this).closest('ul').children('.init').html($(this).html());

            if(!isProgrammatic){
                $(this).closest('ul').children('li:not(.init)').toggleClass("hulk-flex");
            }

            $(this).closest('ul').children('.init').attr('data-uid',uniq_val_identifier);
            $(this).closest('ul').children('.init').attr('data-display-val',data_display_value);
                $(this).closest('ul').children('.init').attr('data-hinventory',data_hinventory);
            var opt_qty = '';
            if($(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val()){
                opt_qty = ` | ${$(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val()}`;
            }
            if($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') .length > 0) {
                if($(this).data('hinventory') != '') {
                    $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val($(this).attr('data-value') + '_hin_' + $(this).data('hinventory') + opt_qty)
                }else{
                    $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') .val("");
                }
            }

            $(this).parents('.hulkapps_option_value').find('.hulk_opt_prop').val($(this).attr('data-value') + opt_qty );
            $(this).find('.hulk_unique_sku').prop('disabled', false);

            conditional_rules(parseInt(hulk_pid),hulk_parent_div);if($('#hulk_amount_dis').val() == '1'){calc_options_total(parseInt(hulk_pid),hulk_parent_div);}validate_single_option("option_type_id_" + id + "",'ci_render',hulk_parent_div);
            changeImage(this)
        });


        $(document).on("click", ".hulkapps_product_options_ul_parent .hulk_options_quantity", function() {
            $(this).parents('.hulkapps_option_value').find('.hulk_opt_prop').val($(this).parents('.hulkapps_option_value').find('li.dropdown_selected').attr('data-value') + ' | ' + $(this).val() );

            if($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') .length > 0 && $(this).parents('.hulkapps_option_value').find('li.dropdown_selected').data('hinventory')){
                $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') .val($(this).parents('.hulkapps_option_value').find('li.dropdown_selected').attr('data-value') + '_hin_' + $(this).parents('.hulkapps_option_value').find('li.dropdown_selected').data('hinventory') + ' | ' + $(this).val() )}
            if($('#hulk_amount_dis').val() == '1'){calc_options_total(parseInt(window.hulkapps.product_id),'hulkapps_product_options');}
        });
        // End color image dropdown js

        /* start multi qty selector option*/
        $(document).on('click keyup', '.multi-qty-option', function(event) {

            $(this).parents('.muti-qty-div').parents('.hulkapps_option_value').parent('.mq_render').removeClass('validation_error');
            $(this).parents('.muti-qty-div').parents('.hulkapps_option_value').parent('.mq_render').find('.inventory_error').remove();
            var unique_prop_val = []
            var hulk_mutli_qty = []
            var data_inventory_record = []

            var hulk_parent_div = $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr('data-parent');
            var hulk_pid = $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr('data-pid');
            var total_price  = 0
            var quantity =  $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr('data-qval');
            var validation_error = '<span class="validation_error error_span" tabindex="0" >'
            var mq_render_parent_class = $(this).parents('.muti-qty-div').parents('.hulkapps_option_value').parent('.mq_render')
            
            if($(this).data('htype') == 'number_input'){
                var quantity = $(this).val();
                $(this).text(quantity);
                $(this).attr("data-qval",quantity);
            }
            else if($(this).data('htype') == 'increment'){
                quantity++;
                $(this).parent('.quantity_selector').find(".hulk_quantity_amount").val(quantity);
                $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr("data-qval",quantity);
            }else{
                if (quantity > 0) {
                    quantity--;
                    $(this).parent('.quantity_selector').find(".hulk_quantity_amount").val(quantity);
                    $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr("data-qval",quantity);
                } else {
                }
            }

            if($(".hulk_quantity_popup").length != 0){
                var min_selection = parseInt($(this).siblings(".hulk_quantity_amount").attr("data-min"))
                var max_selection = parseInt($(this).siblings(".hulk_quantity_amount").attr("data-max"))
                var mq_render_parent_class = $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main')
            }else{
                var min_selection = parseInt($(this).parents('.mq_render').attr("data-min"));
                var max_selection = parseInt($(this).parents('.mq_render').attr("data-max"));
                var mq_render_parent_class = $(this).parents('.muti-qty-div').parents('.hulkapps_option_value').parent('.mq_render')
            }
            
            var selected_qty_count = 0;
            if (!window.ignore_min_max_validation && checkPlan('validation_for_min_max_option_selection', 'boolean')) {
                $(this).parents('.muti-qty-div').parents('.hulkapps_option_value').find('.hulk_quantity_amount').each(function() {
                    var qty = parseInt($(this).attr('data-qval'));
        
                    if (qty > 0) {
                        selected_qty_count += qty;
                    }
                });

            var progressWrapper = mq_render_parent_class.find('.hulk-progress-bar-wrapper');
            if (progressWrapper.length) {
                var limit = max_selection > 0 ? max_selection : min_selection; // pick whichever applies
                var safeCount = Math.min(selected_qty_count, limit);
                var percentage = limit > 0 ? (safeCount / limit) * 100 : 0;

                progressWrapper.find('.hulk-progress-bar').css('width', percentage + '%');
                progressWrapper.find('.hulk-progress-label').text(safeCount + " / " + limit);
            }


                
                if ((min_selection != 0) && (max_selection != 0)) {
                    if (selected_qty_count < min_selection) {
                        mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        mq_render_parent_class.append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                        mq_render_parent_class.find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                        if (selected_qty_count == 0) {
                            mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        }
                    } else if (selected_qty_count > max_selection) {
                        mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        mq_render_parent_class.append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                        mq_render_parent_class.find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                        if (selected_qty_count != max_selection) {
                            mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        }
                        quantity--;
                        if($(this).data('htype') == 'number_input'){ 
                            $(this).val(0);
                            $(this).attr("data-qval",0);
                        }else{
                            $(this).parent('.quantity_selector').find(".hulk_quantity_amount").val(quantity);
                            $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr("data-qval",quantity);
                        }
                       
                    } else {
                        mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                    }
                } else if (min_selection != 0) {
                    if (selected_qty_count < min_selection) {
                        mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        mq_render_parent_class.append(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                        mq_render_parent_class.find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);
                    } else {
                        mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                    }
                } else if (max_selection != 0) {
                    if (max_selection >= selected_qty_count) {
                        if (max_selection == selected_qty_count) {
                            mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        } else {
                            mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                            mq_render_parent_class.append(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`);
                            mq_render_parent_class.find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
                        }
                    } else {
                        mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
                        quantity--;
                        if($(this).data('htype') == 'number_input'){ 
                            $(this).val(0);
                            $(this).attr("data-qval",0);
                        }else{
                            $(this).parent('.quantity_selector').find(".hulk_quantity_amount").val(quantity);
                            $(this).parent('.quantity_selector').find(".hulk_quantity_amount").attr("data-qval",quantity);
                        }
                    }
                }
                
            } else {
                // Remove any existing error message and validation error class if validation is not required
                mq_render_parent_class.removeClass('validation_error').find('.error_span').remove();
            }

            $(this).parents('.muti-qty-div').parents('.hulkapps_option_value').find( ".hulk_quantity_amount" ).each(function( index ) {
                if(parseInt($(this).attr('data-qval')) > 0){
                    $(this).parents('.hulk_quantity_div').parent('.muti-qty-div').find('.hulk_quantity_left').find('.hulk_unique_sku').removeAttr('disabled');
                    var did = $(this).attr('id');
                    var opt_qty = '';
                    var hin_opt_qty = '';
                    opt_qty = ` | ${$(this).attr('data-qval')}`
                    hin_opt_qty = $(this).attr('data-qval');
                    var available_inventory = $(this).attr('data-hinventory');
                    total_price += (parseFloat($(this).attr('data-price')) * parseInt(hin_opt_qty));
                    var qty_val = $(this).attr('data-value');
                    if(available_inventory){
                        unique_prop_val.push(`${qty_val}_hin_${available_inventory}${opt_qty}`)
                    }
                    hulk_mutli_qty.push(`${qty_val}${opt_qty}`)
                    data_inventory_record.push(`${qty_val}_hin_${hin_opt_qty}`)
                }else{
                    $(this).parents('.muti-qty-div').find('.hulk_quantity_left').find('.hulk_unique_sku').attr('disabled',true);

                }
            });
            $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').val(unique_prop_val.join(' , '));
            if(hulk_mutli_qty.length > 0){
                $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').addClass("mqty_selected");
                $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr("data-inventory-record",data_inventory_record);
                $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr("data-price",total_price);

            }else{
                $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').removeClass("mqty_selected");
                $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_unique_prop').attr("data-price",'');

            }
            $(this).parents('.muti-qty-div').parent('.hulk_multi_qty_main').find('.hulk_mutli_qty').val(hulk_mutli_qty.join(' , '));
            calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            conditional_rules(parseInt(hulk_pid),hulk_parent_div);

        });
        /* end multi qty selector option*/
        // Start dropdown js
        $(document).on('change', '.hulk_po_dropdown', function (event, params) {
            const isProgrammatic = params && params.isProgrammatic || params;
            let groupId = $(this).closest('.hulkapps_option').attr("data-parent-id");
            if(!isProgrammatic){
                userModifiedGroups[groupId] = true;
            }
            var did = $(this).attr('id');
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            if ($(this).val()) {
                $(this).parent('.hulkapps_option_value').find('.hulk_options_quantity').show();
            } else {
                $(this).parent('.hulkapps_option_value').find('.hulk_options_quantity').hide();
            }
            $(this).parents('.dd_render').find('.hulk_unique_sku').prop('disabled', true);
            $(this).parents('.dd_render').find('.inventory_error').html('');
            var opt_qty = '';
            if ($(this).parent('.hulkapps_option_value').find('.hulk_options_quantity').val()) {
                opt_qty = ` | ${$(this).parent('.hulkapps_option_value').find('.hulk_options_quantity').val()}`
            }
            if ($(this).parent('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').length > 0) {
                if ($(this).val() && $(this).children('option:selected').data('hinventory')) {
                    $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).val()}_hin_${$(this).children('option:selected').data('hinventory')}${opt_qty}`)
                } else {
                    $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').val('')
                }
            };
            if ($(this).val()) {
                $(this).parent('.hulkapps_option_value').find('.hulk_dropdown_hidden_prop').val($(this).val() + opt_qty);
            } else {
                $(this).parent('.hulkapps_option_value').find('.hulk_dropdown_hidden_prop').val('');
            }
            var cond_value = $(this).find('option:selected').data('conditional-value');
            if (cond_value) {
                $(this).parents('.dd_render').find(`[data-sku-identifier='${cond_value}']`).removeAttr('disabled')
            };
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${did}`, 'dd_render', hulk_parent_div);
            changeImage(this)
        });
        $(document).on('change', '.hulk_po_dropdown_quantity', function() {
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            $(this).parent('.hulkapps_option_value').find('.hulk_dropdown_hidden_prop').val(`${$(this).parent('.hulkapps_option_value').find('.hulkapps_option_child').val()} | ${$(this).val()}`);
            if ($(this).parent('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').length > 0) {
                if ($(this).parent('.hulkapps_option_value').find('.hulkapps_option_child').children('option:selected').data('hinventory')) {
                    $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).parent('.hulkapps_option_value').find('.hulkapps_option_child').val()}_hin_${$(this).parent('.hulkapps_option_value').find('.hulkapps_option_child').children('option:selected').data('hinventory')} | ${$(this).val()}`)
                } else {
                    $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').val('')
                }
            };
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
        });
        // End dropdown js

        // Start dropdown multiple js
        $(document).on('change', '.hulk_po_dropdown_multiple', function (event, params) {
            const isProgrammatic = params && params.isProgrammatic || params;
            let groupId = $(this).closest('.hulkapps_option').attr("data-parent-id");
            if(!isProgrammatic){
                userModifiedGroups[groupId] = true;
            }
            var dmid = $(this).attr('id');
            var min_selection = parseInt($(this).attr('data-min'));
            var max_selection = parseInt($(this).attr('data-max'));
            var validation_error = '<span class="validation_error error_span" tabindex="0">'
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            $(this).parents('.dd_multi_render').find('.hulk_unique_sku').prop('disabled', true);
            $(this).parents('.dd_multi_render').find('.inventory_error').html('');
            if ((min_selection != 0) && (max_selection != 0) && (checkPlan('validation_for_min_max_option_selection', 'boolean'))) {
                if ($(this).find('option:selected').length < min_selection) {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).after(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`)

                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                    if ($(this).find('option:selected').length == 0) {
                        $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    }
                } else if ($(this).find('option:selected').length > max_selection) {
                    $(this).find('option:selected:last').prop('selected', false);
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).after(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                    if ($(this).find('option:selected').length == max_selection) {
                        $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    }
                } else {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                }
            } else if (checkPlan('validation_for_min_max_option_selection', 'boolean') && " + min_selection + " != 0) {
                if ($(this).find('option:selected').length < min_selection) {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).after(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);

                } else {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                }
            } else if (checkPlan('validation_for_min_max_option_selection', 'boolean') && " + max_selection + " != 0) {
                if (max_selection >= $(this).find('option:selected').length) {
                    if (max_selection == $(this).find('option:selected').length) {
                        $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    } else {
                        $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                        $(this).after(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`)
                        $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
                    }
                } else {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).find("option:selected:last").prop('selected', false);
                }
            } else {
                $(this).parents('.hulkapps_option').removeClass('validation_error');
            }
            var chkMulti = $.map($(`.${hulk_parent_div}`).find(`.hulkapps_option_${dmid}_visible:not([disabled])  :selected`), function(el, i) {
                return $(el).val();
            });

            $(`.${hulk_parent_div}`).find(`#hulkapps_option_${dmid}_hidden`).val(chkMulti.join(', '));
            var chkMultiinventory = $.map($(`.${hulk_parent_div}`).find(`.hulkapps_option_${dmid}_visible:not([disabled]) :selected`), function(
                el, i) {
                if ($(el).data('hinventory') != '') {
                    return $(el).val() + '_hin_' + $(el).data('hinventory')
                };
            });
            if ($(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').length > 0) {
                $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').val(chkMultiinventory.join(', '))
            };
            $(`.${hulk_parent_div}`).find(`.hulkapps_option_${dmid}_visible:not([disabled]) :selected`).each(function(index) {
                var cond_value = $(this).data('conditional-value');
                if (cond_value) {
                    $(this).parents('.dd_multi_render').find(`[data-sku-identifier='${cond_value}']`).removeAttr('disabled')
                }
            });
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${dmid}`, 'dd_multi_render', hulk_parent_div);
        });
        // End dropdown multiple js

        // Start Swatch/button js
        $(document).on('change click', '.hulk_po_radio', function (event, params) {
            const isProgrammatic = params && params.isProgrammatic || params;
            let groupId = $(this).closest('.hulkapps_option').attr("data-parent-id");
            if(!isProgrammatic){
                userModifiedGroups[groupId] = true;
            }
            var sid = $(this).attr('data-oid');
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            var radio_class = $(this).attr('data-radio-class');
            var single_valid_class = $(this).attr('data-single_valid-class');
            var val_selected_class = $(this).attr('data-val-selected-class');
            var hidden_prop_class = $(this).attr('data-hidden-class');
            $(this).parents(`.${single_valid_class}`).find('.hulk_unique_sku').prop('disabled', true);
            $(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').show();
            if(single_valid_class == "swatch_render"){
                $(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val('1');
            }
            var opt_qty = '';
            if ($(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val()) {
                opt_qty = ` | ${$(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val()}`
            }
            if ($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length > 0) {
                if ($(this).find(`.${radio_class}`).data('hinventory')) {
                    $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).find(`.${radio_class}`).val()}_hin_${$(this).find(`.${radio_class}`).data('hinventory')}${opt_qty}`);
                } else {
                    $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val('');
                }
            };
            $(this).find(`.${radio_class}`).prop('checked', true);
            $(this).parents(`.${single_valid_class}`).find(`.${val_selected_class}`).removeClass(val_selected_class);
            $(this).parents('.hulkapps_option_value').find(`.${hidden_prop_class}`).val(`${$(this).find(`.${radio_class}`).val()}${opt_qty}`);
            $(this).parents(`.${single_valid_class}`).find('.inventory_error').html('');
            $(this).addClass(val_selected_class);
            $(this).parents('label').find('.hulk_unique_sku').prop('disabled', false);
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${sid}`, single_valid_class, hulk_parent_div);
            changeImage(this)
        });
        $(document).on('change', '.hulk_po_swatch_quantity',function() {
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            $(this).parent('.hulkapps_option_value').find('.hulk_swatch_hidden_prop').val(`${$(this).parents('.hulkapps_option_value').find('.swatch_radio:checked').val()} | ${$(this).val()}`);
            if ($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length > 0 && $(this).parent('.hulkapps_option_value').find('.swatch_radio:checked').data('hinventory')) {
                $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).parent('.hulkapps_option_value').find('.swatch_radio:checked').val()}_hin_${$(this).parent('.hulkapps_option_value').find('.swatch_radio:checked').data('hinventory')} | ${$(this).val()}`)
            } else {
                $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val('');
            }
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
        });
        $(document).on('change', '.hulk_po_button_quantity',function() {
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            $(this).parents('.hulkapps_option_value').find('.hulk_button_hidden_prop').val(`${$(this).parents('.hulkapps_option_value').find('.button_selected').find('.button_radio').val()} | ${$(this).val()}`);
            if ($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length > 0 && $(this).parent('.hulkapps_option_value').find('.button_selected').find('.button_radio').data('hinventory')) {
                $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).parents('.hulkapps_option_value').find('.button_selected').find('.button_radio').val()}_hin_${$(this).parent('.hulkapps_option_value').find('.button_selected').find('.button_radio').data('hinventory')} | ${$(this).val()}`)
            }
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
        });

        // End swatch/button js

        //Change image based on multiple option
        function changeImage(current_element){
            var current_element = $(current_element);
            var radio_combination = [];
        
            $('.image_change_with_multiple').each(function(){
                var first_element = $(this).find('.hulkapps_option_child:first');
                var val_selected_class = first_element.attr('data-val-selected-class');
        
                if ($(first_element).prop("type") == "radio") {
                    var selected = $(this).find(`.${val_selected_class}`);
                    if (selected.length == 1) {
                        var val = $.trim(selected.parents('.hulkapps_radio_option').find('.hulkapps_option_child').attr('data-conditional-value'));
                        if (val) radio_combination.push(val);
                    }
        
                } else if ($(first_element).prop("type") == "select-one") {
                    var val = $.trim($(first_element).find(':selected').data('conditional-value'));
                    if (val) radio_combination.push(val);
        
                } else {
                    var selected = $(this).find(`.${val_selected_class}`);
                    if (selected.length == 1) {
                        var val = $.trim(selected.attr('data-conditional-value'));
                        if (val) radio_combination.push(val);
                    }
                }
            });
        
            if (radio_combination.length > 0) {
                var radio_combination = radio_combination.join(' ').toLowerCase();
                $(window.image_parent).each(function(){
                    var slider_img_alt = $.trim($(this).attr('alt')).toLowerCase().replaceAll('_',' ');
                    if (slider_img_alt == radio_combination) {
                        $(this).click();
                    }
                });
            }
        }

        // Keybord enter key  access
        window.keybordAccess = function(){
            const radios = document.querySelectorAll('.hulkapps_buton_option,.hulkapps_check_option,.hulkapps_radio_option,.hulkapps_swatch_option,.hulkapps_mswatch_option,ul.hulkapps_product_options_ul .init,ul.hulkapps_product_options_ul li:not(.init),.hulk_po_other_options,.font-select span,.fs-results li,.hulk_file_upload,.popup_open_link,.file-upload,.popup_close_link');
            radios.forEach((radio) => {
                radio.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        if (radio.classList.contains('file-upload')) {
                            radio.querySelector('.hulk_file_upload').click();
                            // do something with radio button
                        }else{
                            radio.click();
                        }
                    }
                });
            });
            var groups = document.getElementsByClassName('hulkapps_option_value');
            var currentGroupIndex = 0;
            var currentLabelIndex = 0;

            document.addEventListener('keydown', function(event) {
                var keyCode = event.keyCode;

                if (keyCode === 37 || keyCode === 38) { // Left or up arrow
                    currentLabelIndex = (currentLabelIndex > 0) ? currentLabelIndex - 1 : 0;
                }
                else if (keyCode === 39 || keyCode === 40) { // Right or down arrow
                    var currentFocusedElement = document.activeElement;
                    var parentGroupElement = currentFocusedElement.closest('.hulkapps_option_value');
                    if (!parentGroupElement) {
                        parentGroupElement = groups[currentGroupIndex];
                    }
                    var currentGroupLabels = parentGroupElement.querySelectorAll('label, li');
                    var lastLabelIndex = currentGroupLabels.length - 1;
                    if (currentLabelIndex === lastLabelIndex) {
                        // Move to the next group's first label
                        if (parentGroupElement) {
                            var parentGroupIndex = Array.prototype.indexOf.call(groups, parentGroupElement);
                            if (parentGroupIndex === currentGroupIndex) {
                                currentLabelIndex = 0;
                            } else {
                                currentGroupIndex = (currentGroupIndex < groups.length - 1) ? currentGroupIndex + 1 : 0;
                                currentLabelIndex = 0;
                            }
                        }
                    } else {
                        // Move to the next label in the current group
                        currentLabelIndex = (currentLabelIndex < lastLabelIndex) ? currentLabelIndex + 1 : lastLabelIndex;
                    }
                }
                else {
                    return; // Not an arrow key, exit
                }

                // Update the current group index to the index of the active group
                var activeGroupElement = document.activeElement.closest('.hulkapps_option_value');
                if (activeGroupElement) {
                    currentGroupIndex = Array.prototype.indexOf.call(groups, activeGroupElement);
                }

                var elementToFocus = groups[currentGroupIndex].querySelectorAll('label, li')[currentLabelIndex];
                if(elementToFocus != undefined){

                    elementToFocus.focus();
                    event.preventDefault();// Focus the new element
                }

            });
        }

        // Start Swatch multiple / checkbox js
        $(document).on('change', '.hulk_po_checkbox', function (event, params) {
            const isProgrammatic = params && params.isProgrammatic || params;
            let groupId = $(this).closest('.hulkapps_option').attr("data-parent-id");
            if(!isProgrammatic){
                userModifiedGroups[groupId] = true;
            }
            var cid = $(this).attr('data-oid');
            var single_valid_class = $(this).attr('data-single_valid-class');
            var min_selection = parseInt($(this).attr('data-min'));
            var max_selection = parseInt($(this).attr('data-max'));
            var validation_error = '<span class="validation_error error_span" tabindex="0" >'
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            $(this).parents(`.${single_valid_class}`).find('.hulk_unique_sku').prop('disabled', true);
            if(single_valid_class == 'multiswatch_render'){
                setTimeout(() => {
                    $(this).is(':checked') ? $(this).parent().addClass('swatch_selected') : $(this).parent().removeClass('swatch_selected');
                    $(this).find('.hulk_po_swatch_multiple_checkbox').is(':checked') ? $(this).addClass('swatch_selected') : $(this).removeClass('swatch_selected');
                    $(this).parents('.multiswatch_render').find('.inventory_error').html('')
                }, 0);
            }else{
                $(this).parents('.cb_render').find('.inventory_error').html('');
            }
            if ((min_selection!= 0) && (max_selection != 0) && (checkPlan('validation_for_min_max_option_selection', 'boolean'))) {
                if (($(`.hulkapps_option_${cid}_visible:checkbox:checked`).length) < min_selection) {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).parents('.hulkapps_option').append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                    if (($(`.hulkapps_option_${cid}_visible:checkbox:checked`).length) == 0) {
                        $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    }
                } else if (($(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:checkbox:checked`).length) > max_selection) {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).parents('.hulkapps_option').append(`${validation_error} ${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}</span>`);
                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_max_validation_message, {min: min_selection,max: max_selection})}`);
                    if (($(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:checkbox:checked`).length) != max_selection) {
                        $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    }
                    if(single_valid_class == 'multiswatch_render'){
                        $(this).find(':checkbox').prop('checked', false);

                    }else{
                        this.checked = false;
                    }
                } else {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                }
            } else if (min_selection != 0 && (checkPlan('validation_for_min_max_option_selection', 'boolean'))) {
                if (($(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:checkbox:checked`).length) < min_selection) {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).parents('.hulkapps_option').append(`${validation_error} ${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}</span>`);
                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.min_only_validation_message, { min: min_selection })}`);
                } else {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                }
            } else if (max_selection != 0 && (checkPlan('validation_for_min_max_option_selection', 'boolean'))) {
                const checked_count = $(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:checkbox:checked`).length;
            
                if (checked_count > max_selection) {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                    $(this).parents('.hulkapps_option').append(`${validation_error} ${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}</span>`);
                    $(this).parents('.hulkapps_option').find('.validation_error').attr('aria-label',`${buildValidationMessage(window.max_only_validation_message, { max: max_selection })}`);
            
                    if (single_valid_class == 'multiswatch_render') {
                        $(this).find(':checkbox').prop('checked', false);
                    } else {
                        this.checked = false;
                    }
                } else {
                    $(this).parents('.hulkapps_option').removeClass('validation_error').find('.error_span').remove();
                }
            }            
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            var chkMulti = $.map($(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:not([disabled]):checked`), function(el, i) {
                return $(el).val();
            });
            $(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:not([disabled]):checked`).each(function(index) {
                $(this).parents('label').find('.hulk_unique_sku').removeAttr('disabled');
            });
            $(`.${hulk_parent_div}`).find(`#hulkapps_option_${cid}_hidden`).val(chkMulti.join(',  '));
            var chkMultiinventory = $.map($(`.${hulk_parent_div}`).find(`.hulkapps_option_${cid}_visible:not([disabled]):checked`), function(
                el, i) {
                if ($(el).data('hinventory') != '') {
                    return $(el).val() + '_hin_' + $(el).data('hinventory')
                };
            });
            if ($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length > 0) {
                $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val(chkMultiinventory.join(', '));
                if(single_valid_class == 'multiswatch_render') {
                    $(this).parents('.hulkapps_option_value').find('.swatch_checkbox:disabled').parent('.hulkapps_option_child').removeClass('swatch_selected');
                }
            };
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${cid}`, single_valid_class, hulk_parent_div);
        });
        // end swatch multiple / checkbox js

        // start swatch multiple checkbox js
        // $(document).on('change', '.hulk_po_swatch_multiple_checkbox', function(e) {
        //     $(this).is(':checked') ? $(this).parent().addClass('swatch_selected') : $(this).parent().removeClass('swatch_selected');
        //     $(this).parents('.multiswatch_render').find('.inventory_error').html('')
        // });
        // End swatch multiple checkbox js

        // Start Radio Button
        $(document).on('change click', '.hulk_po_radiobutton', function() {
            var rid = $(this).attr('data-oid');
            var rdiv_id = $(this).attr('id')
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            if ($(this).is(":checked")) {
                $(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').show();
                $(this).parents('.rb_render').find('.hulk_unique_sku').prop('disabled', true);
                var opt_qty = '';
                if ($(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val()) {
                    opt_qty = ` | ${$(this).parents('.hulkapps_option_value').find('.hulk_options_quantity').val()}`
                };
                if ($(this).parents('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').length > 0) {
                    if ($(this).data('hinventory')) {
                        $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).val()}_hin_${$(this).data('hinventory')}${opt_qty}`);
                    } else {
                        $(this).parents('.hulkapps_option_value').find('.hulk_unique_prop').val('')
                    }
                };
                $(this).parents('.hulkapps_option_value').find('.hulk_radiobutton_hidden_prop').val($(this).val() + opt_qty);

                if($(this).parent().attr('class') == "switches-container" || $(this).parent('.hulkapps_option_value').find('.switches-container').length > 1){
                    $(this).siblings().find('.radio_selected').removeClass('radio_selected');
                    $(`#radio_div_${rdiv_id}`).addClass('radio_selected')
                }else{
                    $(this).parent().siblings().find('.radio_div').removeClass('radio_selected');
                    $(this).parent().find('.radio_div').addClass('radio_selected');
                }
                $(this).parents('label').find('.hulk_unique_sku').prop('disabled', false);
                changeImage(this);
            }
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${rid}`, 'rb_render', hulk_parent_div);
            
        });
        $(document).on('change', '.hulk_po_radiobutton_quanity', function() {
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            var is_switch_toggle = false

            const $container = $(this).parent('.hulkapps_option_value');
            const isNewDesign = $container.find('input[type="radio"].no-radio-style').length > 0;

            if($(this).parent('.hulkapps_option_value').find('.switches-container').length > 0){ 
                is_switch_toggle = true
            }
            if(is_switch_toggle){
                rid = $(this).parent('.hulkapps_option_value').find('.radio_selected').attr('id').split('radio_div_')[1];
                $(this).parent('.hulkapps_option_value').find('.hulk_radiobutton_hidden_prop').val(`${$(`#${rid}`).val()} | ${$(this).val()}`);
            }else{
                if (isNewDesign) {
                    // Classic radio buttons
                    $container.find('.hulk_radiobutton_hidden_prop').val(
                        `${$container.find('input[type="radio"]:checked').val()} | ${$(this).val()}`
                    );
                } else {
                    // Button style radio buttons
                    $container.find('.hulk_radiobutton_hidden_prop').val(
                        `${$container
                        .find('.radio_selected')
                        .parent('.hulkapps_radio_option')
                        .find('.hulkapps_option_child')
                        .val()} | ${$(this).val()}`
                    );
                }
            }
            if ($(this).parent('.hulkapps_option_value').find('.hulk_unique_prop') && $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').length > 0 && $(this).parent('.hulkapps_option_value').find('.radio_selected').parent('.hulkapps_radio_option').find('.hulkapps_option_child').data('hinventory')) {
                $(this).parent('.hulkapps_option_value').find('.hulk_unique_prop').val(`${$(this).parent('.hulkapps_option_value').find('.radio_selected').parent('.hulkapps_radio_option').find('.hulkapps_option_child').val()}_hin_${$(this).parent('.hulkapps_option_value').find('.radio_selected').parent('.hulkapps_radio_option').find('.hulkapps_option_child').data('hinventory')} | ${$(this).val()}`)
            }
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
        });
        // End Radio Button

        //Start Textbox & textarea & email & datepicker & numberfield js
        $(document).on('change input', '.hulk_po_other_options', function() {
            var tid = $(this).attr('id');
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            var single_valid_class = $(this).attr('data-single_valid-class');
            var val_selected_class = $(this).attr('data-val-selected-class');
            var is_char_charge = $(this).attr('data-is-charge');
            var price = $(this).data('price');
            if(is_char_charge == 'character_charge'){
                var char_charge = $(this).attr('data-is-charge');
                var main_price = $(this).attr('data-main-price');
                
                var char_count = $.trim($(this).val()).replace(/\s+/g, '').length;
                
                price = parseFloat(main_price) * char_count;
                $(this).attr('data-price', price);
            }
            var tb_val = $(this).val();
            if (tb_val != '') {
                if (price != '0.00') {
                    var res = `${tb_val} [ ${window.hulk_po_currency_symbol}${price} ]`;
                } else {
                    var res = tb_val
                }
                $(this).parent().find('.other_options_prop_val').val(res);
                $(this).addClass(val_selected_class);

            } else {
                $(this).parent().find('.other_options_prop_val').val('');
                $(this).removeClass(val_selected_class);
            }
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${tid}`, single_valid_class, hulk_parent_div);
        });
        //End Textbox & textarea & email & datepicker & numberfield  js

        // Start Formula based options
        $(document).on('change', '.po_changed_formula', function() {
            var po_final_price = ""
            var final_prop = ""
            var hulk_parent_div = $(this).parents(".fm_option_val").attr('data-parent');
            var hulk_pid = $(this).parents(".fm_option_val").attr('data-pid');
            var min_selection = 0;
            var max_selection = 0;
            var opt_name = $(this).attr('data-name')
            if($(this).attr('min')){
                min_selection = parseInt($(this).attr('min'));
            }
            if($(this).attr('max')){
                max_selection = parseInt($(this).attr('max'));
            }
            var is_validated = true;
            $(this).parent('.hulkapps_option_value').find(".error_span").remove();
            if ((min_selection!= 0) && (max_selection != 0)) {
                if(parseFloat($(this).val()) < min_selection || parseFloat($(this).val()) > max_selection){
                    $(this).parent('.hulkapps_option_value').append(`<span class='validation_error error_span' tabindex='0' aria-label='${buildValidationMessage(window.min_max_formula_validation_message, {min: min_selection,max: max_selection})} for option ${opt_name}'>  ${buildValidationMessage(window.min_max_formula_validation_message, {min: min_selection,max: max_selection})} </span>`);
                    is_validated = false;
                } else {
                    $(this).parent('.hulkapps_option_value').find(".error_span").remove();
                    is_validated = true;
                }
            } else if (min_selection != 0 ) {
                if (parseFloat($(this).val()) < min_selection) {
                    $(this).parent('.hulkapps_option_value').append(`<span class='validation_error error_span' tabindex='0' aria-label='${buildValidationMessage(window.min_only_formula_validation_message, { min: min_selection })} for option ${opt_name}'>  ${buildValidationMessage(window.min_only_formula_validation_message, { min: min_selection })} </span>`);
                    is_validated = false;
                } else {
                    $(this).parent('.hulkapps_option_value').find(".error_span").remove();
                    is_validated = true;
                }
            } else if (max_selection != 0 ) {
                if (parseFloat($(this).val()) > max_selection) {
                    $(this).parent('.hulkapps_option_value').append(`<span class='validation_error error_span' tabindex='0' aria-label='${buildValidationMessage(window.max_only_formula_validation_message, { max: max_selection })} for option ${opt_name}'> ${buildValidationMessage(window.max_only_formula_validation_message, { max: max_selection })} </span>`);
                    is_validated = false;
                } else {
                    $(this).parent('.hulkapps_option_value').find(".error_span").remove();
                    is_validated = true;
                }
            }
            var error_span_length = $(this).parents(".fm_option_val").find(".error_span").length
            if(is_validated &&  error_span_length == 0){
                $(this).parents(".fm_option_val").find('.po_changed_formula').each(function() {
                    po_final_price +=  (parseFloat($(this).val()) + $(this).attr('data-arithmatic'));
                    final_prop += `${$(this).attr('data-name')}:${$(this).val()} | `
                });
                po_final_price = po_final_price.slice(0, -1);
                final_prop = final_prop.slice(0, -1);
                po_final_price = (eval(po_final_price)).toFixed(2)
                $(this).parents(".fm_option_val").removeClass("validation_error");
                $(this).parents(".fm_render").find(".error_span").remove();
                if(!isNaN(po_final_price)){
                    if(po_final_price <= 0 || po_final_price == "Infinity" || parseFloat($(this).val()) <= 0 ){
                        if(parseFloat($(this).val()) <= 0) {
                            $(this).val('');
                        }
                        $(this).parents(".fm_option_val").addClass("validation_error");
                        $(this).parents(".fm_render").append(`<span class='validation_error error_span' tabindex='0' aria-label='Please change your value(s)'> Please change your value(s). </span>`)
                        $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").removeClass("formula_selected");
                        $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").val("");
                        $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").attr('data-price','')
                        calc_options_total(parseInt(hulk_pid), hulk_parent_div);

                    }else{
                        $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").val(`${final_prop}[${po_final_price}]`);
                        $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").attr('data-price',po_final_price)
                        $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").addClass("formula_selected");
                        calc_options_total(parseInt(hulk_pid), hulk_parent_div);

                    }
                }else{
                    if(parseFloat($(this).val()) <= 0) {
                        $(this).val('');
                    }
                    $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").removeClass("formula_selected");
                    $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").val("");
                    $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").attr('data-price','')
                    calc_options_total(parseInt(hulk_pid), hulk_parent_div);

                }

            }else{
                if(parseFloat($(this).val()) <= 0) {
                    $(this).val('');
                }
                $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").removeClass("formula_selected");
                $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").val("");
                $(this).parents(".fm_option_val").find(".hulk_formula_hidden_prop").attr('data-price','')
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);

        });

        // End formula based options
        $(document).on('change','.stg_render input[type="text"]',function(){
            opt_val =  $(this).parents(".stg_render").find("input[type='text']").map(function() { if($(this).val() != ''){ return $(this).attr('data-key-name') + " : " + $(this).val();}}).get().join(' | ');
            var hulk_pid = $(this).parents('.stg_render').find('.stg_hidden').attr('data-pid');
            var rid = $(this).parents('.stg_render').find('.stg_hidden').attr('data-oid');
            var hulk_parent_div = $(this).attr('data-parent');
            var single_valid_class = $(this).attr('data-single_valid-class');
            var val_selected_class = $(this).attr('data-val-selected-class');
            if(opt_val != ''){
                opt_price = $(this).parents('.stg_render').find('.stg_hidden').data('price');
                opt_currency = window.hulk_po_currency_symbol
                if(opt_price != '0:00'){
                    var price =  opt_val + ' [ '  + opt_currency + ' ' + opt_price + ' ]'
                    $(this).parents('.stg_render').find('.stg_property_val').val(price)
                    $(this).parents('.stg_render').find('.stg_hidden').addClass(val_selected_class)

                }else{
                    var price =  opt_val
                    $(this).parents('.stg_render').find('.stg_property_val').val(price);
                    $(this).parents('.stg_render').find('.stg_hidden').addClass(val_selected_class)
                }
            }else{
                $(this).parents('.stg_render').find('.stg_property_val').val('');
                $(this).parents('.stg_render').find('.stg_hidden').removeClass(val_selected_class)
            }
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${rid}`, single_valid_class, hulk_parent_div);


        });

      

        

        hulkapps_jQuery(document).on("blur", ".hulkapps_option_value [type='time']", function(e) {
            var tid = $(this).attr('id');
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            var single_valid_class = $(this).attr('data-single_valid-class');
            var val_selected_class = $(this).attr('data-val-selected-class');
            var price = $(this).data('price');
            var selectedTime = hulkapps_jQuery(this).val();
            // Define the disabled time range (e.g., from 13:00 to 14:30)
            var disabledStartTime = hulkapps_jQuery(this).attr('min'); // Change start time
            var disabledEndTime = hulkapps_jQuery(this).attr('max'); // Change end time

            // Disable times within the range
            var selectedTimeObj = new Date('1970-01-01T' + selectedTime + ':00');
            if(disabledStartTime != ""){
            var minTimeObj = new Date('1970-01-01T' + disabledStartTime + ':00');
            }
            if(disabledEndTime != ""){
            var maxTimeObj = new Date('1970-01-01T' + disabledEndTime + ':00');
            }
            if(selectedTime != ""){
            if (selectedTimeObj < minTimeObj || selectedTimeObj > maxTimeObj) {
                hulkapps_jQuery(this).val('');
                var errMsg = '';
                $(this).parent().find('.other_options_prop_val').val('');
                $(this).removeClass(val_selected_class);
                if (minTimeObj && maxTimeObj) {
                errMsg = "Please select a time between " + minTimeObj.toLocaleTimeString([], { timeStyle: "short" }) + " and " + maxTimeObj.toLocaleTimeString([], { timeStyle: "short" }) + ".";
                } else if (minTimeObj) {
                errMsg = "Please select a time from " + minTimeObj.toLocaleTimeString([], { timeStyle: "short" }) + ".";
                } else {
                errMsg = "Please select a time earlier than " + maxTimeObj.toLocaleTimeString([], { timeStyle: "short" }) + ".";
                }
                hulkapps_jQuery(this).parent('.hulkapps_option_value').append("<span class='validation_error error_span' tabindex='0' aria-label='" + errMsg + "'>" + errMsg + "</span>");
                var this_attr = hulkapps_jQuery(this);
                setTimeout(function() {
                this_attr.parent('.hulkapps_option_value').find('.validation_error').remove();
                }, 3000);
            }else{
                if (price != '0.00') {
                var res = `${selectedTime} [ ${window.hulk_po_currency_symbol}${price} ]`;
                } else {
                    var res = selectedTime
                }
                $(this).parent().find('.other_options_prop_val').val(res);
                $(this).addClass(val_selected_class);
            }
            }else{
            $(this).parent().find('.other_options_prop_val').val('');
            $(this).removeClass(val_selected_class);
            }
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${tid}`, single_valid_class, hulk_parent_div);
            
        });


        hulkapps_jQuery(document).on("blur", ".hulkapps_option_value [type='date']", function(e) {
            var tid = $(this).attr('id');
            var hulk_parent_div = $(this).attr('data-parent');
            var hulk_pid = $(this).attr('data-pid');
            var single_valid_class = $(this).attr('data-single_valid-class');
            var val_selected_class = $(this).attr('data-val-selected-class');
            var price = $(this).data('price');
            var selectedDate = hulkapps_jQuery(this).val();
            // Define the disabled time range (e.g., from 13:00 to 14:30)
            var disabledStartDate = hulkapps_jQuery(this).attr('min'); // Change start time
            var disabledEndDate = hulkapps_jQuery(this).attr('max'); // Change end time
            // Disable times within the range
            var selectedDateObj = new Date(selectedDate);
            if(disabledStartDate != ""){
            var minDateObj = new Date(disabledStartDate).toISOString().split('T')[0];
            minDateObj = new Date(minDateObj);
            }
            if(disabledEndDate != ""){
            var maxDateObj = new Date(disabledEndDate).toISOString().split('T')[0];
            maxDateObj = new Date(disabledEndDate);
            }
            if(selectedDate != ""){
            if (selectedDateObj < minDateObj || selectedDateObj > maxDateObj) {
                hulkapps_jQuery(this).val('');
                var errMsg = '';
                $(this).parent().find('.other_options_prop_val').val('');
                $(this).removeClass(val_selected_class);
                if (minDateObj && maxDateObj) {
                errMsg = "Please select a date between " + minDateObj.toISOString().split('T')[0] + " and " + maxDateObj.toISOString().split('T')[0] + ".";
                } else if (minDateObj) {
                errMsg = "Please select a time from " + minDateObj.toISOString().split('T')[0] + ".";
                } else {
                errMsg = "Please select a time earlier than " + maxDateObj.toISOString().split('T')[0] + ".";
                }
                hulkapps_jQuery(this).parent('.hulkapps_option_value').append("<span class='validation_error error_span' tabindex='0' aria-label='" + errMsg + "'>" + errMsg + "</span>");
                var this_attr = hulkapps_jQuery(this);
                setTimeout(function() {
                this_attr.parent('.hulkapps_option_value').find('.validation_error').remove();
                }, 3000);
            }else{
                if (price != '0.00') {
                var res = `${selectedDate} [ ${window.hulk_po_currency_symbol}${price} ]`;
                } else {
                    var res = selectedDate
                }
                $(this).parent().find('.other_options_prop_val').val(res);
                $(this).addClass(val_selected_class);
            }
            }else{
            $(this).parent().find('.other_options_prop_val').val('');
            $(this).removeClass(val_selected_class);
            }
            conditional_rules(parseInt(hulk_pid), hulk_parent_div);
            if ($('#hulk_amount_dis').val() == '1') {
                calc_options_total(parseInt(hulk_pid), hulk_parent_div);
            }
            validate_single_option(`option_type_id_${tid}`, single_valid_class, hulk_parent_div);
            
        });

         $( document ).on( "click", ".hulkapps_product_discount_button", function( e ) {
            $(".hulkapps_product_discount_button").attr("disabled","disabled");
            $(".hulkapps_product_discount_button").addClass("hulkapps_product_discount_disabled_button");

            // e.stopPropagation();
            // e.preventDefault();
            // e.stopImmediatePropagation();
            new Promise((resolve, reject) => {
                var is_good = validate_options(window.hulkapps.product_id, "hulkapps_product_options")
                resolve(is_good)
            }).then(function (is_good) {
                if (is_good) {

                    var draft_order_language = Shopify.locale

                    var cart_collections = {}
                    cart_collections[window.hulkapps.product.selected_variant] = window.hulkapps.product_collection

                    $.ajax({
                        type: "POST",
                        url: window.hulkapps.po_url + "/store/get_cart_details",
                        data: {
                            cart_data: window.hulk_cjson,
                            store_id: window.hulkapps.store_id,
                            cart_collections: JSON.stringify(cart_collections),
                            customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',
                            draft_order_language: draft_order_language != undefined ? draft_order_language : "",
                            discount_code: $("input[name=checkout_discount]").val() ,
                        },
                        crossDomain: true,
                        success: function (data) {
                            var discounts = data.discounts
                            var discounted_price = parseFloat(discounts.discount_cut_price);
                            if (discounts.discount_code && discounts.discount_error == 1) {
                                hulkapps_jQuery(".hulkapps_summary_product").remove();
                                $(".discount_code_box_product .hulkapps_discount_hide").after("<span class='hulkapps_summary_product'>Discount code does not match</span>");
                                $(".hulkapps-summary-product-line-discount-code").html("");
                                $(".product_after_discount_price").html("");
                            } else if (discounts.is_free_shipping) {
                                $(".hulkapps_summary_product").remove();
                                $(".hulkapps-summary-product-line-discount-code").html("");
                                $(".product_after_discount_price").html("");
                                $(".discount_code_box_product .hulkapps_discount_hide").after("<span class='hulkapps-summary-product-line-discount-code'><span class='discount-tag'>" + discounts.discount_code + "<span class='product-close-tag close-tag'></span></span>Free Shipping");

                            } else if (discounts.discount_code && discounted_price <= 0) {
                                $(".discount_code_box_product .hulkapps_discount_hide").after("<span class='hulkapps_summary_product'>" + discounts.discount_code + " discount code isn’t valid for the items in your cart</span>");
                                $(".hulkapps_discount_code").val("")
                                $(".hulkapps-summary-product-line-discount-code").html("");
                                $(".product_after_discount_price").html("");
                            } else if (discounts.discount_code) {
                                $(".discount_code_box_product").find(".hulkapps_summary_product").html("");
                                $(".hulkapps-summary-product-line-discount-code,.product_after_discount_price").remove();
                                $(".discount_code_box_product .hulkapps_discount_hide").after("<span class='hulkapps-summary-product-line-discount-code'><span class='discount-tag'>" + discounts.discount_code + "<span class='product-close-tag close-tag'></span></span><span class='hulkapps_with_discount'>" + " -" + discounts.with_discount + "</span></span><span class='product_after_discount_price'><span class='final-total'>Total</span>" + discounts.final_with_discounted_price + "</span>");
                                $(".hulkapps-cart-total").remove();
                            } else {
                                $(".hulkapps-summary-product-line-discount-code").html("");
                                $(".product_after_discount_price").html("");
                                $(".discount_code_box_product").find(".hulkapps_summary_product").html("");

                            }
                            $(".hulkapps_product_discount_button").removeAttr("disabled");
                            $(".hulkapps_product_discount_button").removeClass("hulkapps_product_discount_disabled_button");
                            
                        }
                    });

                }
            }).catch(function (error) {

            })
        });

        $( document ).on( "click", ".hulkapps_product_discount_modal .modal_close_btn", function( e ) {
            $(".hulkapps_product_discount_modal").hide();
        });
       
        // window.shopify_payment_buttons = function () {
        var hulk_flag = 0;
        $( document ).on( "click", ".hulk-buy_now,#hulkapps_buy_now_continue", function( e ) {
            var this_attr = $(this);
            var hulkapps_buy_now_continue = $(this).attr("data-hulk-btn-type")
            // $("div").delegate(".shopify-payment-button__button", "click", function (e) {
            e.cancelBubble = true;
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            new Promise((resolve, reject) => {
                var is_good = validate_options(window.hulkapps.product_id, "hulkapps_product_options")
                resolve(is_good)
            }).then(function (is_good) {
                if (is_good) {
                    var hulkapps_parents = "hulkapps_product_options"
                    var i;
                    var total = 0;
                    var is_variant_id_present = false
                    var format = window.hulkapps.money_format;
                    var checked_variant = $("." + hulkapps_parents + " #hulkapps_option_list_" + window.hulkapps.product_id + ":visible .price-change:checked, ." + hulkapps_parents + " #hulkapps_option_list_" + window.hulkapps.product_id + ":visible .price-change:selected, ." + hulkapps_parents + " .hulkapps_swatch_option .swatch_selected,." + hulkapps_parents + " .textarea_selected,." + hulkapps_parents + " .textbox_selected,." + hulkapps_parents + " .emailbox_selected,." + hulkapps_parents + " .datepicker_selected,." + hulkapps_parents + " .numberfield_selected,." + hulkapps_parents + " .colorpicker_selected,." + hulkapps_parents + " .button_selected,." + hulkapps_parents + " .googlefont_selected, ." + hulkapps_parents + " .ci_render .hulkapps_option_value .hulkapps_option_child .dropdown_selected, ."+hulkapps_parents+" .formula_selected,."+hulkapps_parents+" .stg_selected,."+hulkapps_parents+" .stg_selected, ."+hulkapps_parents+" .mqty_selected");
                    for (i = 0; i < checked_variant.length; i++) {
                        if (!$(checked_variant[i]).parents(".hulkapps_option").hasClass('conditional')) {
                            total = Number($(checked_variant[i]).attr("data-price")) + Number(total);
                            var checkedVariantId = $(checked_variant[i]).attr("data-variant-id");
                            if (checkedVariantId !== undefined && checkedVariantId !== null && checkedVariantId !== "null") {
                                is_variant_id_present = true;
                            }
                        }
                    }

                    if ((total > 0 || (total <= 0 && (is_variant_id_present || $('.file-upload.hulk-active').length > 0))) && (hulk_flag == 0 && (this_attr.attr("data-testid") == "Checkout-button" || this_attr.attr("data-testid") == "ShopifyPay-button" || this_attr.attr("data-testid") == "payment-button"))){
                        $('.shopify-payment-button').css({'pointer-events': 'none'});
                        if(!window.is_checkout_api){
                            if (window.is_product_page_doscount_code && hulkapps_buy_now_continue != "hulkapps_buy_now_continue" && $(".product-hulkapps-discount-code-html").length > 0) {
                                var data_btn_type = ""
                                var checkoutElement = document.querySelector('shopify-accelerated-checkout');
                                var recommendedName = '';
                                if (checkoutElement) {
                                    try {
                                        const recommended = checkoutElement.getAttribute('recommended');
                                        recommendedName = recommended ? JSON.parse(recommended).name || '' : '';
                                    } catch(e) {
                                        recommendedName = '';
                                    }
                                }
                                if ($('.shopify-payment-button').html().includes("ShopifyPay-button") || recommendedName == 'shop_pay') {
                                    data_btn_type = 'ShopifyPay-button'
                                }else if($('.shopify-payment-button').html().includes("payment-button")){
                                    data_btn_type = 'payment-button'
                                }else {
                                    data_btn_type = 'Checkout-button'
                                }
                                $(".product-hulkapps-discount-code-html").html('<div class="hulkapps_product_discount_modal"><div class="product_discount_modal_wrapper"><span class="modal_close_btn"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2361_7248)"><path d="M1.23998 24.0001C0.923838 24.0001 0.607699 23.8798 0.367506 23.6378C-0.114689 23.1556 -0.114689 22.3739 0.367506 21.8917L21.8975 0.361646C22.3797 -0.120549 23.1615 -0.120549 23.6437 0.361646C24.1259 0.843841 24.1259 1.6256 23.6437 2.1081L2.11396 23.6378C1.87195 23.8783 1.55582 24.0001 1.23998 24.0001Z" fill="#AAAAAA"/><path d="M22.7715 24.0001C22.4554 24.0001 22.1395 23.8798 21.899 23.6378L0.367506 2.1081C-0.114689 1.6256 -0.114689 0.843841 0.367506 0.361646C0.849701 -0.120549 1.63146 -0.120549 2.11396 0.361646L23.6437 21.8917C24.1259 22.3739 24.1259 23.1556 23.6437 23.6378C23.4017 23.8783 23.0858 24.0001 22.7715 24.0001Z" fill="#AAAAAA"/></g><defs><clipPath id="clip0_2361_7248"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></span><div class="product_discount_modal_body"><div id="hulkapps_discount_code"><div class="discount_code_box_product"><div class="hulkapps_discount_hide"><input placeholder="Discount code" class="hulkapps_discount_code" autocomplete="off" aria-required="true" size="30" type="text" name="checkout_discount"><button type="button" class="btn btn--primary btn-primary button hulkapps_product_discount_button hulkapps_product_discount_disabled_button" disabled >Apply</button></div></div></div><p class="hulkapps_discount_notetxt"><b>Note:</b> Proceed with Checkout button if no discount code available.</p></div><div class="product_discount_modal_footer"><button id="" class="btn btn-secondary button button--secondary modal_close_btn" type="button"  >Cancel</button><button id="hulkapps_buy_now_continue" class="btn btn--secondary btn-primary button button--primary" type="button" data-testid="' + data_btn_type + '" data-hulk-btn-type="hulkapps_buy_now_continue">Checkout</button></div></div></div>')
                            }
                        }
                        var hulk_properties = {}
                        var hulk_btn_type = this_attr.attr("data-testid")
                        var is_file = false
                        var file_props_name = []
                        $("[name^='properties']").each(function () {
                            if ($(this).val() == '') {
                                $(this).remove();
                            }
                            var name;
                            if (this.type == "radio") {
                                if (this.checked) {
                                    name = this.name.replace('properties[', '').replace(']', '');
                                    if ($.trim(this.value).length > 0) {
                                        hulk_properties[name] = this.value;
                                    }
                                }
                            } else if (this.type == "file") {
                                name = this.name.replace('properties[', '').replace(']', '');
                                if ($.trim(this.value).length > 0) {
                                    hulk_properties[name] = this.value;
                                    is_file = true
                                    file_props_name.push(name)

                                }

                            } else {
                                name = this.name.replace('properties[', '').replace(']', '');
                                if ($.trim(this.value).length > 0) {
                                    hulk_properties[name] = this.value;
                                }
                            }
                        });
                        new Promise((resolve, reject) => {
                            if(is_file && file_props_name.length > 0){
                                var hulk_add_to_cart_ele = null;
                                var product_form_id = null;
                                var selectors = ["input[name='add']", "button[name='add']", "#add-to-cart", "#AddToCartText", "#AddToCart",'form[action$="/cart/add"] input[type="submit"]'];
                                    var found_selectors = 0;
                                    selectors.forEach(function (selector) {
                                        var elements = document.querySelectorAll(selector);
                                        found_selectors += elements.length;

                                        if (hulk_add_to_cart_ele === null && elements.length > 0) {
                                            hulk_add_to_cart_ele = elements[0];
                                        }
                                    });

                                    if (hulk_add_to_cart_ele) {
                                        var product_form_id = hulk_add_to_cart_ele.closest("form").getAttribute('id');
                                    }
                                    if(product_form_id){
                                        var formData = new FormData($(`#${product_form_id}`)[0]); // For file upload use this formate
                                        $.ajax({
                                            type: 'POST',
                                            url: '/cart/add.js',
                                            data: formData,
                                            dataType: 'json',
                                            contentType: false,
                                            processData: false,
                                            success: function (cart_item) {
                                                if(file_props_name.length > 0){
                                                    file_props_name.forEach(function (value) {
                                                        hulk_properties[value] = cart_item.properties[value]
                                                    });
                                                    resolve(hulk_properties);
                                                }else{
                                                    resolve(hulk_properties);
                                                }
                                                let item_key = cart_item.key
                                                $.ajax({
                                                    type: 'POST',
                                                    url: '/cart/change.js',
                                                    data: {
                                                        quantity: 0,
                                                        id: item_key
                                                    },
                                                    dataType: 'json',
                                                    success: function(cart) {
                                                    },
                                                    error: function(xhr, textStatus, errorThrown) {
                                                    }
                                                });
                                            }
                                        });
                                    }else{
                                        resolve(hulk_properties);
                                    }
                            }else{
                                resolve(hulk_properties);
                            }

                        }).then(function (hulk_properties) {
                            var draft_order_language = Shopify.locale

                            var cart_collections = {}
                            cart_collections[window.hulkapps.product.selected_variant] = window.hulkapps.product_collection
                            window.hulk_cjson = {}
                            let items = []
                            var hulk_product_price = window.hulkapps.product.price
                            if(window.hulkapps.product.selected_variant_price){
                                hulk_product_price = window.hulkapps.product.selected_variant_price
                            }
                            var pqty = 1
                            if($("input[name=quantity]").val()){
                                pqty = parseInt($("input[name=quantity]").val())
                            }
                            items.push({
                                "product_id": window.hulkapps.product.id,
                                "price": hulk_product_price,
                                "line_price": hulk_product_price * pqty,
                                "tags": window.hulkapps.product.tags,
                                "variant_id": window.hulkapps.product.selected_variant,
                                "quantity": pqty,
                                "vendor": window.hulkapps.product.vendor,
                                "product_type": window.hulkapps.product.type,
                                "properties": hulk_properties,
                                "title": window.hulkapps.product.title
                            })
                            hulk_cjson["cart"] = {
                                "items": items,
                                "original_total_price": window.hulkapps.product.price * pqty,
                                item_count: pqty,
                                discounted_price: window.hulkapps.product.price * pqty,
                    
                            }
                            hulk_cjson["money_format"] = window.hulkapps.money_format
                            if (!window.is_product_page_doscount_code || (window.is_product_page_doscount_code && hulkapps_buy_now_continue == "hulkapps_buy_now_continue" ) || window.is_checkout_api) {
                                const checkout_draft_data = {
                                    cart_json: hulk_cjson,
                                    store_id: window.hulkapps.store_id,
                                    cart_collections: JSON.stringify(cart_collections),
                                    customer_tags: window.hulkapps.customer != null ? window.hulkapps.customer.tags.split(",") : '',
                                    draft_order_language: draft_order_language != undefined ? draft_order_language : "",
                                    discount_code: $(".discount_code_box_product .hulkapps_discount_code").val(),
                                    hulk_btn_type: hulk_btn_type,
                                    default_address: window.hulkapps.customer != null && window.hulkapps.customer.default_address != null  ? window.hulkapps.customer.default_address : '',
                                    currency_rate: window.hulkapps_shopify_rate

                                }
                                if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
                                    checkout_draft_data.currency_code = window.Shopify.currency.active;
                                }
                                if (window.Shopify && window.Shopify.country) {
                                    checkout_draft_data.buyer_country_code = window.Shopify.country;
                                }
                                $.ajax({
                                    type: "POST",
                                    url: window.hulkapps.po_url + "/store/create_draft_order",
                                    data: checkout_draft_data,
                                    crossDomain: true,
                                    success: function (res) {

                                        if (typeof res == "string") {
                                            window.location.href = res


                                        } else {
                                            if (hulk_btn_type == "ShopifyPay-button") {
                                                window.location.href = "/checkout?payment=shop_pay"


                                            } else {
                                                window.location.href = "/checkout"
                                            }
                                        }
                                        localStorage.removeItem('discount_code');
                                    }
                                });
                            }
                        }).catch(function (error) {
                            console.log("error",error)
                        })
                    } else {
                        $('.shopify-payment-button__button, .shopify-payment-button__more-options').first().trigger('click');
                    }
                }
            }).catch(function (error) {

            })
        });
        var hulk_flag = 0;
        $(document).on("click", ".hulkapps_submit_cart", function (e) {
            if (hulk_flag == 0) {
                e.preventDefault();
                new Promise((resolve, reject) => {
                    var is_good = validate_options(window.hulkapps.product_id,"hulkapps_product_options")
                    resolve(is_good)
                }).then(function (is_good) {
                    if (is_good) {
                        $("[name^='properties']").each(function () {

                            if ($(this).val() == '' || ($(this).hasClass("hf_property_val") && $(this).hasClass("conditional"))) {
                                $(this).attr('disabled', true);
                            }
                        });
                        hulk_flag = 1;
                        $('.hulkapps_submit_cart').click();
                        if (hulk_flag == 1) {
                            $("[name^='properties']").each(function () {
                                if ($(this).val() == '' || ($(this).hasClass("hf_property_val") && $(this).hasClass("conditional"))) {
                                    $(this).attr('disabled', false);
                                }
                            });
                            if(window.hulk_multi_qty_selector) {
                                setTimeout(function() {
                                    window.hulkUpdateStockStatus($);
                                }, 700); // 300000 milliseconds = 5 minutes
                            }
                            hulk_flag = 0;
                        }
                    }
                }).catch(function (error) {
                    hulk_flag = 1;
                    $('.hulkapps_submit_cart').click();
                    if (hulk_flag == 1) {
                        $("[name^='properties']").each(function () {
                            if ($(this).val() == '' || ($(this).hasClass("hf_property_val") && $(this).hasClass("conditional"))) {
                                $(this).attr('disabled', false);
                            }

                        });
                        hulk_flag = 0;
                    }
                })

            }
        });
    }
// }

// });
    if (typeof window.hulkapps !== 'undefined') {
        if ((typeof (jQuery) == 'undefined') || (parseInt(jQuery.fn.jquery) == 3 && parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 2.1)) {
            hulkLoadScript('//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js', function () {
                hulkapps_jQuery = jQuery.noConflict(true);
                checkAppInstalled(hulkapps_jQuery);
            });
        } else {
            hulkapps_jQuery = jQuery
            checkAppInstalled(hulkapps_jQuery);
        }
        if (!window.flatpickr) {
            hulkLoadStyle('https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css');
            hulkLoadScript('https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.js', function(){});
        }
    }
}
